/**
 * 废钢直通车 - Mock 数据
 * 统一数据结构，符合订单-送货单模型
 */

import { ORDER_STATUS, DELIVERY_STATUS } from '../constants/status';

// ============ 基础数据 ============

export const baseData = [
  { id: 'B001', name: '马钢诚兴台州基地', address: '浙江省台州市路桥区...路88号', contact: '张三', phone: '13800138001', cbsStatus: '已映射 (CBS-TZ-01)', platformStatus: '运营中', createdAt: '2025-01-15 09:30', updatedAt: '2026-02-20 14:25', operator: '管理员' },
  { id: 'B002', name: '马钢诚兴上海分公司', address: '上海市宝山区...路12号', contact: '李四', phone: '13800138002', cbsStatus: '未映射', platformStatus: '运营中', createdAt: '2025-02-10 10:15', updatedAt: '2026-01-18 16:30', operator: '管理员' },
  { id: 'B003', name: '马钢诚兴杭州湾基地', address: '浙江省宁波市杭州湾新区...路66号', contact: '赵六', phone: '13800138003', cbsStatus: '已映射 (CBS-NB-02)', platformStatus: '运营中', createdAt: '2025-03-05 08:45', updatedAt: '2026-02-28 11:00', operator: '管理员' },
  { id: 'B004', name: '马钢诚兴南京分公司', address: '江苏省南京市江宁区...路100号', contact: '孙七', phone: '13800138004', cbsStatus: '已映射 (CBS-NJ-03)', platformStatus: '已停运', createdAt: '2025-03-20 14:00', updatedAt: '2026-01-10 09:15', operator: '管理员' },
  { id: 'B005', name: '马钢诚兴无锡基地', address: '江苏省无锡市惠山区...路55号', contact: '吴九', phone: '13800138005', cbsStatus: '已映射 (CBS-WX-04)', platformStatus: '运营中', createdAt: '2025-04-01 11:30', updatedAt: '2026-02-15 15:45', operator: '管理员' },
];

export const initialMaterialsData = [
  { id: 'M001', name: '工业重废毛料', standard: '厚度≥6mm，无密封容器...', category: '重废', cbsCode: 'M-CBS-101', unit: '吨', baseIds: ['B001'], createdAt: '2025-01-20 10:00', updatedAt: '2026-02-15 14:30', operator: '管理员' },
  { id: 'M002', name: '特级破碎料', standard: '堆比重≥1.2t/m³，杂质含量≤1%...', category: '破碎料', cbsCode: 'M-CBS-102', unit: '吨', baseIds: ['B001', 'B002'], createdAt: '2025-02-05 11:30', updatedAt: '2026-01-20 09:45', operator: '管理员' },
  { id: 'M003', name: '统料废钢', standard: '无重度锈蚀，无密封容器...', category: '统料', cbsCode: 'M-CBS-103', unit: '吨', baseIds: ['B002'], createdAt: '2025-02-18 15:00', updatedAt: '2026-02-28 16:20', operator: '管理员' },
  { id: 'M004', name: '轻薄料', standard: '厚度<3mm，无油污...', category: '轻薄料', cbsCode: 'M-CBS-104', unit: '吨', baseIds: ['B001', 'B003'], createdAt: '2025-03-10 08:45', updatedAt: '2026-02-10 11:15', operator: '管理员' },
  { id: 'M005', name: '钢筋头', standard: '长度≤1m，无混凝土...', category: '重废', cbsCode: 'M-CBS-105', unit: '吨', baseIds: ['B002', 'B004'], createdAt: '2025-03-25 13:20', updatedAt: '2026-01-05 10:00', operator: '管理员' },
];

export const initialSupplierData = [
  { id: 'S1001', name: '王五', idCard: '331002198010101234', phone: '13800138000', authStatus: '已认证', riskStatus: '正常', bankCards: [{ id: 'C1', bank: '中国农业银行', account: '622848003812345678', branch: '台州分行', status: 'normal' }] },
  { id: 'S1002', name: '赵六', idCard: '331002199205055678', phone: '13900139000', authStatus: '已认证', riskStatus: '正常', bankCards: [{ id: 'C2', bank: '中国工商银行', account: '622202123456789012', branch: '上海分行', status: 'normal' }] },
  { id: 'S1003', name: '孙七', idCard: '340102198503151234', phone: '13700137001', authStatus: '已认证', riskStatus: '正常', bankCards: [{ id: 'C4', bank: '中国建设银行', account: '6217001234567890123', branch: '南京分行', status: 'normal' }] },
  { id: 'S1004', name: '周八', idCard: '330106199008082345', phone: '13600136002', authStatus: '已认证', riskStatus: '正常', bankCards: [{ id: 'C5', bank: '交通银行', account: '6222601234567890', branch: '无锡分行', status: 'normal' }] },
  { id: 'S1005', name: '吴九', idCard: '320205198712125678', phone: '13500135003', authStatus: '已认证', riskStatus: '正常', bankCards: [{ id: 'C6', bank: '浦发银行', account: '9843012345678901', branch: '杭州分行', status: 'normal' }] },
  { id: 'S1006', name: '郑十', idCard: '330102198808088765', phone: '13400134004', authStatus: '已认证', riskStatus: '风险', blacklistReason: '', bankCards: [{ id: 'C7', bank: '招商银行', account: '6214831234567890', branch: '杭州分行', status: 'normal' }] },
  { id: 'S1007', name: '钱十一', idCard: '330106199101011234', phone: '13300133005', authStatus: '待认证', riskStatus: '正常', bankCards: [] },
  { id: 'S1008', name: '李十二', idCard: '330102199203033456', phone: '13200132006', authStatus: '已认证', riskStatus: '黑名单', blacklistReason: '多次提供虚假质检报告', bankCards: [{ id: 'C8', bank: '中国银行', account: '6216611234567890', branch: '宁波分行', status: 'error' }] },
  { id: 'S1009', name: '张十三', idCard: '330106199404044567', phone: '13100131007', authStatus: '已认证', riskStatus: '正常', bankCards: [{ id: 'C9', bank: '兴业银行', account: '6229081234567890', branch: '温州分行', status: 'normal' }] },
  { id: 'S1010', name: '刘十四', idCard: '330102199505055678', phone: '13000130008', authStatus: '已认证', riskStatus: '正常', bankCards: [{ id: 'C10', bank: '民生银行', account: '6226151234567890', branch: '绍兴分行', status: 'normal' }] },
  { id: 'S1011', name: '陈十五', idCard: '330106199606066789', phone: '13900139009', authStatus: '已认证', riskStatus: '正常', bankCards: [{ id: 'C11', bank: '光大银行', account: '6226801234567890', branch: '嘉兴分行', status: 'normal' }] },
  { id: 'S1012', name: '黄十六', idCard: '330102199707077890', phone: '13800138010', authStatus: '已认证', riskStatus: '正常', bankCards: [{ id: 'C12', bank: '华夏银行', account: '6226301234567890', branch: '金华分行', status: 'normal' }] },
];

export const mockEmployees = [
  { id: 'E001', name: '张三', role: '基地经理', phone: '13800000001', base: '马钢诚兴台州基地', status: '在职' },
  { id: 'E002', name: '李四', role: '业务员', phone: '13800000002', base: '马钢诚兴台州基地', status: '在职' },
  { id: 'E003', name: '王部长', role: '平台运营部长', phone: '13800000003', base: '平台运营中心', status: '在职' },
  { id: 'E004', name: '赵总', role: '分管副总', phone: '13800000004', base: '集团总部', status: '在职' },
];

export const demandData = [
  // 草稿状态
  {
    id: 'D2026030401',
    type: '敞口需求',
    demandType: 'open',
    baseIds: ['B001'],
    baseNames: '马钢诚兴台州基地',
    material: '工业重废毛料, 特级破碎料, 统料废钢',
    materials: [
      { name: '工业重废毛料', price: 2400, qty: 150 },
      { name: '特级破碎料', price: 2600, qty: 100 },
      { name: '统料废钢', price: 2200, qty: 50 }
    ],
    price: '2,400 元/吨',
    qty: '300 吨',
    validFrom: '2026-03-04',
    validUntil: '2026-09-04',
    status: '草稿',
    creator: '张伟',
    createTime: '2026-03-04 09:00'
  },
  {
    id: 'D2026030402',
    type: '定制化(闭口)',
    demandType: 'closed',
    baseIds: ['B002', 'B003'],
    baseNames: '马钢诚兴上海分公司、马钢诚兴杭州湾基地',
    material: '特级破碎料',
    price: '2,650 元/吨',
    qty: '150 吨',
    validFrom: '2026-03-04',
    validUntil: '2026-04-15',
    status: '草稿',
    creator: '李四',
    createTime: '2026-03-04 10:30'
  },
  // 待审核状态
  {
    id: 'D2026030301',
    type: '敞口需求',
    demandType: 'open',
    baseIds: ['B001'],
    baseNames: '马钢诚兴台州基地',
    material: '统料废钢, 轻薄料',
    materials: [
      { name: '统料废钢', price: 2200, qty: 500 },
      { name: '轻薄料', price: 1800, qty: 300 }
    ],
    price: '2,200 元/吨',
    qty: '800 吨',
    validFrom: '2026-03-03',
    validUntil: '2026-09-03',
    status: '待审核',
    creator: '张伟',
    createTime: '2026-03-03 14:00'
  },
  {
    id: 'D2026030302',
    type: '定制化(闭口)',
    demandType: 'closed',
    baseIds: ['B003'],
    baseNames: '马钢诚兴杭州湾基地',
    material: '轻薄料',
    price: '1,800 元/吨',
    qty: '200 吨',
    validFrom: '2026-03-03',
    validUntil: '2026-04-30',
    status: '待审核',
    creator: '王五',
    createTime: '2026-03-03 16:45'
  },
  {
    id: 'D2026030303',
    type: '敞口需求',
    demandType: 'open',
    baseIds: ['B002'],
    baseNames: '马钢诚兴上海分公司',
    material: '特级破碎料',
    materials: [
      { name: '特级破碎料', price: 2650, qty: null, qtyUnlimited: true }
    ],
    price: '2,650 元/吨',
    qty: '不限',
    totalQty: 0,
    hasUnlimitedQty: true,
    validFrom: '2026-03-03',
    validTo: '2026-06-30',
    validUntil: '2026-06-30',
    deliveryValidMonths: 3,
    status: '待审核',
    creator: '张伟',
    createTime: '2026-03-03 17:20'
  },
  // 已发布状态
  {
    id: 'D2026022801',
    type: '敞口需求',
    demandType: 'open',
    baseIds: ['B001', 'B002'],
    baseNames: '马钢诚兴台州基地、马钢诚兴上海分公司',
    material: '工业重废毛料, 钢筋头',
    materials: [
      { name: '工业重废毛料', price: 2450, qty: null, qtyUnlimited: true },
      { name: '钢筋头', price: 2300, qty: 200 }
    ],
    price: '2,450 元/吨',
    qty: '不限',
    totalQty: 200,
    hasUnlimitedQty: true,
    validFrom: '2026-02-28',
    validTo: '2026-08-28',
    validUntil: '2026-08-28',
    deliveryValidMonths: 6,
    status: '已发布',
    creator: '张伟',
    createTime: '2026-02-28 10:00'
  },
  {
    id: 'D2026022802',
    type: '定制化(闭口)',
    demandType: 'closed',
    baseIds: ['B002'],
    baseNames: '马钢诚兴上海分公司',
    material: '特级破碎料',
    price: '2,600 元/吨',
    qty: '100 吨',
    validFrom: '2026-02-28',
    validUntil: '2026-03-31',
    status: '已发布',
    creator: '李四',
    createTime: '2026-02-28 14:30'
  },
  {
    id: 'D2026022501',
    type: '敞口需求',
    demandType: 'open',
    baseIds: ['B003', 'B005'],
    baseNames: '马钢诚兴杭州湾基地、马钢诚兴无锡基地',
    material: '钢筋头',
    price: '2,300 元/吨',
    qty: '400 吨',
    validFrom: '2026-02-25',
    validUntil: '2026-08-25',
    status: '已发布',
    creator: '王五',
    createTime: '2026-02-25 11:20'
  },
  // 已失效状态
  {
    id: 'D2026022001',
    type: '敞口需求',
    demandType: 'open',
    baseIds: ['B001'],
    baseNames: '马钢诚兴台州基地',
    material: '统料废钢',
    price: '2,150 元/吨',
    qty: '600 吨',
    validFrom: '2026-02-20',
    validUntil: '2026-02-28',
    status: '已失效',
    creator: '张伟',
    createTime: '2026-02-20 09:30'
  },
  {
    id: 'D2026021501',
    type: '定制化(闭口)',
    demandType: 'closed',
    baseIds: ['B002', 'B003'],
    baseNames: '马钢诚兴上海分公司、马钢诚兴杭州湾基地',
    material: '轻薄料',
    price: '1,750 元/吨',
    qty: '120 吨',
    validFrom: '2026-02-15',
    validUntil: '2026-03-01',
    status: '已失效',
    creator: '李四',
    createTime: '2026-02-15 15:00'
  },
  {
    id: 'D2026021001',
    type: '敞口需求',
    demandType: 'open',
    baseIds: ['B004'],
    baseNames: '马钢诚兴南京分公司',
    material: '工业重废毛料',
    price: '2,380 元/吨',
    qty: '350 吨',
    validFrom: '2026-02-10',
    validUntil: '2026-02-25',
    status: '已失效',
    creator: '王五',
    createTime: '2026-02-10 13:45'
  },
];

// ============ 订单数据（新结构）============

export const mockOrders = [
  {
    id: 'ORD001',
    orderNo: 'ORD20260312001',
    supplierId: 'S1001',
    supplierName: '王五',
    supplierPhone: '13800138000',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    baseAddress: '浙江省宁波市杭州湾新区兴慈大道66号',
    materialId: 'M001',
    materialName: '工业重废毛料',
    demandId: 'D2026031201',
    contractNo: 'C20260312001',
    mode: 'self',
    demandType: 'closed',
    price: 2437,
    estimatedWeight: 40,
    estimatedAmount: 97480,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-03-12 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-12 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-12 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-12 12:12"},
    deliveryCount: 2,
    deliveryStats: {"total":2,"pendingConfirm":0,"waitingDelivery":1,"arrived":1,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260411',
    createdAt: '2026-03-12 11:12',
    updatedAt: '2026-03-12 11:12',
    completedAt: null,
  },
  {
    id: 'ORD002',
    orderNo: 'ORD20260311002',
    supplierId: 'S1002',
    supplierName: '赵六',
    supplierPhone: '13900139000',
    baseId: 'B004',
    baseName: '马钢诚兴南京分公司',
    baseAddress: '江苏省南京市江宁区秣周东路100号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026031101',
    contractNo: 'C20260311002',
    mode: 'self',
    demandType: 'closed',
    price: 2274,
    estimatedWeight: 44,
    estimatedAmount: 100056,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_APPROVAL,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260410',
    createdAt: '2026-03-11 11:12',
    updatedAt: '2026-03-11 11:12',
    completedAt: null,
  },
  {
    id: 'ORD003',
    orderNo: 'ORD20260310003',
    supplierId: 'S1003',
    supplierName: '孙七',
    supplierPhone: '13700137001',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    baseAddress: '浙江省宁波市杭州湾新区兴慈大道66号',
    materialId: 'M001',
    materialName: '工业重废毛料',
    demandId: 'D2026031001',
    contractNo: null,
    mode: 'self',
    demandType: 'open',
    price: 2472,
    estimatedWeight: 33,
    estimatedAmount: 81576,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_SIGN,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260409',
    createdAt: '2026-03-10 11:12',
    updatedAt: '2026-03-10 11:12',
    completedAt: null,
  },
  {
    id: 'ORD004',
    orderNo: 'ORD20260309004',
    supplierId: 'S1004',
    supplierName: '周八',
    supplierPhone: '13600136002',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    baseAddress: '浙江省宁波市杭州湾新区兴慈大道66号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026030901',
    contractNo: 'C20260309004',
    mode: 'self',
    demandType: 'closed',
    price: 2157,
    estimatedWeight: 61,
    estimatedAmount: 131577,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.REJECTED,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260408',
    createdAt: '2026-03-09 11:12',
    updatedAt: '2026-03-09 11:12',
    completedAt: null,
  },
  {
    id: 'ORD005',
    orderNo: 'ORD20260308005',
    supplierId: 'S1005',
    supplierName: '吴九',
    supplierPhone: '13500135003',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    baseAddress: '浙江省台州市路桥区滨海大道88号',
    materialId: 'M001',
    materialName: '工业重废毛料',
    demandId: 'D2026030801',
    contractNo: 'C20260308005',
    mode: 'self',
    demandType: 'closed',
    price: 2517,
    estimatedWeight: 65,
    estimatedAmount: 163605,
    actualWeight: 46.8,
    actualAmount: 118915,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-08 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-08 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-08 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-08 12:12"},
    deliveryCount: 4,
    deliveryStats: {"total":4,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":4},
    deliveryDeadline: '20260407',
    createdAt: '2026-03-08 11:12',
    updatedAt: '2026-03-08 11:12',
    completedAt: null,
  },
  {
    id: 'ORD006',
    orderNo: 'ORD20260307006',
    supplierId: 'S1001',
    supplierName: '王五',
    supplierPhone: '13800138000',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    baseAddress: '上海市宝山区宝杨路12号',
    materialId: 'M005',
    materialName: '钢筋头',
    demandId: 'D2026030701',
    contractNo: 'C20260307006',
    mode: 'self',
    demandType: 'closed',
    price: 2377,
    estimatedWeight: 62,
    estimatedAmount: 147374,
    actualWeight: 13.1,
    actualAmount: 31446,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-03-07 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-07 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-07 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-07 12:12"},
    deliveryCount: 4,
    deliveryStats: {"total":4,"pendingConfirm":0,"waitingDelivery":1,"arrived":1,"waitingApproval":1,"stored":0,"pendingSettlement":0,"settled":1,"invoiced":0,"paid":0},
    deliveryDeadline: '20260406',
    createdAt: '2026-03-07 11:12',
    updatedAt: '2026-03-07 11:12',
    completedAt: null,
  },
  {
    id: 'ORD007',
    orderNo: 'ORD20260306007',
    supplierId: 'S1002',
    supplierName: '赵六',
    supplierPhone: '13900139000',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    baseAddress: '浙江省宁波市杭州湾新区兴慈大道66号',
    materialId: 'M004',
    materialName: '轻薄料',
    demandId: 'D2026030601',
    contractNo: 'C20260306007',
    mode: 'self',
    demandType: 'open',
    price: 1881,
    estimatedWeight: 71,
    estimatedAmount: 133551,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_APPROVAL,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260405',
    createdAt: '2026-03-06 11:12',
    updatedAt: '2026-03-06 11:12',
    completedAt: null,
  },
  {
    id: 'ORD008',
    orderNo: 'ORD20260305008',
    supplierId: 'S1003',
    supplierName: '孙七',
    supplierPhone: '13700137001',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    baseAddress: '上海市宝山区宝杨路12号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026030501',
    contractNo: null,
    mode: 'self',
    demandType: 'closed',
    price: 2318,
    estimatedWeight: 89,
    estimatedAmount: 206302,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_SIGN,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260404',
    createdAt: '2026-03-05 11:12',
    updatedAt: '2026-03-05 11:12',
    completedAt: null,
  },
  {
    id: 'ORD009',
    orderNo: 'ORD20260304009',
    supplierId: 'S1004',
    supplierName: '周八',
    supplierPhone: '13600136002',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    baseAddress: '浙江省台州市路桥区滨海大道88号',
    materialId: 'M004',
    materialName: '轻薄料',
    demandId: 'D2026030401',
    contractNo: 'C20260304009',
    mode: 'self',
    demandType: 'open',
    price: 1751,
    estimatedWeight: 108,
    estimatedAmount: 189108,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.REJECTED,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260403',
    createdAt: '2026-03-04 11:12',
    updatedAt: '2026-03-04 11:12',
    completedAt: null,
  },
  {
    id: 'ORD010',
    orderNo: 'ORD20260303010',
    supplierId: 'S1005',
    supplierName: '吴九',
    supplierPhone: '13500135003',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    baseAddress: '上海市宝山区宝杨路12号',
    materialId: 'M001',
    materialName: '工业重废毛料',
    demandId: 'D2026030301',
    contractNo: 'C20260303010',
    mode: 'self',
    demandType: 'closed',
    price: 2407,
    estimatedWeight: 37,
    estimatedAmount: 89059,
    actualWeight: 22.9,
    actualAmount: 55554,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-03 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-03 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-03 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-03 12:12"},
    deliveryCount: 2,
    deliveryStats: {"total":2,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":2},
    deliveryDeadline: '20260402',
    createdAt: '2026-03-03 11:12',
    updatedAt: '2026-03-03 11:12',
    completedAt: null,
  },
  {
    id: 'ORD011',
    orderNo: 'ORD20260312011',
    supplierId: 'S1001',
    supplierName: '王五',
    supplierPhone: '13800138000',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    baseAddress: '上海市宝山区宝杨路12号',
    materialId: 'M001',
    materialName: '工业重废毛料',
    demandId: 'D2026031201',
    contractNo: 'C20260312011',
    mode: 'self',
    demandType: 'closed',
    price: 2400,
    estimatedWeight: 70,
    estimatedAmount: 168000,
    actualWeight: 21.3,
    actualAmount: 51646,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-03-12 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-12 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-12 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-12 12:12"},
    deliveryCount: 2,
    deliveryStats: {"total":2,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":1,"settled":1,"invoiced":0,"paid":0},
    deliveryDeadline: '20260411',
    createdAt: '2026-03-12 11:12',
    updatedAt: '2026-03-12 11:12',
    completedAt: null,
  },
  {
    id: 'ORD012',
    orderNo: 'ORD20260311012',
    supplierId: 'S1002',
    supplierName: '赵六',
    supplierPhone: '13900139000',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    baseAddress: '江苏省无锡市惠山区洛社镇55号',
    materialId: 'M005',
    materialName: '钢筋头',
    demandId: 'D2026031101',
    contractNo: 'C20260311012',
    mode: 'self',
    demandType: 'open',
    price: 2365,
    estimatedWeight: 107,
    estimatedAmount: 253055,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_APPROVAL,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260410',
    createdAt: '2026-03-11 11:12',
    updatedAt: '2026-03-11 11:12',
    completedAt: null,
  },
  {
    id: 'ORD013',
    orderNo: 'ORD20260310013',
    supplierId: 'S1003',
    supplierName: '孙七',
    supplierPhone: '13700137001',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    baseAddress: '上海市宝山区宝杨路12号',
    materialId: 'M004',
    materialName: '轻薄料',
    demandId: 'D2026031001',
    contractNo: null,
    mode: 'self',
    demandType: 'open',
    price: 1859,
    estimatedWeight: 55,
    estimatedAmount: 102245,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_SIGN,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260409',
    createdAt: '2026-03-10 11:12',
    updatedAt: '2026-03-10 11:12',
    completedAt: null,
  },
  {
    id: 'ORD014',
    orderNo: 'ORD20260309014',
    supplierId: 'S1004',
    supplierName: '周八',
    supplierPhone: '13600136002',
    baseId: 'B004',
    baseName: '马钢诚兴南京分公司',
    baseAddress: '江苏省南京市江宁区秣周东路100号',
    materialId: 'M004',
    materialName: '轻薄料',
    demandId: 'D2026030901',
    contractNo: 'C20260309014',
    mode: 'self',
    demandType: 'open',
    price: 1763,
    estimatedWeight: 36,
    estimatedAmount: 63468,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.REJECTED,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260408',
    createdAt: '2026-03-09 11:12',
    updatedAt: '2026-03-09 11:12',
    completedAt: null,
  },
  {
    id: 'ORD015',
    orderNo: 'ORD20260308015',
    supplierId: 'S1005',
    supplierName: '吴九',
    supplierPhone: '13500135003',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    baseAddress: '江苏省无锡市惠山区洛社镇55号',
    materialId: 'M002',
    materialName: '特级破碎料',
    demandId: 'D2026030801',
    contractNo: 'C20260308015',
    mode: 'self',
    demandType: 'closed',
    price: 2529,
    estimatedWeight: 93,
    estimatedAmount: 235197,
    actualWeight: 39.7,
    actualAmount: 101360,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-08 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-08 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-08 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-08 12:12"},
    deliveryCount: 3,
    deliveryStats: {"total":3,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":3},
    deliveryDeadline: '20260407',
    createdAt: '2026-03-08 11:12',
    updatedAt: '2026-03-08 11:12',
    completedAt: null,
  },
  {
    id: 'ORD016',
    orderNo: 'ORD20260307016',
    supplierId: 'S1001',
    supplierName: '王五',
    supplierPhone: '13800138000',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    baseAddress: '浙江省宁波市杭州湾新区兴慈大道66号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026030701',
    contractNo: 'C20260307016',
    mode: 'self',
    demandType: 'open',
    price: 2185,
    estimatedWeight: 78,
    estimatedAmount: 170430,
    actualWeight: 29.5,
    actualAmount: 65073,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-03-07 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-07 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-07 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-07 12:12"},
    deliveryCount: 2,
    deliveryStats: {"total":2,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":1,"pendingSettlement":1,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260406',
    createdAt: '2026-03-07 11:12',
    updatedAt: '2026-03-07 11:12',
    completedAt: null,
  },
  {
    id: 'ORD017',
    orderNo: 'ORD20260306017',
    supplierId: 'S1002',
    supplierName: '赵六',
    supplierPhone: '13900139000',
    baseId: 'B004',
    baseName: '马钢诚兴南京分公司',
    baseAddress: '江苏省南京市江宁区秣周东路100号',
    materialId: 'M004',
    materialName: '轻薄料',
    demandId: 'D2026030601',
    contractNo: 'C20260306017',
    mode: 'self',
    demandType: 'closed',
    price: 1790,
    estimatedWeight: 93,
    estimatedAmount: 166470,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_APPROVAL,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260405',
    createdAt: '2026-03-06 11:12',
    updatedAt: '2026-03-06 11:12',
    completedAt: null,
  },
  {
    id: 'ORD018',
    orderNo: 'ORD20260305018',
    supplierId: 'S1003',
    supplierName: '孙七',
    supplierPhone: '13700137001',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    baseAddress: '浙江省台州市路桥区滨海大道88号',
    materialId: 'M005',
    materialName: '钢筋头',
    demandId: 'D2026030501',
    contractNo: null,
    mode: 'self',
    demandType: 'open',
    price: 2343,
    estimatedWeight: 104,
    estimatedAmount: 243672,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_SIGN,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260404',
    createdAt: '2026-03-05 11:12',
    updatedAt: '2026-03-05 11:12',
    completedAt: null,
  },
  {
    id: 'ORD019',
    orderNo: 'ORD20260304019',
    supplierId: 'S1004',
    supplierName: '周八',
    supplierPhone: '13600136002',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    baseAddress: '上海市宝山区宝杨路12号',
    materialId: 'M002',
    materialName: '特级破碎料',
    demandId: 'D2026030401',
    contractNo: 'C20260304019',
    mode: 'self',
    demandType: 'closed',
    price: 2604,
    estimatedWeight: 78,
    estimatedAmount: 203112,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.REJECTED,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260403',
    createdAt: '2026-03-04 11:12',
    updatedAt: '2026-03-04 11:12',
    completedAt: null,
  },
  {
    id: 'ORD020',
    orderNo: 'ORD20260303020',
    supplierId: 'S1005',
    supplierName: '吴九',
    supplierPhone: '13500135003',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    baseAddress: '上海市宝山区宝杨路12号',
    materialId: 'M005',
    materialName: '钢筋头',
    demandId: 'D2026030301',
    contractNo: 'C20260303020',
    mode: 'self',
    demandType: 'open',
    price: 2359,
    estimatedWeight: 36,
    estimatedAmount: 84924,
    actualWeight: 59.6,
    actualAmount: 141972,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-03 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-03 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-03 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-03 12:12"},
    deliveryCount: 4,
    deliveryStats: {"total":4,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":4},
    deliveryDeadline: '20260402',
    createdAt: '2026-03-03 11:12',
    updatedAt: '2026-03-03 11:12',
    completedAt: null,
  },
  {
    id: 'ORD021',
    orderNo: 'ORD20260312021',
    supplierId: 'S1001',
    supplierName: '王五',
    supplierPhone: '13800138000',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    baseAddress: '上海市宝山区宝杨路12号',
    materialId: 'M001',
    materialName: '工业重废毛料',
    demandId: 'D2026031201',
    contractNo: 'C20260312021',
    mode: 'self',
    demandType: 'closed',
    price: 2361,
    estimatedWeight: 87,
    estimatedAmount: 205407,
    actualWeight: 18.9,
    actualAmount: 45072,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-03-12 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-12 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-12 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-12 12:12"},
    deliveryCount: 2,
    deliveryStats: {"total":2,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":1,"stored":1,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260411',
    createdAt: '2026-03-12 11:12',
    updatedAt: '2026-03-12 11:12',
    completedAt: null,
  },
  {
    id: 'ORD022',
    orderNo: 'ORD20260311022',
    supplierId: 'S1002',
    supplierName: '赵六',
    supplierPhone: '13900139000',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    baseAddress: '浙江省台州市路桥区滨海大道88号',
    materialId: 'M004',
    materialName: '轻薄料',
    demandId: 'D2026031101',
    contractNo: 'C20260311022',
    mode: 'self',
    demandType: 'closed',
    price: 1846,
    estimatedWeight: 47,
    estimatedAmount: 86762,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_APPROVAL,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260410',
    createdAt: '2026-03-11 11:12',
    updatedAt: '2026-03-11 11:12',
    completedAt: null,
  },
  {
    id: 'ORD023',
    orderNo: 'ORD20260310023',
    supplierId: 'S1003',
    supplierName: '孙七',
    supplierPhone: '13700137001',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    baseAddress: '浙江省台州市路桥区滨海大道88号',
    materialId: 'M002',
    materialName: '特级破碎料',
    demandId: 'D2026031001',
    contractNo: null,
    mode: 'self',
    demandType: 'closed',
    price: 2671,
    estimatedWeight: 56,
    estimatedAmount: 149576,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.PENDING_SIGN,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260409',
    createdAt: '2026-03-10 11:12',
    updatedAt: '2026-03-10 11:12',
    completedAt: null,
  },
  {
    id: 'ORD024',
    orderNo: 'ORD20260309024',
    supplierId: 'S1004',
    supplierName: '周八',
    supplierPhone: '13600136002',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    baseAddress: '浙江省台州市路桥区滨海大道88号',
    materialId: 'M004',
    materialName: '轻薄料',
    demandId: 'D2026030901',
    contractNo: 'C20260309024',
    mode: 'self',
    demandType: 'closed',
    price: 1894,
    estimatedWeight: 56,
    estimatedAmount: 106064,
    actualWeight: 0.0,
    actualAmount: 0,
    status: ORDER_STATUS.REJECTED,
    approval: null,
    deliveryCount: 0,
    deliveryStats: {"total":0,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260408',
    createdAt: '2026-03-09 11:12',
    updatedAt: '2026-03-09 11:12',
    completedAt: null,
  },
  {
    id: 'ORD025',
    orderNo: 'ORD20260308025',
    supplierId: 'S1005',
    supplierName: '吴九',
    supplierPhone: '13500135003',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    baseAddress: '江苏省无锡市惠山区洛社镇55号',
    materialId: 'M002',
    materialName: '特级破碎料',
    demandId: 'D2026030801',
    contractNo: 'C20260308025',
    mode: 'self',
    demandType: 'closed',
    price: 2560,
    estimatedWeight: 42,
    estimatedAmount: 107520,
    actualWeight: 36.4,
    actualAmount: 94213,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-08 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-08 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-08 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-08 12:12"},
    deliveryCount: 3,
    deliveryStats: {"total":3,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":3},
    deliveryDeadline: '20260407',
    createdAt: '2026-03-08 11:12',
    updatedAt: '2026-03-08 11:12',
    completedAt: null,
  },
  {
    id: 'ORD026',
    orderNo: 'ORD20260225026',
    supplierId: 'S1006',
    supplierName: '郑十',
    supplierPhone: '13400134004',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    baseAddress: '浙江省台州市路桥区滨海大道88号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026022501',
    contractNo: 'C20260225026',
    mode: 'self',
    demandType: 'open',
    price: 2343,
    estimatedWeight: 108,
    estimatedAmount: 253044,
    actualWeight: 16.0,
    actualAmount: 37920,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-02-25 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-02-25 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-02-25 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-02-25 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":1,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260327',
    createdAt: '2026-02-25 11:12',
    updatedAt: '2026-02-25 11:12',
    completedAt: null,
  },
  {
    id: 'ORD027',
    orderNo: 'ORD20260222027',
    supplierId: 'S1007',
    supplierName: '钱十一',
    supplierPhone: '13300133005',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    baseAddress: '江苏省无锡市惠山区洛社镇55号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026022201',
    contractNo: 'C20260222027',
    mode: 'self',
    demandType: 'closed',
    price: 2310,
    estimatedWeight: 86,
    estimatedAmount: 198660,
    actualWeight: 7.7,
    actualAmount: 17977,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-02-22 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-02-22 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-02-22 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-02-22 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":1,"settled":0,"invoiced":0,"paid":0},
    deliveryDeadline: '20260324',
    createdAt: '2026-02-22 11:12',
    updatedAt: '2026-02-22 11:12',
    completedAt: null,
  },
  {
    id: 'ORD028',
    orderNo: 'ORD20260219028',
    supplierId: 'S1010',
    supplierName: '刘十四',
    supplierPhone: '13000130008',
    baseId: 'B004',
    baseName: '马钢诚兴南京分公司',
    baseAddress: '江苏省南京市江宁区秣周东路100号',
    materialId: 'M005',
    materialName: '钢筋头',
    demandId: 'D2026021901',
    contractNo: 'C20260219028',
    mode: 'self',
    demandType: 'closed',
    price: 2446,
    estimatedWeight: 43,
    estimatedAmount: 105178,
    actualWeight: 14.1,
    actualAmount: 34699,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-02-19 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-02-19 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-02-19 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-02-19 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":1,"paid":0},
    deliveryDeadline: '20260321',
    createdAt: '2026-02-19 11:12',
    updatedAt: '2026-02-19 11:12',
    completedAt: null,
  },
  {
    id: 'ORD029',
    orderNo: 'ORD20260216029',
    supplierId: 'S1011',
    supplierName: '陈十五',
    supplierPhone: '13900139009',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    baseAddress: '浙江省宁波市杭州湾新区兴慈大道66号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026021601',
    contractNo: 'C20260216029',
    mode: 'self',
    demandType: 'open',
    price: 2254,
    estimatedWeight: 77,
    estimatedAmount: 173558,
    actualWeight: 4.2,
    actualAmount: 9664,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-02-16 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-02-16 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-02-16 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-02-16 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":1,"paid":0},
    deliveryDeadline: '20260318',
    createdAt: '2026-02-16 11:12',
    updatedAt: '2026-02-16 11:12',
    completedAt: null,
  },
  {
    id: 'ORD030',
    orderNo: 'ORD20260213030',
    supplierId: 'S1012',
    supplierName: '黄十六',
    supplierPhone: '13800138010',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    baseAddress: '浙江省宁波市杭州湾新区兴慈大道66号',
    materialId: 'M001',
    materialName: '工业重废毛料',
    demandId: 'D2026021301',
    contractNo: 'C20260213030',
    mode: 'self',
    demandType: 'closed',
    price: 2455,
    estimatedWeight: 74,
    estimatedAmount: 181670,
    actualWeight: 12.6,
    actualAmount: 31309,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-02-13 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-02-13 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-02-13 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-02-13 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":1},
    deliveryDeadline: '20260315',
    createdAt: '2026-02-13 11:12',
    updatedAt: '2026-02-13 11:12',
    completedAt: null,
  },
  {
    id: 'ORD031',
    orderNo: 'ORD20260312031',
    supplierId: 'S1004',
    supplierName: '周八',
    supplierPhone: '13600136002',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    baseAddress: '浙江省宁波市杭州湾新区兴慈大道66号',
    materialId: 'M005',
    materialName: '钢筋头',
    demandId: 'D2026031201',
    contractNo: 'C20260312031',
    mode: 'self',
    demandType: 'open',
    price: 2380,
    estimatedWeight: 60,
    estimatedAmount: 142800,
    actualWeight: 15.1,
    actualAmount: 36328,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-12 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-12 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-12 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-12 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":1},
    deliveryDeadline: '20260411',
    createdAt: '2026-03-12 11:12',
    updatedAt: '2026-03-12 11:12',
    completedAt: null,
  },
  {
    id: 'ORD032',
    orderNo: 'ORD20260311032',
    supplierId: 'S1005',
    supplierName: '吴九',
    supplierPhone: '13500135003',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    baseAddress: '江苏省无锡市惠山区洛社镇55号',
    materialId: 'M004',
    materialName: '轻薄料',
    demandId: 'D2026031101',
    contractNo: 'C20260311032',
    mode: 'self',
    demandType: 'closed',
    price: 1907,
    estimatedWeight: 98,
    estimatedAmount: 186886,
    actualWeight: 15.2,
    actualAmount: 29214,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-11 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-11 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-11 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-11 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":1},
    deliveryDeadline: '20260410',
    createdAt: '2026-03-11 11:12',
    updatedAt: '2026-03-11 11:12',
    completedAt: null,
  },
  {
    id: 'ORD033',
    orderNo: 'ORD20260310033',
    supplierId: 'S1012',
    supplierName: '黄十六',
    supplierPhone: '13800138010',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    baseAddress: '浙江省台州市路桥区滨海大道88号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026031001',
    contractNo: 'C20260310033',
    mode: 'self',
    demandType: 'closed',
    price: 2295,
    estimatedWeight: 65,
    estimatedAmount: 149175,
    actualWeight: 13.8,
    actualAmount: 32017,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-10 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-10 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-10 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-10 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":1},
    deliveryDeadline: '20260409',
    createdAt: '2026-03-10 11:12',
    updatedAt: '2026-03-10 11:12',
    completedAt: null,
  },
  {
    id: 'ORD034',
    orderNo: 'ORD20260309034',
    supplierId: 'S1012',
    supplierName: '黄十六',
    supplierPhone: '13800138010',
    baseId: 'B004',
    baseName: '马钢诚兴南京分公司',
    baseAddress: '江苏省南京市江宁区秣周东路100号',
    materialId: 'M001',
    materialName: '工业重废毛料',
    demandId: 'D2026030901',
    contractNo: 'C20260309034',
    mode: 'self',
    demandType: 'open',
    price: 2464,
    estimatedWeight: 79,
    estimatedAmount: 194656,
    actualWeight: 15.3,
    actualAmount: 38072,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-09 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-09 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-09 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-09 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":1},
    deliveryDeadline: '20260408',
    createdAt: '2026-03-09 11:12',
    updatedAt: '2026-03-09 11:12',
    completedAt: null,
  },
  {
    id: 'ORD035',
    orderNo: 'ORD20260308035',
    supplierId: 'S1004',
    supplierName: '周八',
    supplierPhone: '13600136002',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    baseAddress: '浙江省宁波市杭州湾新区兴慈大道66号',
    materialId: 'M005',
    materialName: '钢筋头',
    demandId: 'D2026030801',
    contractNo: 'C20260308035',
    mode: 'self',
    demandType: 'open',
    price: 2403,
    estimatedWeight: 81,
    estimatedAmount: 194643,
    actualWeight: 8.9,
    actualAmount: 21713,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-08 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-08 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-08 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-08 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":1},
    deliveryDeadline: '20260407',
    createdAt: '2026-03-08 11:12',
    updatedAt: '2026-03-08 11:12',
    completedAt: null,
  },
  {
    id: 'ORD036',
    orderNo: 'ORD20260307036',
    supplierId: 'S1001',
    supplierName: '王五',
    supplierPhone: '13800138000',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    baseAddress: '浙江省台州市路桥区滨海大道88号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026030701',
    contractNo: 'C20260307036',
    mode: 'self',
    demandType: 'open',
    price: 2341,
    estimatedWeight: 48,
    estimatedAmount: 112368,
    actualWeight: 12.3,
    actualAmount: 29052,
    status: ORDER_STATUS.IN_PROGRESS,
    approval: {"submittedAt":"2026-03-07 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-07 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-07 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-07 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":1,"paid":0},
    deliveryDeadline: '20260406',
    createdAt: '2026-03-07 11:12',
    updatedAt: '2026-03-07 11:12',
    completedAt: null,
  },
  {
    id: 'ORD037',
    orderNo: 'ORD20260306037',
    supplierId: 'S1004',
    supplierName: '周八',
    supplierPhone: '13600136002',
    baseId: 'B004',
    baseName: '马钢诚兴南京分公司',
    baseAddress: '江苏省南京市江宁区秣周东路100号',
    materialId: 'M003',
    materialName: '统料废钢',
    demandId: 'D2026030601',
    contractNo: 'C20260306037',
    mode: 'self',
    demandType: 'open',
    price: 2242,
    estimatedWeight: 47,
    estimatedAmount: 105374,
    actualWeight: 11.6,
    actualAmount: 26197,
    status: ORDER_STATUS.COMPLETED,
    approval: {"submittedAt":"2026-03-06 11:12","currentStep":null,"flow":[{"step":"业务员提交","approver":"李四","approverRole":"业务员","status":"approved","time":"2026-03-06 11:12","remark":""},{"step":"平台运营部长","approver":"王部长","approverRole":"平台运营部长","status":"approved","time":"2026-03-06 12:12","remark":"同意"}],"rejectedReason":null,"approvedAt":"2026-03-06 12:12"},
    deliveryCount: 1,
    deliveryStats: {"total":1,"pendingConfirm":0,"waitingDelivery":0,"arrived":0,"waitingApproval":0,"stored":0,"pendingSettlement":0,"settled":0,"invoiced":0,"paid":1},
    deliveryDeadline: '20260405',
    createdAt: '2026-03-06 11:12',
    updatedAt: '2026-03-06 11:12',
    completedAt: null,
  }
];

// ============ 送货单数据（新增）============

export const mockDeliveries = [
  {
    id: 'DEL001',
    deliveryNo: 'DEL20260312001',
    orderId: 'ORD001',
    orderNo: 'ORD20260312001',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2437,
    stockInNo: null,
    settlementNo: null,
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260312001","time":"2026-03-12 13:12","vehicleNo":"浙J65546","driverName":"赵师傅","driverPhone":"189031****6288"},
    arrival: null,
    storage: null,
    settlement: null,
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.WAITING_DELIVERY,
    timeline: [{"time":"03-12 11:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"}],
    createdAt: '2026-03-12 11:12',
    updatedAt: '2026-03-12 11:12',
  },
  {
    id: 'DEL002',
    deliveryNo: 'DEL20260312002',
    orderId: 'ORD001',
    orderNo: 'ORD20260312001',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2437,
    stockInNo: null,
    settlementNo: null,
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260312002","time":"2026-03-12 15:12","vehicleNo":"苏A89127","driverName":"黄师傅","driverPhone":"156552****2722"},
    arrival: {"at":"2026-03-12 16:12","photo":"arrival_DEL002.jpg","operator":"张三"},
    storage: null,
    settlement: null,
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.ARRIVED,
    timeline: [{"time":"03-12 13:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-12 16:12","status":"arrived","action":"车辆到场","operator":"张三"}],
    createdAt: '2026-03-12 13:12',
    updatedAt: '2026-03-12 13:12',
  },
  {
    id: 'DEL003',
    deliveryNo: 'DEL20260308003',
    orderId: 'ORD005',
    orderNo: 'ORD20260308005',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2517,
    stockInNo: 'SI20260308001',
    settlementNo: 'SET20260308001',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308003","time":"2026-03-08 13:12","vehicleNo":"苏A18725","driverName":"黄师傅","driverPhone":"179955****9367"},
    arrival: {"at":"2026-03-08 14:12","photo":"arrival_DEL003.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 15:12","stockInNo":"SI20260308001","grossWeight":23,"tareWeight":16,"netWeight":7,"deduction":0.53,"actualWeight":6.47,"quality":"二级","photos":["plate_DEL003.jpg"],"operator":"李四","confirmed":true,"price":2517,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":16296,"amountWithTax":16458.96,"entryInfo":{"at":"2026-03-08 14:22","operator":"王门卫","photo":"entry_DEL003.jpg"},"entryWeighInfo":{"at":"2026-03-08 14:42","operator":"李四","photo":"weigh_in_DEL003.jpg"},"qualityInfo":{"at":"2026-03-08 14:57","operator":"张质检","photo":"quality_DEL003.jpg"},"exitWeighInfo":{"at":"2026-03-08 15:00","operator":"李四","photo":"weigh_out_DEL003.jpg"},"exitCheckInfo":{"at":"2026-03-08 15:22","operator":"王门卫","photo":"exit_DEL003.jpg"}},
    settlement: {"unitPrice":2517,"amount":117738,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 11:12","settlementNo":"SET20260308001","mergedCount":4,"isMergedHead":true},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":314487.74,"at":"2026-03-10 11:12","file":"invoice_DEL003.pdf","mergedCount":10,"isMergedHead":true},
    payment: {"no":"PAY20260308001","amount":541227.69,"at":"2026-03-11 11:12","method":"银行转账","transactionNo":"TXN20260308001","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260310","requiredAmount":541227.69,"paidAmount":541227.69,"voucher":{"no":"VCH20260308001","type":"银行回单","at":"2026-03-11 11:12","file":"PAY_VOUCHER_DEL003.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"],"isMergedHead":true,"invoiceMergedCount":3},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 11:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 15:12","status":"stored","action":"入库过磅 6.5吨","operator":"李四"},{"time":"03-08 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 11:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 11:12',
    updatedAt: '2026-03-08 11:12',
  },
  {
    id: 'DEL004',
    deliveryNo: 'DEL20260308004',
    orderId: 'ORD005',
    orderNo: 'ORD20260308005',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2517,
    stockInNo: 'SI20260308002',
    settlementNo: 'SET20260308001',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308004","time":"2026-03-08 15:12","vehicleNo":"苏A38886","driverName":"吴师傅","driverPhone":"136322****7872"},
    arrival: {"at":"2026-03-08 16:12","photo":"arrival_DEL004.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 17:12","stockInNo":"SI20260308002","grossWeight":22,"tareWeight":12,"netWeight":10,"deduction":0.12,"actualWeight":9.88,"quality":"一级","photos":["plate_DEL004.jpg"],"operator":"李四","confirmed":true,"price":2517,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":24856,"amountWithTax":25104.56,"entryInfo":{"at":"2026-03-08 16:22","operator":"王门卫","photo":"entry_DEL004.jpg"},"entryWeighInfo":{"at":"2026-03-08 16:42","operator":"李四","photo":"weigh_in_DEL004.jpg"},"qualityInfo":{"at":"2026-03-08 16:57","operator":"张质检","photo":"quality_DEL004.jpg"},"exitWeighInfo":{"at":"2026-03-08 17:00","operator":"李四","photo":"weigh_out_DEL004.jpg"},"exitCheckInfo":{"at":"2026-03-08 17:22","operator":"王门卫","photo":"exit_DEL004.jpg"}},
    settlement: {"unitPrice":2517,"amount":29435,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 13:12","settlementNo":"SET20260308001","mergedCount":4},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":31448.77,"at":"2026-03-10 13:12","file":"invoice_DEL004.pdf","mergedCount":10},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-11 13:12","method":"银行转账","transactionNo":"TXN20260308002","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260311","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260308002","type":"银行回单","at":"2026-03-11 13:12","file":"PAY_VOUCHER_DEL004.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 13:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 16:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 17:12","status":"stored","action":"入库过磅 9.9吨","operator":"李四"},{"time":"03-08 18:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 13:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 13:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 13:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 13:12',
    updatedAt: '2026-03-08 13:12',
  },
  {
    id: 'DEL005',
    deliveryNo: 'DEL20260308005',
    orderId: 'ORD005',
    orderNo: 'ORD20260308005',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2517,
    stockInNo: 'ST20260308001',
    settlementNo: 'SET20260308001',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308005","time":"2026-03-08 17:12","vehicleNo":"浙A87810","driverName":"王师傅","driverPhone":"137559****1085"},
    arrival: {"at":"2026-03-08 18:12","photo":"arrival_DEL005.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 19:12","stockInNo":"ST20260308001","grossWeight":28,"tareWeight":16,"netWeight":12,"deduction":0.11,"actualWeight":11.89,"quality":"二级","photos":["plate_DEL005.jpg"],"operator":"李四","confirmed":true,"price":2517,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":29937,"amountWithTax":30236.37,"entryInfo":{"at":"2026-03-08 18:22","operator":"王门卫","photo":"entry_DEL005.jpg"},"entryWeighInfo":{"at":"2026-03-08 18:42","operator":"李四","photo":"weigh_in_DEL005.jpg"},"qualityInfo":{"at":"2026-03-08 18:57","operator":"张质检","photo":"quality_DEL005.jpg"},"exitWeighInfo":{"at":"2026-03-08 19:00","operator":"李四","photo":"weigh_out_DEL005.jpg"},"exitCheckInfo":{"at":"2026-03-08 19:22","operator":"王门卫","photo":"exit_DEL005.jpg"}},
    settlement: {"unitPrice":2517,"amount":29435,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 15:12","settlementNo":"SET20260308001","mergedCount":4},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":31448.77,"at":"2026-03-10 15:12","file":"invoice_DEL005.pdf","mergedCount":10},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-11 15:12","method":"银行转账","transactionNo":"TXN20260308003","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260311","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260308003","type":"银行回单","at":"2026-03-11 15:12","file":"PAY_VOUCHER_DEL005.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 15:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 18:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 19:12","status":"stored","action":"入库过磅 11.9吨","operator":"李四"},{"time":"03-08 20:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 15:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 15:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 15:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 15:12',
    updatedAt: '2026-03-08 15:12',
  },
  {
    id: 'DEL006',
    deliveryNo: 'DEL20260308006',
    orderId: 'ORD005',
    orderNo: 'ORD20260308005',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2517,
    stockInNo: 'SI20260308003',
    settlementNo: 'SET20260308001',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308006","time":"2026-03-08 19:12","vehicleNo":"浙A53762","driverName":"黄师傅","driverPhone":"189740****5588"},
    arrival: {"at":"2026-03-08 20:12","photo":"arrival_DEL006.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 21:12","stockInNo":"SI20260308003","grossWeight":33,"tareWeight":14,"netWeight":19,"deduction":0.47,"actualWeight":18.53,"quality":"合格","photos":["plate_DEL006.jpg"],"operator":"李四","confirmed":true,"price":2517,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":46649,"amountWithTax":47115.49,"entryInfo":{"at":"2026-03-08 20:22","operator":"王门卫","photo":"entry_DEL006.jpg"},"entryWeighInfo":{"at":"2026-03-08 20:42","operator":"李四","photo":"weigh_in_DEL006.jpg"},"qualityInfo":{"at":"2026-03-08 20:57","operator":"张质检","photo":"quality_DEL006.jpg"},"exitWeighInfo":{"at":"2026-03-08 21:00","operator":"李四","photo":"weigh_out_DEL006.jpg"},"exitCheckInfo":{"at":"2026-03-08 21:22","operator":"王门卫","photo":"exit_DEL006.jpg"}},
    settlement: {"unitPrice":2517,"amount":29435,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 17:12","settlementNo":"SET20260308001","mergedCount":4},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":31448.77,"at":"2026-03-10 17:12","file":"invoice_DEL006.pdf","mergedCount":10},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-11 17:12","method":"银行转账","transactionNo":"TXN20260308004","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260311","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260308004","type":"银行回单","at":"2026-03-11 17:12","file":"PAY_VOUCHER_DEL006.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 17:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 20:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 21:12","status":"stored","action":"入库过磅 18.5吨","operator":"李四"},{"time":"03-08 22:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 17:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 17:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 17:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 17:12',
    updatedAt: '2026-03-08 17:12',
  },
  {
    id: 'DEL007',
    deliveryNo: 'DEL20260307007',
    orderId: 'ORD006',
    orderNo: 'ORD20260307006',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2377,
    stockInNo: 'SI20260307004',
    settlementNo: 'SET20260307005',
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260307007","time":"2026-03-07 13:12","vehicleNo":"苏A99427","driverName":"黄师傅","driverPhone":"179025****2074"},
    arrival: {"at":"2026-03-07 14:12","photo":"arrival_DEL007.jpg","operator":"张三"},
    storage: {"at":"2026-03-07 15:12","stockInNo":"SI20260307004","grossWeight":28,"tareWeight":14,"netWeight":14,"deduction":0.9,"actualWeight":13.1,"quality":"二级","photos":["plate_DEL007.jpg"],"operator":"李四","confirmed":true,"price":2377,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":31135,"amountWithTax":31446.35,"entryInfo":{"at":"2026-03-07 14:22","operator":"王门卫","photo":"entry_DEL007.jpg"},"entryWeighInfo":{"at":"2026-03-07 14:42","operator":"李四","photo":"weigh_in_DEL007.jpg"},"qualityInfo":{"at":"2026-03-07 14:57","operator":"张质检","photo":"quality_DEL007.jpg"},"exitWeighInfo":{"at":"2026-03-07 15:00","operator":"李四","photo":"weigh_out_DEL007.jpg"},"exitCheckInfo":{"at":"2026-03-07 15:22","operator":"王门卫","photo":"exit_DEL007.jpg"}},
    settlement: {"unitPrice":2377,"amount":31135,"confirmedBySupplier":true,"confirmedAt":"2026-03-08 11:12","settlementNo":"SET20260307005"},
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.SETTLED,
    timeline: [{"time":"03-07 11:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-07 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-07 15:12","status":"stored","action":"入库过磅 13.1吨","operator":"李四"},{"time":"03-07 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-08 11:12","status":"settled","action":"供应商确认结算","operator":"王五"}],
    createdAt: '2026-03-07 11:12',
    updatedAt: '2026-03-07 11:12',
  },
  {
    id: 'DEL008',
    deliveryNo: 'DEL20260307008',
    orderId: 'ORD006',
    orderNo: 'ORD20260307006',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2377,
    stockInNo: null,
    settlementNo: null,
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260307008","time":"2026-03-07 15:12","vehicleNo":"苏A47083","driverName":"张师傅","driverPhone":"136994****5056"},
    arrival: null,
    storage: null,
    settlement: null,
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.WAITING_DELIVERY,
    timeline: [{"time":"03-07 13:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"}],
    createdAt: '2026-03-07 13:12',
    updatedAt: '2026-03-07 13:12',
  },
  {
    id: 'DEL009',
    deliveryNo: 'DEL20260307009',
    orderId: 'ORD006',
    orderNo: 'ORD20260307006',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2377,
    stockInNo: null,
    settlementNo: null,
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260307009","time":"2026-03-07 17:12","vehicleNo":"苏B70928","driverName":"王师傅","driverPhone":"176659****1404"},
    arrival: {"at":"2026-03-07 18:12","photo":"arrival_DEL009.jpg","operator":"张三"},
    storage: null,
    settlement: null,
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.ARRIVED,
    timeline: [{"time":"03-07 15:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-07 18:12","status":"arrived","action":"车辆到场","operator":"张三"}],
    createdAt: '2026-03-07 15:12',
    updatedAt: '2026-03-07 15:12',
  },
  {
    id: 'DEL010',
    deliveryNo: 'DEL20260307010',
    orderId: 'ORD006',
    orderNo: 'ORD20260307006',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2377,
    stockInNo: null,
    settlementNo: null,
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260307010","time":"2026-03-07 19:12","vehicleNo":"苏A22046","driverName":"刘师傅","driverPhone":"171327****9382"},
    arrival: {"at":"2026-03-07 20:12","photo":"arrival_DEL010.jpg","operator":"张三"},
    storage: null,
    settlement: null,
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.WAITING_APPROVAL,
    timeline: [{"time":"03-07 17:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-07 20:12","status":"arrived","action":"车辆到场","operator":"张三"}],
    createdAt: '2026-03-07 17:12',
    updatedAt: '2026-03-07 17:12',
  },
  {
    id: 'DEL011',
    deliveryNo: 'DEL20260303011',
    orderId: 'ORD010',
    orderNo: 'ORD20260303010',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2407,
    stockInNo: 'SI20260303005',
    settlementNo: 'SET20260303006',
    invoiceNo: 'INV20260303005',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260303011","time":"2026-03-03 13:12","vehicleNo":"浙A43317","driverName":"张师傅","driverPhone":"143706****1323"},
    arrival: {"at":"2026-03-03 14:12","photo":"arrival_DEL011.jpg","operator":"张三"},
    storage: {"at":"2026-03-03 15:12","stockInNo":"SI20260303005","grossWeight":29,"tareWeight":13,"netWeight":16,"deduction":0.09,"actualWeight":15.91,"quality":"合格","photos":["plate_DEL011.jpg"],"operator":"李四","confirmed":true,"price":2407,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":38293,"amountWithTax":38675.93,"entryInfo":{"at":"2026-03-03 14:22","operator":"王门卫","photo":"entry_DEL011.jpg"},"entryWeighInfo":{"at":"2026-03-03 14:42","operator":"李四","photo":"weigh_in_DEL011.jpg"},"qualityInfo":{"at":"2026-03-03 14:57","operator":"张质检","photo":"quality_DEL011.jpg"},"exitWeighInfo":{"at":"2026-03-03 15:00","operator":"李四","photo":"weigh_out_DEL011.jpg"},"exitCheckInfo":{"at":"2026-03-03 15:22","operator":"王门卫","photo":"exit_DEL011.jpg"}},
    settlement: {"unitPrice":2407,"amount":55004,"confirmedBySupplier":true,"confirmedAt":"2026-03-04 11:12","settlementNo":"SET20260303006","mergedCount":2,"isMergedHead":true},
    invoice: {"no":"INV20260303005","type":"反向开票","amount":197525.7,"at":"2026-03-05 11:12","file":"invoice_DEL011.pdf","mergedCount":6,"isMergedHead":true},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-06 11:12","method":"银行转账","transactionNo":"TXN20260303005","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260305","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260303005","type":"银行回单","at":"2026-03-06 11:12","file":"PAY_VOUCHER_DEL011.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-03 11:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-03 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-03 15:12","status":"stored","action":"入库过磅 15.9吨","operator":"李四"},{"time":"03-03 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-04 11:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-05 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-06 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-03 11:12',
    updatedAt: '2026-03-03 11:12',
  },
  {
    id: 'DEL012',
    deliveryNo: 'DEL20260303012',
    orderId: 'ORD010',
    orderNo: 'ORD20260303010',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2407,
    stockInNo: 'SI20260303006',
    settlementNo: 'SET20260303006',
    invoiceNo: 'INV20260303005',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260303012","time":"2026-03-03 15:12","vehicleNo":"浙J75527","driverName":"赵师傅","driverPhone":"136520****3655"},
    arrival: {"at":"2026-03-03 16:12","photo":"arrival_DEL012.jpg","operator":"张三"},
    storage: {"at":"2026-03-03 17:12","stockInNo":"SI20260303006","grossWeight":21,"tareWeight":14,"netWeight":7,"deduction":0.06,"actualWeight":6.94,"quality":"一级","photos":["plate_DEL012.jpg"],"operator":"李四","confirmed":true,"price":2407,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":16711,"amountWithTax":16878.11,"entryInfo":{"at":"2026-03-03 16:22","operator":"王门卫","photo":"entry_DEL012.jpg"},"entryWeighInfo":{"at":"2026-03-03 16:42","operator":"李四","photo":"weigh_in_DEL012.jpg"},"qualityInfo":{"at":"2026-03-03 16:57","operator":"张质检","photo":"quality_DEL012.jpg"},"exitWeighInfo":{"at":"2026-03-03 17:00","operator":"李四","photo":"weigh_out_DEL012.jpg"},"exitCheckInfo":{"at":"2026-03-03 17:22","operator":"王门卫","photo":"exit_DEL012.jpg"}},
    settlement: {"unitPrice":2407,"amount":27502,"confirmedBySupplier":true,"confirmedAt":"2026-03-04 13:12","settlementNo":"SET20260303006","mergedCount":2},
    invoice: {"no":"INV20260303005","type":"反向开票","amount":32920.95,"at":"2026-03-05 13:12","file":"invoice_DEL012.pdf","mergedCount":6},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-06 13:12","method":"银行转账","transactionNo":"TXN20260303006","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260306","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260303006","type":"银行回单","at":"2026-03-06 13:12","file":"PAY_VOUCHER_DEL012.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-03 13:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-03 16:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-03 17:12","status":"stored","action":"入库过磅 6.9吨","operator":"李四"},{"time":"03-03 18:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-04 13:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-05 13:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-06 13:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-03 13:12',
    updatedAt: '2026-03-03 13:12',
  },
  {
    id: 'DEL013',
    deliveryNo: 'DEL20260312013',
    orderId: 'ORD011',
    orderNo: 'ORD20260312011',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2400,
    stockInNo: 'SI20260312007',
    settlementNo: 'SET20260312008',
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260312013","time":"2026-03-12 13:12","vehicleNo":"沪A76638","driverName":"赵师傅","driverPhone":"187247****3110"},
    arrival: {"at":"2026-03-12 14:12","photo":"arrival_DEL013.jpg","operator":"张三"},
    storage: {"at":"2026-03-12 15:12","stockInNo":"SI20260312007","grossWeight":31,"tareWeight":14,"netWeight":17,"deduction":0.22,"actualWeight":16.78,"quality":"一级","photos":["plate_DEL013.jpg"],"operator":"李四","confirmed":true,"price":2400,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":40282,"amountWithTax":40684.82,"entryInfo":{"at":"2026-03-12 14:22","operator":"王门卫","photo":"entry_DEL013.jpg"},"entryWeighInfo":{"at":"2026-03-12 14:42","operator":"李四","photo":"weigh_in_DEL013.jpg"},"qualityInfo":{"at":"2026-03-12 14:57","operator":"张质检","photo":"quality_DEL013.jpg"},"exitWeighInfo":{"at":"2026-03-12 15:00","operator":"李四","photo":"weigh_out_DEL013.jpg"},"exitCheckInfo":{"at":"2026-03-12 15:22","operator":"王门卫","photo":"exit_DEL013.jpg"}},
    settlement: {"unitPrice":2400,"amount":51135,"confirmedBySupplier":false,"confirmedAt":null,"settlementNo":"SET20260312008","mergedCount":2,"isMergedHead":true},
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.PENDING_SETTLEMENT,
    timeline: [{"time":"03-12 11:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-12 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-12 15:12","status":"stored","action":"入库过磅 16.8吨","operator":"李四"},{"time":"03-12 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"}],
    createdAt: '2026-03-12 11:12',
    updatedAt: '2026-03-12 11:12',
  },
  {
    id: 'DEL014',
    deliveryNo: 'DEL20260312014',
    orderId: 'ORD011',
    orderNo: 'ORD20260312011',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2400,
    stockInNo: 'ST20260312002',
    settlementNo: 'SET20260312008',
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260312014","time":"2026-03-12 15:12","vehicleNo":"苏B29136","driverName":"刘师傅","driverPhone":"171580****3679"},
    arrival: {"at":"2026-03-12 16:12","photo":"arrival_DEL014.jpg","operator":"张三"},
    storage: {"at":"2026-03-12 17:12","stockInNo":"ST20260312002","grossWeight":20,"tareWeight":15,"netWeight":5,"deduction":0.48,"actualWeight":4.52,"quality":"一级","photos":["plate_DEL014.jpg"],"operator":"李四","confirmed":true,"price":2400,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":10853,"amountWithTax":10961.53,"entryInfo":{"at":"2026-03-12 16:22","operator":"王门卫","photo":"entry_DEL014.jpg"},"entryWeighInfo":{"at":"2026-03-12 16:42","operator":"李四","photo":"weigh_in_DEL014.jpg"},"qualityInfo":{"at":"2026-03-12 16:57","operator":"张质检","photo":"quality_DEL014.jpg"},"exitWeighInfo":{"at":"2026-03-12 17:00","operator":"李四","photo":"weigh_out_DEL014.jpg"},"exitCheckInfo":{"at":"2026-03-12 17:22","operator":"王门卫","photo":"exit_DEL014.jpg"}},
    settlement: {"unitPrice":2400,"amount":25568,"confirmedBySupplier":true,"confirmedAt":"2026-03-13 13:12","settlementNo":"SET20260312008","mergedCount":2},
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.SETTLED,
    timeline: [{"time":"03-12 13:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-12 16:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-12 17:12","status":"stored","action":"入库过磅 4.5吨","operator":"李四"},{"time":"03-12 18:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-13 13:12","status":"settled","action":"供应商确认结算","operator":"王五"}],
    createdAt: '2026-03-12 13:12',
    updatedAt: '2026-03-12 13:12',
  },
  {
    id: 'DEL015',
    deliveryNo: 'DEL20260308015',
    orderId: 'ORD015',
    orderNo: 'ORD20260308015',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    materialId: 'M002',
    materialName: '特级破碎料',
    price: 2529,
    stockInNo: 'SI20260308008',
    settlementNo: 'SET20260308010',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308015","time":"2026-03-08 13:12","vehicleNo":"沪A56617","driverName":"李师傅","driverPhone":"175544****5007"},
    arrival: {"at":"2026-03-08 14:12","photo":"arrival_DEL015.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 15:12","stockInNo":"SI20260308008","grossWeight":29,"tareWeight":13,"netWeight":16,"deduction":0.21,"actualWeight":15.79,"quality":"一级","photos":["plate_DEL015.jpg"],"operator":"李四","confirmed":true,"price":2529,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":39940,"amountWithTax":40339.4,"entryInfo":{"at":"2026-03-08 14:22","operator":"王门卫","photo":"entry_DEL015.jpg"},"entryWeighInfo":{"at":"2026-03-08 14:42","operator":"李四","photo":"weigh_in_DEL015.jpg"},"qualityInfo":{"at":"2026-03-08 14:57","operator":"张质检","photo":"quality_DEL015.jpg"},"exitWeighInfo":{"at":"2026-03-08 15:00","operator":"李四","photo":"weigh_out_DEL015.jpg"},"exitCheckInfo":{"at":"2026-03-08 15:22","operator":"王门卫","photo":"exit_DEL015.jpg"}},
    settlement: {"unitPrice":2529,"amount":100356,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 11:12","settlementNo":"SET20260308010","mergedCount":3,"isMergedHead":true},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":31448.77,"at":"2026-03-10 11:12","file":"invoice_DEL015.pdf","mergedCount":10},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-11 11:12","method":"银行转账","transactionNo":"TXN20260308007","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260310","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260308007","type":"银行回单","at":"2026-03-11 11:12","file":"PAY_VOUCHER_DEL015.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 11:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 15:12","status":"stored","action":"入库过磅 15.8吨","operator":"李四"},{"time":"03-08 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 11:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 11:12',
    updatedAt: '2026-03-08 11:12',
  },
  {
    id: 'DEL016',
    deliveryNo: 'DEL20260308016',
    orderId: 'ORD015',
    orderNo: 'ORD20260308015',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    materialId: 'M002',
    materialName: '特级破碎料',
    price: 2529,
    stockInNo: 'SI20260308009',
    settlementNo: 'SET20260308010',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308016","time":"2026-03-08 15:12","vehicleNo":"沪A32993","driverName":"吴师傅","driverPhone":"184843****6019"},
    arrival: {"at":"2026-03-08 16:12","photo":"arrival_DEL016.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 17:12","stockInNo":"SI20260308009","grossWeight":21,"tareWeight":16,"netWeight":5,"deduction":0.29,"actualWeight":4.71,"quality":"二级","photos":["plate_DEL016.jpg"],"operator":"李四","confirmed":true,"price":2529,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":11910,"amountWithTax":12029.1,"entryInfo":{"at":"2026-03-08 16:22","operator":"王门卫","photo":"entry_DEL016.jpg"},"entryWeighInfo":{"at":"2026-03-08 16:42","operator":"李四","photo":"weigh_in_DEL016.jpg"},"qualityInfo":{"at":"2026-03-08 16:57","operator":"张质检","photo":"quality_DEL016.jpg"},"exitWeighInfo":{"at":"2026-03-08 17:00","operator":"李四","photo":"weigh_out_DEL016.jpg"},"exitCheckInfo":{"at":"2026-03-08 17:22","operator":"王门卫","photo":"exit_DEL016.jpg"}},
    settlement: {"unitPrice":2529,"amount":33452,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 13:12","settlementNo":"SET20260308010","mergedCount":3},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":31448.77,"at":"2026-03-10 13:12","file":"invoice_DEL016.pdf","mergedCount":10},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-11 13:12","method":"银行转账","transactionNo":"TXN20260308008","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260311","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260308008","type":"银行回单","at":"2026-03-11 13:12","file":"PAY_VOUCHER_DEL016.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 13:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 16:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 17:12","status":"stored","action":"入库过磅 4.7吨","operator":"李四"},{"time":"03-08 18:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 13:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 13:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 13:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 13:12',
    updatedAt: '2026-03-08 13:12',
  },
  {
    id: 'DEL017',
    deliveryNo: 'DEL20260308017',
    orderId: 'ORD015',
    orderNo: 'ORD20260308015',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    materialId: 'M002',
    materialName: '特级破碎料',
    price: 2529,
    stockInNo: 'ST20260308003',
    settlementNo: 'SET20260308010',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308017","time":"2026-03-08 17:12","vehicleNo":"浙J27836","driverName":"张师傅","driverPhone":"135006****5423"},
    arrival: {"at":"2026-03-08 18:12","photo":"arrival_DEL017.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 19:12","stockInNo":"ST20260308003","grossWeight":33,"tareWeight":13,"netWeight":20,"deduction":0.82,"actualWeight":19.18,"quality":"一级","photos":["plate_DEL017.jpg"],"operator":"李四","confirmed":true,"price":2529,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":48506,"amountWithTax":48991.06,"entryInfo":{"at":"2026-03-08 18:22","operator":"王门卫","photo":"entry_DEL017.jpg"},"entryWeighInfo":{"at":"2026-03-08 18:42","operator":"李四","photo":"weigh_in_DEL017.jpg"},"qualityInfo":{"at":"2026-03-08 18:57","operator":"张质检","photo":"quality_DEL017.jpg"},"exitWeighInfo":{"at":"2026-03-08 19:00","operator":"李四","photo":"weigh_out_DEL017.jpg"},"exitCheckInfo":{"at":"2026-03-08 19:22","operator":"王门卫","photo":"exit_DEL017.jpg"}},
    settlement: {"unitPrice":2529,"amount":33452,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 15:12","settlementNo":"SET20260308010","mergedCount":3},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":31448.77,"at":"2026-03-10 15:12","file":"invoice_DEL017.pdf","mergedCount":10},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-11 15:12","method":"银行转账","transactionNo":"TXN20260308009","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260311","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260308009","type":"银行回单","at":"2026-03-11 15:12","file":"PAY_VOUCHER_DEL017.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 15:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 18:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 19:12","status":"stored","action":"入库过磅 19.2吨","operator":"李四"},{"time":"03-08 20:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 15:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 15:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 15:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 15:12',
    updatedAt: '2026-03-08 15:12',
  },
  {
    id: 'DEL018',
    deliveryNo: 'DEL20260307018',
    orderId: 'ORD016',
    orderNo: 'ORD20260307016',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    materialId: 'M003',
    materialName: '统料废钢',
    price: 2185,
    stockInNo: 'SI20260307010',
    settlementNo: null,
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260307018","time":"2026-03-07 13:12","vehicleNo":"浙J81808","driverName":"刘师傅","driverPhone":"186425****9719"},
    arrival: {"at":"2026-03-07 14:12","photo":"arrival_DEL018.jpg","operator":"张三"},
    storage: {"at":"2026-03-07 15:12","stockInNo":"SI20260307010","grossWeight":29,"tareWeight":12,"netWeight":17,"deduction":0.07,"actualWeight":16.93,"quality":"合格","photos":["plate_DEL018.jpg"],"operator":"李四","confirmed":true,"price":2185,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":36991,"amountWithTax":37360.91,"entryInfo":{"at":"2026-03-07 14:22","operator":"王门卫","photo":"entry_DEL018.jpg"},"entryWeighInfo":{"at":"2026-03-07 14:42","operator":"李四","photo":"weigh_in_DEL018.jpg"},"qualityInfo":{"at":"2026-03-07 14:57","operator":"张质检","photo":"quality_DEL018.jpg"},"exitWeighInfo":{"at":"2026-03-07 15:00","operator":"李四","photo":"weigh_out_DEL018.jpg"},"exitCheckInfo":{"at":"2026-03-07 15:22","operator":"王门卫","photo":"exit_DEL018.jpg"}},
    settlement: null,
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.STORED,
    timeline: [{"time":"03-07 11:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-07 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-07 15:12","status":"stored","action":"入库过磅 16.9吨","operator":"李四"}],
    createdAt: '2026-03-07 11:12',
    updatedAt: '2026-03-07 11:12',
  },
  {
    id: 'DEL019',
    deliveryNo: 'DEL20260307019',
    orderId: 'ORD016',
    orderNo: 'ORD20260307016',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    materialId: 'M003',
    materialName: '统料废钢',
    price: 2185,
    stockInNo: 'SI20260307011',
    settlementNo: 'SET20260307013',
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260307019","time":"2026-03-07 15:12","vehicleNo":"浙A54674","driverName":"李师傅","driverPhone":"177151****2873"},
    arrival: {"at":"2026-03-07 16:12","photo":"arrival_DEL019.jpg","operator":"张三"},
    storage: {"at":"2026-03-07 17:12","stockInNo":"SI20260307011","grossWeight":29,"tareWeight":16,"netWeight":13,"deduction":0.44,"actualWeight":12.56,"quality":"二级","photos":["plate_DEL019.jpg"],"operator":"李四","confirmed":true,"price":2185,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":27438,"amountWithTax":27712.38,"entryInfo":{"at":"2026-03-07 16:22","operator":"王门卫","photo":"entry_DEL019.jpg"},"entryWeighInfo":{"at":"2026-03-07 16:42","operator":"李四","photo":"weigh_in_DEL019.jpg"},"qualityInfo":{"at":"2026-03-07 16:57","operator":"张质检","photo":"quality_DEL019.jpg"},"exitWeighInfo":{"at":"2026-03-07 17:00","operator":"李四","photo":"weigh_out_DEL019.jpg"},"exitCheckInfo":{"at":"2026-03-07 17:22","operator":"王门卫","photo":"exit_DEL019.jpg"}},
    settlement: {"unitPrice":2185,"amount":27438,"confirmedBySupplier":false,"confirmedAt":null,"settlementNo":"SET20260307013"},
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.PENDING_SETTLEMENT,
    timeline: [{"time":"03-07 13:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-07 16:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-07 17:12","status":"stored","action":"入库过磅 12.6吨","operator":"李四"},{"time":"03-07 18:12","status":"pending_settlement","action":"生成结算单","operator":"系统"}],
    createdAt: '2026-03-07 13:12',
    updatedAt: '2026-03-07 13:12',
  },
  {
    id: 'DEL020',
    deliveryNo: 'DEL20260303020',
    orderId: 'ORD020',
    orderNo: 'ORD20260303020',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2359,
    stockInNo: 'SI20260303012',
    settlementNo: 'SET20260303014',
    invoiceNo: 'INV20260303005',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260303020","time":"2026-03-03 13:12","vehicleNo":"苏A68149","driverName":"赵师傅","driverPhone":"138198****4408"},
    arrival: {"at":"2026-03-03 14:12","photo":"arrival_DEL020.jpg","operator":"张三"},
    storage: {"at":"2026-03-03 15:12","stockInNo":"SI20260303012","grossWeight":21,"tareWeight":15,"netWeight":6,"deduction":0.39,"actualWeight":5.61,"quality":"二级","photos":["plate_DEL020.jpg"],"operator":"李四","confirmed":true,"price":2359,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":13226,"amountWithTax":13358.26,"entryInfo":{"at":"2026-03-03 14:22","operator":"王门卫","photo":"entry_DEL020.jpg"},"entryWeighInfo":{"at":"2026-03-03 14:42","operator":"李四","photo":"weigh_in_DEL020.jpg"},"qualityInfo":{"at":"2026-03-03 14:57","operator":"张质检","photo":"quality_DEL020.jpg"},"exitWeighInfo":{"at":"2026-03-03 15:00","operator":"李四","photo":"weigh_out_DEL020.jpg"},"exitCheckInfo":{"at":"2026-03-03 15:22","operator":"王门卫","photo":"exit_DEL020.jpg"}},
    settlement: {"unitPrice":2359,"amount":140566,"confirmedBySupplier":true,"confirmedAt":"2026-03-04 11:12","settlementNo":"SET20260303014","mergedCount":4,"isMergedHead":true},
    invoice: {"no":"INV20260303005","type":"反向开票","amount":32920.95,"at":"2026-03-05 11:12","file":"invoice_DEL020.pdf","mergedCount":6},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-06 11:12","method":"银行转账","transactionNo":"TXN20260303010","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260305","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260303010","type":"银行回单","at":"2026-03-06 11:12","file":"PAY_VOUCHER_DEL020.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-03 11:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-03 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-03 15:12","status":"stored","action":"入库过磅 5.6吨","operator":"李四"},{"time":"03-03 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-04 11:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-05 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-06 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-03 11:12',
    updatedAt: '2026-03-03 11:12',
  },
  {
    id: 'DEL021',
    deliveryNo: 'DEL20260303021',
    orderId: 'ORD020',
    orderNo: 'ORD20260303020',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2359,
    stockInNo: 'ST20260303004',
    settlementNo: 'SET20260303014',
    invoiceNo: 'INV20260303005',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260303021","time":"2026-03-03 15:12","vehicleNo":"浙J51474","driverName":"陈师傅","driverPhone":"185925****9683"},
    arrival: {"at":"2026-03-03 16:12","photo":"arrival_DEL021.jpg","operator":"张三"},
    storage: {"at":"2026-03-03 17:12","stockInNo":"ST20260303004","grossWeight":33,"tareWeight":12,"netWeight":21,"deduction":0.54,"actualWeight":20.46,"quality":"合格","photos":["plate_DEL021.jpg"],"operator":"李四","confirmed":true,"price":2359,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":48274,"amountWithTax":48756.74,"entryInfo":{"at":"2026-03-03 16:22","operator":"王门卫","photo":"entry_DEL021.jpg"},"entryWeighInfo":{"at":"2026-03-03 16:42","operator":"李四","photo":"weigh_in_DEL021.jpg"},"qualityInfo":{"at":"2026-03-03 16:57","operator":"张质检","photo":"quality_DEL021.jpg"},"exitWeighInfo":{"at":"2026-03-03 17:00","operator":"李四","photo":"weigh_out_DEL021.jpg"},"exitCheckInfo":{"at":"2026-03-03 17:22","operator":"王门卫","photo":"exit_DEL021.jpg"}},
    settlement: {"unitPrice":2359,"amount":35142,"confirmedBySupplier":true,"confirmedAt":"2026-03-04 13:12","settlementNo":"SET20260303014","mergedCount":4},
    invoice: {"no":"INV20260303005","type":"反向开票","amount":32920.95,"at":"2026-03-05 13:12","file":"invoice_DEL021.pdf","mergedCount":6},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-06 13:12","method":"银行转账","transactionNo":"TXN20260303011","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260306","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260303011","type":"银行回单","at":"2026-03-06 13:12","file":"PAY_VOUCHER_DEL021.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-03 13:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-03 16:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-03 17:12","status":"stored","action":"入库过磅 20.5吨","operator":"李四"},{"time":"03-03 18:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-04 13:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-05 13:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-06 13:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-03 13:12',
    updatedAt: '2026-03-03 13:12',
  },
  {
    id: 'DEL022',
    deliveryNo: 'DEL20260303022',
    orderId: 'ORD020',
    orderNo: 'ORD20260303020',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2359,
    stockInNo: 'SI20260303013',
    settlementNo: 'SET20260303014',
    invoiceNo: 'INV20260303005',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260303022","time":"2026-03-03 17:12","vehicleNo":"苏B70334","driverName":"赵师傅","driverPhone":"143420****4619"},
    arrival: {"at":"2026-03-03 18:12","photo":"arrival_DEL022.jpg","operator":"张三"},
    storage: {"at":"2026-03-03 19:12","stockInNo":"SI20260303013","grossWeight":29,"tareWeight":15,"netWeight":14,"deduction":0.27,"actualWeight":13.73,"quality":"二级","photos":["plate_DEL022.jpg"],"operator":"李四","confirmed":true,"price":2359,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":32400,"amountWithTax":32724,"entryInfo":{"at":"2026-03-03 18:22","operator":"王门卫","photo":"entry_DEL022.jpg"},"entryWeighInfo":{"at":"2026-03-03 18:42","operator":"李四","photo":"weigh_in_DEL022.jpg"},"qualityInfo":{"at":"2026-03-03 18:57","operator":"张质检","photo":"quality_DEL022.jpg"},"exitWeighInfo":{"at":"2026-03-03 19:00","operator":"李四","photo":"weigh_out_DEL022.jpg"},"exitCheckInfo":{"at":"2026-03-03 19:22","operator":"王门卫","photo":"exit_DEL022.jpg"}},
    settlement: {"unitPrice":2359,"amount":35142,"confirmedBySupplier":true,"confirmedAt":"2026-03-04 15:12","settlementNo":"SET20260303014","mergedCount":4},
    invoice: {"no":"INV20260303005","type":"反向开票","amount":32920.95,"at":"2026-03-05 15:12","file":"invoice_DEL022.pdf","mergedCount":6},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-06 15:12","method":"银行转账","transactionNo":"TXN20260303012","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260306","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260303012","type":"银行回单","at":"2026-03-06 15:12","file":"PAY_VOUCHER_DEL022.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-03 15:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-03 18:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-03 19:12","status":"stored","action":"入库过磅 13.7吨","operator":"李四"},{"time":"03-03 20:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-04 15:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-05 15:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-06 15:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-03 15:12',
    updatedAt: '2026-03-03 15:12',
  },
  {
    id: 'DEL023',
    deliveryNo: 'DEL20260303023',
    orderId: 'ORD020',
    orderNo: 'ORD20260303020',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2359,
    stockInNo: 'SI20260303014',
    settlementNo: 'SET20260303014',
    invoiceNo: 'INV20260303005',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260303023","time":"2026-03-03 19:12","vehicleNo":"苏B24565","driverName":"张师傅","driverPhone":"148208****8620"},
    arrival: {"at":"2026-03-03 20:12","photo":"arrival_DEL023.jpg","operator":"张三"},
    storage: {"at":"2026-03-03 21:12","stockInNo":"SI20260303014","grossWeight":32,"tareWeight":12,"netWeight":20,"deduction":0.22,"actualWeight":19.78,"quality":"一级","photos":["plate_DEL023.jpg"],"operator":"李四","confirmed":true,"price":2359,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":46666,"amountWithTax":47132.66,"entryInfo":{"at":"2026-03-03 20:22","operator":"王门卫","photo":"entry_DEL023.jpg"},"entryWeighInfo":{"at":"2026-03-03 20:42","operator":"李四","photo":"weigh_in_DEL023.jpg"},"qualityInfo":{"at":"2026-03-03 20:57","operator":"张质检","photo":"quality_DEL023.jpg"},"exitWeighInfo":{"at":"2026-03-03 21:00","operator":"李四","photo":"weigh_out_DEL023.jpg"},"exitCheckInfo":{"at":"2026-03-03 21:22","operator":"王门卫","photo":"exit_DEL023.jpg"}},
    settlement: {"unitPrice":2359,"amount":35142,"confirmedBySupplier":true,"confirmedAt":"2026-03-04 17:12","settlementNo":"SET20260303014","mergedCount":4},
    invoice: {"no":"INV20260303005","type":"反向开票","amount":32920.95,"at":"2026-03-05 17:12","file":"invoice_DEL023.pdf","mergedCount":6},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-06 17:12","method":"银行转账","transactionNo":"TXN20260303013","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260306","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260303013","type":"银行回单","at":"2026-03-06 17:12","file":"PAY_VOUCHER_DEL023.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-03 17:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-03 20:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-03 21:12","status":"stored","action":"入库过磅 19.8吨","operator":"李四"},{"time":"03-03 22:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-04 17:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-05 17:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-06 17:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-03 17:12',
    updatedAt: '2026-03-03 17:12',
  },
  {
    id: 'DEL024',
    deliveryNo: 'DEL20260312024',
    orderId: 'ORD021',
    orderNo: 'ORD20260312021',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2361,
    stockInNo: null,
    settlementNo: null,
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260312024","time":"2026-03-12 13:12","vehicleNo":"苏B64337","driverName":"李师傅","driverPhone":"182788****4323"},
    arrival: {"at":"2026-03-12 14:12","photo":"arrival_DEL024.jpg","operator":"张三"},
    storage: null,
    settlement: null,
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.WAITING_APPROVAL,
    timeline: [{"time":"03-12 11:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-12 14:12","status":"arrived","action":"车辆到场","operator":"张三"}],
    createdAt: '2026-03-12 11:12',
    updatedAt: '2026-03-12 11:12',
  },
  {
    id: 'DEL025',
    deliveryNo: 'DEL20260312025',
    orderId: 'ORD021',
    orderNo: 'ORD20260312021',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B002',
    baseName: '马钢诚兴上海分公司',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2361,
    stockInNo: 'SI20260312015',
    settlementNo: null,
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260312025","time":"2026-03-12 15:12","vehicleNo":"苏A76263","driverName":"杨师傅","driverPhone":"148045****9229"},
    arrival: {"at":"2026-03-12 16:12","photo":"arrival_DEL025.jpg","operator":"张三"},
    storage: {"at":"2026-03-12 17:12","stockInNo":"SI20260312015","grossWeight":34,"tareWeight":15,"netWeight":19,"deduction":0.1,"actualWeight":18.9,"quality":"二级","photos":["plate_DEL025.jpg"],"operator":"李四","confirmed":true,"price":2361,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":44626,"amountWithTax":45072.26,"entryInfo":{"at":"2026-03-12 16:22","operator":"王门卫","photo":"entry_DEL025.jpg"},"entryWeighInfo":{"at":"2026-03-12 16:42","operator":"李四","photo":"weigh_in_DEL025.jpg"},"qualityInfo":{"at":"2026-03-12 16:57","operator":"张质检","photo":"quality_DEL025.jpg"},"exitWeighInfo":{"at":"2026-03-12 17:00","operator":"李四","photo":"weigh_out_DEL025.jpg"},"exitCheckInfo":{"at":"2026-03-12 17:22","operator":"王门卫","photo":"exit_DEL025.jpg"}},
    settlement: null,
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.STORED,
    timeline: [{"time":"03-12 13:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-12 16:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-12 17:12","status":"stored","action":"入库过磅 18.9吨","operator":"李四"}],
    createdAt: '2026-03-12 13:12',
    updatedAt: '2026-03-12 13:12',
  },
  {
    id: 'DEL026',
    deliveryNo: 'DEL20260308026',
    orderId: 'ORD025',
    orderNo: 'ORD20260308025',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    materialId: 'M002',
    materialName: '特级破碎料',
    price: 2560,
    stockInNo: 'SI20260308016',
    settlementNo: 'SET20260308018',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308026","time":"2026-03-08 13:12","vehicleNo":"浙A48701","driverName":"吴师傅","driverPhone":"142918****4630"},
    arrival: {"at":"2026-03-08 14:12","photo":"arrival_DEL026.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 15:12","stockInNo":"SI20260308016","grossWeight":22,"tareWeight":12,"netWeight":10,"deduction":0.74,"actualWeight":9.26,"quality":"二级","photos":["plate_DEL026.jpg"],"operator":"李四","confirmed":true,"price":2560,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":23700,"amountWithTax":23937,"entryInfo":{"at":"2026-03-08 14:22","operator":"王门卫","photo":"entry_DEL026.jpg"},"entryWeighInfo":{"at":"2026-03-08 14:42","operator":"李四","photo":"weigh_in_DEL026.jpg"},"qualityInfo":{"at":"2026-03-08 14:57","operator":"张质检","photo":"quality_DEL026.jpg"},"exitWeighInfo":{"at":"2026-03-08 15:00","operator":"李四","photo":"weigh_out_DEL026.jpg"},"exitCheckInfo":{"at":"2026-03-08 15:22","operator":"王门卫","photo":"exit_DEL026.jpg"}},
    settlement: {"unitPrice":2560,"amount":93280,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 11:12","settlementNo":"SET20260308018","mergedCount":3,"isMergedHead":true},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":31448.77,"at":"2026-03-10 11:12","file":"invoice_DEL026.pdf","mergedCount":10},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-11 11:12","method":"银行转账","transactionNo":"TXN20260308014","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260310","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260308014","type":"银行回单","at":"2026-03-11 11:12","file":"PAY_VOUCHER_DEL026.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 11:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 15:12","status":"stored","action":"入库过磅 9.3吨","operator":"李四"},{"time":"03-08 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 11:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 11:12',
    updatedAt: '2026-03-08 11:12',
  },
  {
    id: 'DEL027',
    deliveryNo: 'DEL20260308027',
    orderId: 'ORD025',
    orderNo: 'ORD20260308025',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    materialId: 'M002',
    materialName: '特级破碎料',
    price: 2560,
    stockInNo: 'SI20260308017',
    settlementNo: 'SET20260308018',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308027","time":"2026-03-08 15:12","vehicleNo":"浙J45369","driverName":"李师傅","driverPhone":"133817****6448"},
    arrival: {"at":"2026-03-08 16:12","photo":"arrival_DEL027.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 17:12","stockInNo":"SI20260308017","grossWeight":30,"tareWeight":16,"netWeight":14,"deduction":0.52,"actualWeight":13.48,"quality":"一级","photos":["plate_DEL027.jpg"],"operator":"李四","confirmed":true,"price":2560,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":34500,"amountWithTax":34845,"entryInfo":{"at":"2026-03-08 16:22","operator":"王门卫","photo":"entry_DEL027.jpg"},"entryWeighInfo":{"at":"2026-03-08 16:42","operator":"李四","photo":"weigh_in_DEL027.jpg"},"qualityInfo":{"at":"2026-03-08 16:57","operator":"张质检","photo":"quality_DEL027.jpg"},"exitWeighInfo":{"at":"2026-03-08 17:00","operator":"李四","photo":"weigh_out_DEL027.jpg"},"exitCheckInfo":{"at":"2026-03-08 17:22","operator":"王门卫","photo":"exit_DEL027.jpg"}},
    settlement: {"unitPrice":2560,"amount":31093,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 13:12","settlementNo":"SET20260308018","mergedCount":3},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":31448.77,"at":"2026-03-10 13:12","file":"invoice_DEL027.pdf","mergedCount":10},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-11 13:12","method":"银行转账","transactionNo":"TXN20260308015","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260311","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260308015","type":"银行回单","at":"2026-03-11 13:12","file":"PAY_VOUCHER_DEL027.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 13:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 16:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 17:12","status":"stored","action":"入库过磅 13.5吨","operator":"李四"},{"time":"03-08 18:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 13:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 13:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 13:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 13:12',
    updatedAt: '2026-03-08 13:12',
  },
  {
    id: 'DEL028',
    deliveryNo: 'DEL20260308028',
    orderId: 'ORD025',
    orderNo: 'ORD20260308025',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    materialId: 'M002',
    materialName: '特级破碎料',
    price: 2560,
    stockInNo: 'ST20260308005',
    settlementNo: 'SET20260308018',
    invoiceNo: 'INV20260308001',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260308028","time":"2026-03-08 17:12","vehicleNo":"苏B72354","driverName":"黄师傅","driverPhone":"143992****6958"},
    arrival: {"at":"2026-03-08 18:12","photo":"arrival_DEL028.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 19:12","stockInNo":"ST20260308005","grossWeight":28,"tareWeight":14,"netWeight":14,"deduction":0.3,"actualWeight":13.7,"quality":"合格","photos":["plate_DEL028.jpg"],"operator":"李四","confirmed":true,"price":2560,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":35080,"amountWithTax":35430.8,"entryInfo":{"at":"2026-03-08 18:22","operator":"王门卫","photo":"entry_DEL028.jpg"},"entryWeighInfo":{"at":"2026-03-08 18:42","operator":"李四","photo":"weigh_in_DEL028.jpg"},"qualityInfo":{"at":"2026-03-08 18:57","operator":"张质检","photo":"quality_DEL028.jpg"},"exitWeighInfo":{"at":"2026-03-08 19:00","operator":"李四","photo":"weigh_out_DEL028.jpg"},"exitCheckInfo":{"at":"2026-03-08 19:22","operator":"王门卫","photo":"exit_DEL028.jpg"}},
    settlement: {"unitPrice":2560,"amount":31093,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 15:12","settlementNo":"SET20260308018","mergedCount":3},
    invoice: {"no":"INV20260308001","type":"反向开票","amount":31448.77,"at":"2026-03-10 15:12","file":"invoice_DEL028.pdf","mergedCount":10},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-11 15:12","method":"银行转账","transactionNo":"TXN20260308016","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260311","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260308016","type":"银行回单","at":"2026-03-11 15:12","file":"PAY_VOUCHER_DEL028.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 15:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-08 18:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 19:12","status":"stored","action":"入库过磅 13.7吨","operator":"李四"},{"time":"03-08 20:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 15:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-10 15:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 15:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 15:12',
    updatedAt: '2026-03-08 15:12',
  },
  {
    id: 'DEL029',
    deliveryNo: 'DEL20260225029',
    orderId: 'ORD026',
    orderNo: 'ORD20260225026',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1006',
    supplierName: '郑十',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    materialId: 'M003',
    materialName: '统料废钢',
    price: 2343,
    stockInNo: 'SI20260225018',
    settlementNo: 'SET20260225021',
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260225029","time":"2026-02-25 13:12","vehicleNo":"苏B13249","driverName":"张师傅","driverPhone":"143750****3768"},
    arrival: {"at":"2026-02-25 14:12","photo":"arrival_DEL029.jpg","operator":"张三"},
    storage: {"at":"2026-02-25 15:12","stockInNo":"SI20260225018","grossWeight":31,"tareWeight":14,"netWeight":17,"deduction":0.98,"actualWeight":16.02,"quality":"一级","photos":["plate_DEL029.jpg"],"operator":"李四","confirmed":true,"price":2343,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":37545,"amountWithTax":37920.45,"entryInfo":{"at":"2026-02-25 14:22","operator":"王门卫","photo":"entry_DEL029.jpg"},"entryWeighInfo":{"at":"2026-02-25 14:42","operator":"李四","photo":"weigh_in_DEL029.jpg"},"qualityInfo":{"at":"2026-02-25 14:57","operator":"张质检","photo":"quality_DEL029.jpg"},"exitWeighInfo":{"at":"2026-02-25 15:00","operator":"李四","photo":"weigh_out_DEL029.jpg"},"exitCheckInfo":{"at":"2026-02-25 15:22","operator":"王门卫","photo":"exit_DEL029.jpg"}},
    settlement: {"unitPrice":2343,"amount":37545,"approved":false,"settlementNo":"SET20260225021"},
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.PENDING_SETTLEMENT,
    timeline: [{"time":"02-25 11:12","status":"waiting_delivery","action":"创建预约单","operator":"郑十"},{"time":"02-25 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"02-25 15:12","status":"stored","action":"入库过磅 16.0吨","operator":"李四"},{"time":"02-25 16:12","status":"pending_settlement","action":"生成结算单（审核中）","operator":"系统"}],
    createdAt: '2026-02-25 11:12',
    updatedAt: '2026-02-25 11:12',
  },
  {
    id: 'DEL030',
    deliveryNo: 'DEL20260222030',
    orderId: 'ORD027',
    orderNo: 'ORD20260222027',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1007',
    supplierName: '钱十一',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    materialId: 'M003',
    materialName: '统料废钢',
    price: 2310,
    stockInNo: 'SI20260222019',
    settlementNo: 'SET20260222022',
    invoiceNo: null,
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260222030","time":"2026-02-22 13:12","vehicleNo":"苏A98901","driverName":"王师傅","driverPhone":"186354****4533"},
    arrival: {"at":"2026-02-22 14:12","photo":"arrival_DEL030.jpg","operator":"张三"},
    storage: {"at":"2026-02-22 15:12","stockInNo":"SI20260222019","grossWeight":24,"tareWeight":16,"netWeight":8,"deduction":0.29,"actualWeight":7.71,"quality":"二级","photos":["plate_DEL030.jpg"],"operator":"李四","confirmed":true,"price":2310,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":17799,"amountWithTax":17976.99,"entryInfo":{"at":"2026-02-22 14:22","operator":"王门卫","photo":"entry_DEL030.jpg"},"entryWeighInfo":{"at":"2026-02-22 14:42","operator":"李四","photo":"weigh_in_DEL030.jpg"},"qualityInfo":{"at":"2026-02-22 14:57","operator":"张质检","photo":"quality_DEL030.jpg"},"exitWeighInfo":{"at":"2026-02-22 15:00","operator":"李四","photo":"weigh_out_DEL030.jpg"},"exitCheckInfo":{"at":"2026-02-22 15:22","operator":"王门卫","photo":"exit_DEL030.jpg"}},
    settlement: {"unitPrice":2310,"amount":17799,"approved":true,"settlementNo":"SET20260222022"},
    invoice: null,
    payment: null,
    status: DELIVERY_STATUS.PENDING_SETTLEMENT,
    timeline: [{"time":"02-22 11:12","status":"waiting_delivery","action":"创建预约单","operator":"钱十一"},{"time":"02-22 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"02-22 15:12","status":"stored","action":"入库过磅 7.7吨","operator":"李四"},{"time":"02-22 16:12","status":"pending_settlement","action":"生成结算单（待供应商确认）","operator":"系统"}],
    createdAt: '2026-02-22 11:12',
    updatedAt: '2026-02-22 11:12',
  },
  {
    id: 'DEL031',
    deliveryNo: 'DEL20260219031',
    orderId: 'ORD028',
    orderNo: 'ORD20260219028',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1010',
    supplierName: '刘十四',
    baseId: 'B004',
    baseName: '马钢诚兴南京分公司',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2446,
    stockInNo: 'ST20260219006',
    settlementNo: 'SET20260219023',
    invoiceNo: 'INV20260219019',
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260219031","time":"2026-02-19 13:12","vehicleNo":"浙A82923","driverName":"刘师傅","driverPhone":"177191****7814"},
    arrival: {"at":"2026-02-19 14:12","photo":"arrival_DEL031.jpg","operator":"张三"},
    storage: {"at":"2026-02-19 15:12","stockInNo":"ST20260219006","grossWeight":28,"tareWeight":13,"netWeight":15,"deduction":0.95,"actualWeight":14.05,"quality":"二级","photos":["plate_DEL031.jpg"],"operator":"李四","confirmed":true,"price":2446,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":34355,"amountWithTax":34698.55,"entryInfo":{"at":"2026-02-19 14:22","operator":"王门卫","photo":"entry_DEL031.jpg"},"entryWeighInfo":{"at":"2026-02-19 14:42","operator":"李四","photo":"weigh_in_DEL031.jpg"},"qualityInfo":{"at":"2026-02-19 14:57","operator":"张质检","photo":"quality_DEL031.jpg"},"exitWeighInfo":{"at":"2026-02-19 15:00","operator":"李四","photo":"weigh_out_DEL031.jpg"},"exitCheckInfo":{"at":"2026-02-19 15:22","operator":"王门卫","photo":"exit_DEL031.jpg"}},
    settlement: {"unitPrice":2446,"amount":34355,"confirmedBySupplier":true,"confirmedAt":"2026-02-20 11:12","settlementNo":"SET20260219023"},
    invoice: {"no":"INV20260219019","type":"反向开票","amount":34698.55,"at":"2026-02-21 11:12","file":"invoice_DEL031.pdf","pendingApproval":true},
    payment: null,
    status: DELIVERY_STATUS.INVOICED,
    timeline: [{"time":"02-19 11:12","status":"waiting_delivery","action":"创建预约单","operator":"刘十四"},{"time":"02-19 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"02-19 15:12","status":"stored","action":"入库过磅 14.0吨","operator":"李四"},{"time":"02-19 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"02-20 11:12","status":"settled","action":"供应商确认结算","operator":"刘十四"},{"time":"02-21 11:12","status":"invoiced","action":"开具发票（审批中）","operator":"财务"}],
    createdAt: '2026-02-19 11:12',
    updatedAt: '2026-02-19 11:12',
  },
  {
    id: 'DEL032',
    deliveryNo: 'DEL20260216032',
    orderId: 'ORD029',
    orderNo: 'ORD20260216029',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1011',
    supplierName: '陈十五',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    materialId: 'M003',
    materialName: '统料废钢',
    price: 2254,
    stockInNo: 'ST20260216007',
    settlementNo: 'SET20260216024',
    invoiceNo: 'INV20260216020',
    paymentNo: 'PAY20260216020',
    reservation: {"reservationNo":"RSV20260216032","time":"2026-02-16 13:12","vehicleNo":"苏A23829","driverName":"刘师傅","driverPhone":"186897****2233"},
    arrival: {"at":"2026-02-16 14:12","photo":"arrival_DEL032.jpg","operator":"张三"},
    storage: {"at":"2026-02-16 15:12","stockInNo":"ST20260216007","grossWeight":21,"tareWeight":16,"netWeight":5,"deduction":0.76,"actualWeight":4.24,"quality":"合格","photos":["plate_DEL032.jpg"],"operator":"李四","confirmed":true,"price":2254,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":9568,"amountWithTax":9663.68,"entryInfo":{"at":"2026-02-16 14:22","operator":"王门卫","photo":"entry_DEL032.jpg"},"entryWeighInfo":{"at":"2026-02-16 14:42","operator":"李四","photo":"weigh_in_DEL032.jpg"},"qualityInfo":{"at":"2026-02-16 14:57","operator":"张质检","photo":"quality_DEL032.jpg"},"exitWeighInfo":{"at":"2026-02-16 15:00","operator":"李四","photo":"weigh_out_DEL032.jpg"},"exitCheckInfo":{"at":"2026-02-16 15:22","operator":"王门卫","photo":"exit_DEL032.jpg"}},
    settlement: {"unitPrice":2254,"amount":9568,"confirmedBySupplier":true,"confirmedAt":"2026-02-17 11:12","settlementNo":"SET20260216024"},
    invoice: {"no":"INV20260216020","type":"反向开票","amount":9663.68,"at":"2026-02-18 11:12","file":"invoice_DEL032.pdf"},
    payment: {"no":"PAY20260216020","amount":9663.68,"at":null,"method":"银行转账","transactionNo":null,"bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260218","requiredAmount":9663.68,"paidAmount":0,"pendingPay":true},
    status: DELIVERY_STATUS.INVOICED,
    timeline: [{"time":"02-16 11:12","status":"waiting_delivery","action":"创建预约单","operator":"陈十五"},{"time":"02-16 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"02-16 15:12","status":"stored","action":"入库过磅 4.2吨","operator":"李四"},{"time":"02-16 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"02-17 11:12","status":"settled","action":"供应商确认结算","operator":"陈十五"},{"time":"02-18 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"02-18 16:12","status":"invoiced","action":"发起付款申请（待付款）","operator":"财务"}],
    createdAt: '2026-02-16 11:12',
    updatedAt: '2026-02-16 11:12',
  },
  {
    id: 'DEL033',
    deliveryNo: 'DEL20260213033',
    orderId: 'ORD030',
    orderNo: 'ORD20260213030',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1012',
    supplierName: '黄十六',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2455,
    stockInNo: 'SI20260213020',
    settlementNo: 'SET20260213025',
    invoiceNo: 'INV20260213021',
    paymentNo: 'PAY20260213021',
    reservation: {"reservationNo":"RSV20260213033","time":"2026-02-13 13:12","vehicleNo":"苏A83409","driverName":"陈师傅","driverPhone":"143517****8991"},
    arrival: {"at":"2026-02-13 14:12","photo":"arrival_DEL033.jpg","operator":"张三"},
    storage: {"at":"2026-02-13 15:12","stockInNo":"SI20260213020","grossWeight":28,"tareWeight":15,"netWeight":13,"deduction":0.37,"actualWeight":12.63,"quality":"一级","photos":["plate_DEL033.jpg"],"operator":"李四","confirmed":true,"price":2455,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":30999,"amountWithTax":31308.99,"entryInfo":{"at":"2026-02-13 14:22","operator":"王门卫","photo":"entry_DEL033.jpg"},"entryWeighInfo":{"at":"2026-02-13 14:42","operator":"李四","photo":"weigh_in_DEL033.jpg"},"qualityInfo":{"at":"2026-02-13 14:57","operator":"张质检","photo":"quality_DEL033.jpg"},"exitWeighInfo":{"at":"2026-02-13 15:00","operator":"李四","photo":"weigh_out_DEL033.jpg"},"exitCheckInfo":{"at":"2026-02-13 15:22","operator":"王门卫","photo":"exit_DEL033.jpg"}},
    settlement: {"unitPrice":2455,"amount":30999,"confirmedBySupplier":true,"confirmedAt":"2026-02-14 11:12","settlementNo":"SET20260213025"},
    invoice: {"no":"INV20260213021","type":"反向开票","amount":31308.99,"at":"2026-02-15 11:12","file":"invoice_DEL033.pdf"},
    payment: {"no":"PAY20260213021","amount":101397.94,"at":"2026-02-16 11:12","method":"银行转账","transactionNo":"TXN20260213021","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260215","requiredAmount":101397.94,"paidAmount":101397.94,"voucher":{"no":"VCH20260213021","type":"银行回单","at":"2026-02-16 11:12","file":"PAY_VOUCHER_DEL033.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260213021","INV20260310024","INV20260309025"],"isMergedHead":true,"invoiceMergedCount":3},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"02-13 11:12","status":"waiting_delivery","action":"创建预约单","operator":"黄十六"},{"time":"02-13 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"02-13 15:12","status":"stored","action":"入库过磅 12.6吨","operator":"李四"},{"time":"02-13 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"02-14 11:12","status":"settled","action":"供应商确认结算","operator":"黄十六"},{"time":"02-15 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"02-16 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-02-13 11:12',
    updatedAt: '2026-02-13 11:12',
  },
  {
    id: 'DEL034',
    deliveryNo: 'DEL20260312034',
    orderId: 'ORD031',
    orderNo: 'ORD20260312031',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1004',
    supplierName: '周八',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2380,
    stockInNo: 'SI20260312021',
    settlementNo: 'SET20260312026',
    invoiceNo: 'INV20260312022',
    paymentNo: 'PAY20260312022',
    reservation: {"reservationNo":"RSV20260312034","time":"2026-03-12 13:12","vehicleNo":"浙A50754","driverName":"李师傅","driverPhone":"139068****9698"},
    arrival: {"at":"2026-03-12 14:12","photo":"arrival_DEL034.jpg","operator":"张三"},
    storage: {"at":"2026-03-12 15:12","stockInNo":"SI20260312021","grossWeight":32,"tareWeight":16,"netWeight":16,"deduction":0.89,"actualWeight":15.11,"quality":"一级","photos":["plate_DEL034.jpg"],"operator":"李四","confirmed":true,"price":2380,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":35968,"amountWithTax":36327.68,"entryInfo":{"at":"2026-03-12 14:22","operator":"王门卫","photo":"entry_DEL034.jpg"},"entryWeighInfo":{"at":"2026-03-12 14:42","operator":"李四","photo":"weigh_in_DEL034.jpg"},"qualityInfo":{"at":"2026-03-12 14:57","operator":"张质检","photo":"quality_DEL034.jpg"},"exitWeighInfo":{"at":"2026-03-12 15:00","operator":"李四","photo":"weigh_out_DEL034.jpg"},"exitCheckInfo":{"at":"2026-03-12 15:22","operator":"王门卫","photo":"exit_DEL034.jpg"}},
    settlement: {"unitPrice":2380,"amount":35968,"confirmedBySupplier":true,"confirmedAt":"2026-03-13 11:12","settlementNo":"SET20260312026"},
    invoice: {"no":"INV20260312022","type":"反向开票","amount":36327.68,"at":"2026-03-14 11:12","file":"invoice_DEL034.pdf"},
    payment: {"no":"PAY20260312022","amount":84238.04000000001,"at":"2026-03-15 11:12","method":"银行转账","transactionNo":"TXN20260312022","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260314","requiredAmount":84238.04000000001,"paidAmount":84238.04000000001,"voucher":{"no":"VCH20260312022","type":"银行回单","at":"2026-03-15 11:12","file":"PAY_VOUCHER_DEL034.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260312022","INV20260308026","INV20260306028"],"isMergedHead":true,"invoiceMergedCount":3},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-12 11:12","status":"waiting_delivery","action":"创建预约单","operator":"周八"},{"time":"03-12 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-12 15:12","status":"stored","action":"入库过磅 15.1吨","operator":"李四"},{"time":"03-12 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-13 11:12","status":"settled","action":"供应商确认结算","operator":"周八"},{"time":"03-14 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-15 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-12 11:12',
    updatedAt: '2026-03-12 11:12',
  },
  {
    id: 'DEL035',
    deliveryNo: 'DEL20260311035',
    orderId: 'ORD032',
    orderNo: 'ORD20260311032',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1005',
    supplierName: '吴九',
    baseId: 'B005',
    baseName: '马钢诚兴无锡基地',
    materialId: 'M004',
    materialName: '轻薄料',
    price: 1907,
    stockInNo: 'SI20260311022',
    settlementNo: 'SET20260311027',
    invoiceNo: 'INV20260311023',
    paymentNo: 'PAY20260308001',
    reservation: {"reservationNo":"RSV20260311035","time":"2026-03-11 13:12","vehicleNo":"苏B74440","driverName":"吴师傅","driverPhone":"171580****3918"},
    arrival: {"at":"2026-03-11 14:12","photo":"arrival_DEL035.jpg","operator":"张三"},
    storage: {"at":"2026-03-11 15:12","stockInNo":"SI20260311022","grossWeight":30,"tareWeight":14,"netWeight":16,"deduction":0.83,"actualWeight":15.17,"quality":"一级","photos":["plate_DEL035.jpg"],"operator":"李四","confirmed":true,"price":1907,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":28925,"amountWithTax":29214.25,"entryInfo":{"at":"2026-03-11 14:22","operator":"王门卫","photo":"entry_DEL035.jpg"},"entryWeighInfo":{"at":"2026-03-11 14:42","operator":"李四","photo":"weigh_in_DEL035.jpg"},"qualityInfo":{"at":"2026-03-11 14:57","operator":"张质检","photo":"quality_DEL035.jpg"},"exitWeighInfo":{"at":"2026-03-11 15:00","operator":"李四","photo":"weigh_out_DEL035.jpg"},"exitCheckInfo":{"at":"2026-03-11 15:22","operator":"王门卫","photo":"exit_DEL035.jpg"}},
    settlement: {"unitPrice":1907,"amount":28925,"confirmedBySupplier":true,"confirmedAt":"2026-03-12 11:12","settlementNo":"SET20260311027"},
    invoice: {"no":"INV20260311023","type":"反向开票","amount":29214.25,"at":"2026-03-13 11:12","file":"invoice_DEL035.pdf"},
    payment: {"no":"PAY20260308001","amount":31836.92,"at":"2026-03-14 11:12","method":"银行转账","transactionNo":"TXN20260311023","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260313","requiredAmount":31836.92,"paidAmount":31836.92,"voucher":{"no":"VCH20260311023","type":"银行回单","at":"2026-03-14 11:12","file":"PAY_VOUCHER_DEL035.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260308001","INV20260303005","INV20260311023"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-11 11:12","status":"waiting_delivery","action":"创建预约单","operator":"吴九"},{"time":"03-11 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-11 15:12","status":"stored","action":"入库过磅 15.2吨","operator":"李四"},{"time":"03-11 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-12 11:12","status":"settled","action":"供应商确认结算","operator":"吴九"},{"time":"03-13 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-14 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-11 11:12',
    updatedAt: '2026-03-11 11:12',
  },
  {
    id: 'DEL036',
    deliveryNo: 'DEL20260310036',
    orderId: 'ORD033',
    orderNo: 'ORD20260310033',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1012',
    supplierName: '黄十六',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    materialId: 'M003',
    materialName: '统料废钢',
    price: 2295,
    stockInNo: 'SI20260310023',
    settlementNo: 'SET20260310028',
    invoiceNo: 'INV20260310024',
    paymentNo: 'PAY20260213021',
    reservation: {"reservationNo":"RSV20260310036","time":"2026-03-10 13:12","vehicleNo":"沪A79947","driverName":"黄师傅","driverPhone":"147994****1281"},
    arrival: {"at":"2026-03-10 14:12","photo":"arrival_DEL036.jpg","operator":"张三"},
    storage: {"at":"2026-03-10 15:12","stockInNo":"SI20260310023","grossWeight":29,"tareWeight":15,"netWeight":14,"deduction":0.19,"actualWeight":13.81,"quality":"合格","photos":["plate_DEL036.jpg"],"operator":"李四","confirmed":true,"price":2295,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":31700,"amountWithTax":32017,"entryInfo":{"at":"2026-03-10 14:22","operator":"王门卫","photo":"entry_DEL036.jpg"},"entryWeighInfo":{"at":"2026-03-10 14:42","operator":"李四","photo":"weigh_in_DEL036.jpg"},"qualityInfo":{"at":"2026-03-10 14:57","operator":"张质检","photo":"quality_DEL036.jpg"},"exitWeighInfo":{"at":"2026-03-10 15:00","operator":"李四","photo":"weigh_out_DEL036.jpg"},"exitCheckInfo":{"at":"2026-03-10 15:22","operator":"王门卫","photo":"exit_DEL036.jpg"}},
    settlement: {"unitPrice":2295,"amount":31700,"confirmedBySupplier":true,"confirmedAt":"2026-03-11 11:12","settlementNo":"SET20260310028"},
    invoice: {"no":"INV20260310024","type":"反向开票","amount":32017,"at":"2026-03-12 11:12","file":"invoice_DEL036.pdf"},
    payment: {"no":"PAY20260213021","amount":33799.31,"at":"2026-03-13 11:12","method":"银行转账","transactionNo":"TXN20260310024","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260312","requiredAmount":33799.31,"paidAmount":33799.31,"voucher":{"no":"VCH20260310024","type":"银行回单","at":"2026-03-13 11:12","file":"PAY_VOUCHER_DEL036.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260213021","INV20260310024","INV20260309025"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-10 11:12","status":"waiting_delivery","action":"创建预约单","operator":"黄十六"},{"time":"03-10 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-10 15:12","status":"stored","action":"入库过磅 13.8吨","operator":"李四"},{"time":"03-10 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-11 11:12","status":"settled","action":"供应商确认结算","operator":"黄十六"},{"time":"03-12 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-13 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-10 11:12',
    updatedAt: '2026-03-10 11:12',
  },
  {
    id: 'DEL037',
    deliveryNo: 'DEL20260309037',
    orderId: 'ORD034',
    orderNo: 'ORD20260309034',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1012',
    supplierName: '黄十六',
    baseId: 'B004',
    baseName: '马钢诚兴南京分公司',
    materialId: 'M001',
    materialName: '工业重废毛料',
    price: 2464,
    stockInNo: 'ST20260309008',
    settlementNo: 'SET20260309029',
    invoiceNo: 'INV20260309025',
    paymentNo: 'PAY20260213021',
    reservation: {"reservationNo":"RSV20260309037","time":"2026-03-09 13:12","vehicleNo":"浙A16908","driverName":"赵师傅","driverPhone":"148113****7098"},
    arrival: {"at":"2026-03-09 14:12","photo":"arrival_DEL037.jpg","operator":"张三"},
    storage: {"at":"2026-03-09 15:12","stockInNo":"ST20260309008","grossWeight":30,"tareWeight":14,"netWeight":16,"deduction":0.7,"actualWeight":15.3,"quality":"一级","photos":["plate_DEL037.jpg"],"operator":"李四","confirmed":true,"price":2464,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":37695,"amountWithTax":38071.95,"entryInfo":{"at":"2026-03-09 14:22","operator":"王门卫","photo":"entry_DEL037.jpg"},"entryWeighInfo":{"at":"2026-03-09 14:42","operator":"李四","photo":"weigh_in_DEL037.jpg"},"qualityInfo":{"at":"2026-03-09 14:57","operator":"张质检","photo":"quality_DEL037.jpg"},"exitWeighInfo":{"at":"2026-03-09 15:00","operator":"李四","photo":"weigh_out_DEL037.jpg"},"exitCheckInfo":{"at":"2026-03-09 15:22","operator":"王门卫","photo":"exit_DEL037.jpg"}},
    settlement: {"unitPrice":2464,"amount":37695,"confirmedBySupplier":true,"confirmedAt":"2026-03-10 11:12","settlementNo":"SET20260309029"},
    invoice: {"no":"INV20260309025","type":"反向开票","amount":38071.95,"at":"2026-03-11 11:12","file":"invoice_DEL037.pdf"},
    payment: {"no":"PAY20260213021","amount":33799.31,"at":"2026-03-12 11:12","method":"银行转账","transactionNo":"TXN20260309025","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260311","requiredAmount":33799.31,"paidAmount":33799.31,"voucher":{"no":"VCH20260309025","type":"银行回单","at":"2026-03-12 11:12","file":"PAY_VOUCHER_DEL037.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260213021","INV20260310024","INV20260309025"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-09 11:12","status":"waiting_delivery","action":"创建预约单","operator":"黄十六"},{"time":"03-09 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-09 15:12","status":"stored","action":"入库过磅 15.3吨","operator":"李四"},{"time":"03-09 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-10 11:12","status":"settled","action":"供应商确认结算","operator":"黄十六"},{"time":"03-11 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-12 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-09 11:12',
    updatedAt: '2026-03-09 11:12',
  },
  {
    id: 'DEL038',
    deliveryNo: 'DEL20260308038',
    orderId: 'ORD035',
    orderNo: 'ORD20260308035',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1004',
    supplierName: '周八',
    baseId: 'B003',
    baseName: '马钢诚兴杭州湾基地',
    materialId: 'M005',
    materialName: '钢筋头',
    price: 2403,
    stockInNo: 'ST20260308009',
    settlementNo: 'SET20260308030',
    invoiceNo: 'INV20260308026',
    paymentNo: 'PAY20260312022',
    reservation: {"reservationNo":"RSV20260308038","time":"2026-03-08 13:12","vehicleNo":"苏B31674","driverName":"刘师傅","driverPhone":"147692****5431"},
    arrival: {"at":"2026-03-08 14:12","photo":"arrival_DEL038.jpg","operator":"张三"},
    storage: {"at":"2026-03-08 15:12","stockInNo":"ST20260308009","grossWeight":24,"tareWeight":15,"netWeight":9,"deduction":0.05,"actualWeight":8.95,"quality":"合格","photos":["plate_DEL038.jpg"],"operator":"李四","confirmed":true,"price":2403,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":21498,"amountWithTax":21712.98,"entryInfo":{"at":"2026-03-08 14:22","operator":"王门卫","photo":"entry_DEL038.jpg"},"entryWeighInfo":{"at":"2026-03-08 14:42","operator":"李四","photo":"weigh_in_DEL038.jpg"},"qualityInfo":{"at":"2026-03-08 14:57","operator":"张质检","photo":"quality_DEL038.jpg"},"exitWeighInfo":{"at":"2026-03-08 15:00","operator":"李四","photo":"weigh_out_DEL038.jpg"},"exitCheckInfo":{"at":"2026-03-08 15:22","operator":"王门卫","photo":"exit_DEL038.jpg"}},
    settlement: {"unitPrice":2403,"amount":21498,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 11:12","settlementNo":"SET20260308030"},
    invoice: {"no":"INV20260308026","type":"反向开票","amount":21712.98,"at":"2026-03-10 11:12","file":"invoice_DEL038.pdf"},
    payment: {"no":"PAY20260312022","amount":28079.35,"at":"2026-03-11 11:12","method":"银行转账","transactionNo":"TXN20260308026","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260310","requiredAmount":28079.35,"paidAmount":28079.35,"voucher":{"no":"VCH20260308026","type":"银行回单","at":"2026-03-11 11:12","file":"PAY_VOUCHER_DEL038.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260312022","INV20260308026","INV20260306028"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-08 11:12","status":"waiting_delivery","action":"创建预约单","operator":"周八"},{"time":"03-08 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-08 15:12","status":"stored","action":"入库过磅 8.9吨","operator":"李四"},{"time":"03-08 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-09 11:12","status":"settled","action":"供应商确认结算","operator":"周八"},{"time":"03-10 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-11 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-08 11:12',
    updatedAt: '2026-03-08 11:12',
  },
  {
    id: 'DEL039',
    deliveryNo: 'DEL20260307039',
    orderId: 'ORD036',
    orderNo: 'ORD20260307036',
    orderStatus: ORDER_STATUS.IN_PROGRESS,
    supplierId: 'S1001',
    supplierName: '王五',
    baseId: 'B001',
    baseName: '马钢诚兴台州基地',
    materialId: 'M003',
    materialName: '统料废钢',
    price: 2341,
    stockInNo: 'SI20260307024',
    settlementNo: 'SET20260307031',
    invoiceNo: 'INV20260307027',
    paymentNo: null,
    reservation: {"reservationNo":"RSV20260307039","time":"2026-03-07 13:12","vehicleNo":"苏B92559","driverName":"张师傅","driverPhone":"134903****1565"},
    arrival: {"at":"2026-03-07 14:12","photo":"arrival_DEL039.jpg","operator":"张三"},
    storage: {"at":"2026-03-07 15:12","stockInNo":"SI20260307024","grossWeight":25,"tareWeight":12,"netWeight":13,"deduction":0.71,"actualWeight":12.29,"quality":"合格","photos":["plate_DEL039.jpg"],"operator":"李四","confirmed":true,"price":2341,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":28764,"amountWithTax":29051.64,"entryInfo":{"at":"2026-03-07 14:22","operator":"王门卫","photo":"entry_DEL039.jpg"},"entryWeighInfo":{"at":"2026-03-07 14:42","operator":"李四","photo":"weigh_in_DEL039.jpg"},"qualityInfo":{"at":"2026-03-07 14:57","operator":"张质检","photo":"quality_DEL039.jpg"},"exitWeighInfo":{"at":"2026-03-07 15:00","operator":"李四","photo":"weigh_out_DEL039.jpg"},"exitCheckInfo":{"at":"2026-03-07 15:22","operator":"王门卫","photo":"exit_DEL039.jpg"}},
    settlement: {"unitPrice":2341,"amount":28764,"confirmedBySupplier":true,"confirmedAt":"2026-03-08 11:12","settlementNo":"SET20260307031"},
    invoice: {"no":"INV20260307027","type":"反向开票","amount":29051.64,"at":"2026-03-09 11:12","file":"invoice_DEL039.pdf","pendingApproval":true},
    payment: null,
    status: DELIVERY_STATUS.INVOICED,
    timeline: [{"time":"03-07 11:12","status":"waiting_delivery","action":"创建预约单","operator":"王五"},{"time":"03-07 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-07 15:12","status":"stored","action":"入库过磅 12.3吨","operator":"李四"},{"time":"03-07 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-08 11:12","status":"settled","action":"供应商确认结算","operator":"王五"},{"time":"03-09 11:12","status":"invoiced","action":"开具发票（审批中）","operator":"财务"}],
    createdAt: '2026-03-07 11:12',
    updatedAt: '2026-03-07 11:12',
  },
  {
    id: 'DEL040',
    deliveryNo: 'DEL20260306040',
    orderId: 'ORD037',
    orderNo: 'ORD20260306037',
    orderStatus: ORDER_STATUS.COMPLETED,
    supplierId: 'S1004',
    supplierName: '周八',
    baseId: 'B004',
    baseName: '马钢诚兴南京分公司',
    materialId: 'M003',
    materialName: '统料废钢',
    price: 2242,
    stockInNo: 'SI20260306025',
    settlementNo: 'SET20260306032',
    invoiceNo: 'INV20260306028',
    paymentNo: 'PAY20260312022',
    reservation: {"reservationNo":"RSV20260306040","time":"2026-03-06 13:12","vehicleNo":"沪A19754","driverName":"吴师傅","driverPhone":"133819****9563"},
    arrival: {"at":"2026-03-06 14:12","photo":"arrival_DEL040.jpg","operator":"张三"},
    storage: {"at":"2026-03-06 15:12","stockInNo":"SI20260306025","grossWeight":26,"tareWeight":14,"netWeight":12,"deduction":0.43,"actualWeight":11.57,"quality":"二级","photos":["plate_DEL040.jpg"],"operator":"李四","confirmed":true,"price":2242,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":25938,"amountWithTax":26197.38,"entryInfo":{"at":"2026-03-06 14:22","operator":"王门卫","photo":"entry_DEL040.jpg"},"entryWeighInfo":{"at":"2026-03-06 14:42","operator":"李四","photo":"weigh_in_DEL040.jpg"},"qualityInfo":{"at":"2026-03-06 14:57","operator":"张质检","photo":"quality_DEL040.jpg"},"exitWeighInfo":{"at":"2026-03-06 15:00","operator":"李四","photo":"weigh_out_DEL040.jpg"},"exitCheckInfo":{"at":"2026-03-06 15:22","operator":"王门卫","photo":"exit_DEL040.jpg"}},
    settlement: {"unitPrice":2242,"amount":25938,"confirmedBySupplier":true,"confirmedAt":"2026-03-07 11:12","settlementNo":"SET20260306032"},
    invoice: {"no":"INV20260306028","type":"反向开票","amount":26197.38,"at":"2026-03-08 11:12","file":"invoice_DEL040.pdf"},
    payment: {"no":"PAY20260312022","amount":28079.35,"at":"2026-03-09 11:12","method":"银行转账","transactionNo":"TXN20260306028","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260308","requiredAmount":28079.35,"paidAmount":28079.35,"voucher":{"no":"VCH20260306028","type":"银行回单","at":"2026-03-09 11:12","file":"PAY_VOUCHER_DEL040.pdf"},"mergedCount":3,"sourceInvoiceNos":["INV20260312022","INV20260308026","INV20260306028"]},
    status: DELIVERY_STATUS.PAID,
    timeline: [{"time":"03-06 11:12","status":"waiting_delivery","action":"创建预约单","operator":"周八"},{"time":"03-06 14:12","status":"arrived","action":"车辆到场","operator":"张三"},{"time":"03-06 15:12","status":"stored","action":"入库过磅 11.6吨","operator":"李四"},{"time":"03-06 16:12","status":"pending_settlement","action":"生成结算单","operator":"系统"},{"time":"03-07 11:12","status":"settled","action":"供应商确认结算","operator":"周八"},{"time":"03-08 11:12","status":"invoiced","action":"开具发票","operator":"财务"},{"time":"03-09 11:12","status":"paid","action":"完成付款","operator":"财务"}],
    createdAt: '2026-03-06 11:12',
    updatedAt: '2026-03-06 11:12',
  }
];

// ============ 其他数据 ============

export const mockSettlements = [
  {"id":"SET20260308001","settlementNo":"SET20260308001","deliveryNos":["DEL20260308003","DEL20260308004","DEL20260308005","DEL20260308006"],"stockInNos":["SI20260308001","SI20260308002","ST20260308001","SI20260308003"],"orderNos":["ORD20260308005"],"supplierId":"S1005","supplierName":"吴九","baseId":"B001","baseName":"马钢诚兴台州基地","unitPrice":2517,"amount":206043,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 11:12","createdAt":"2026-03-09 11:12","updatedAt":"2026-03-09 11:12","status":"已确认"},
  {"id":"SET20260307005","settlementNo":"SET20260307005","deliveryNos":["DEL20260307007"],"stockInNos":["SI20260307004"],"orderNos":["ORD20260307006"],"supplierId":"S1001","supplierName":"王五","baseId":"B002","baseName":"马钢诚兴上海分公司","unitPrice":2377,"amount":31135,"confirmedBySupplier":true,"confirmedAt":"2026-03-08 11:12","createdAt":"2026-03-08 11:12","updatedAt":"2026-03-08 11:12","status":"已确认"},
  {"id":"SET20260303006","settlementNo":"SET20260303006","deliveryNos":["DEL20260303011","DEL20260303012"],"stockInNos":["SI20260303005","SI20260303006"],"orderNos":["ORD20260303010"],"supplierId":"S1005","supplierName":"吴九","baseId":"B002","baseName":"马钢诚兴上海分公司","unitPrice":2407,"amount":82506,"confirmedBySupplier":true,"confirmedAt":"2026-03-04 11:12","createdAt":"2026-03-04 11:12","updatedAt":"2026-03-04 11:12","status":"已确认"},
  {"id":"SET20260312008","settlementNo":"SET20260312008","deliveryNos":["DEL20260312013","DEL20260312014"],"stockInNos":["SI20260312007","ST20260312002"],"orderNos":["ORD20260312011"],"supplierId":"S1001","supplierName":"王五","baseId":"B002","baseName":"马钢诚兴上海分公司","unitPrice":2400,"amount":76703,"confirmedBySupplier":true,"confirmedAt":null,"createdAt":"2026-03-12 15:12","updatedAt":null,"status":"待确认"},
  {"id":"SET20260308010","settlementNo":"SET20260308010","deliveryNos":["DEL20260308015","DEL20260308016","DEL20260308017"],"stockInNos":["SI20260308008","SI20260308009","ST20260308003"],"orderNos":["ORD20260308015"],"supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","unitPrice":2529,"amount":167260,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 11:12","createdAt":"2026-03-09 11:12","updatedAt":"2026-03-09 11:12","status":"已确认"},
  {"id":"SET20260307013","settlementNo":"SET20260307013","deliveryNos":["DEL20260307019"],"stockInNos":["SI20260307011"],"orderNos":["ORD20260307016"],"supplierId":"S1001","supplierName":"王五","baseId":"B003","baseName":"马钢诚兴杭州湾基地","unitPrice":2185,"amount":27438,"confirmedBySupplier":true,"confirmedAt":null,"createdAt":"2026-03-07 17:12","updatedAt":null,"status":"待确认"},
  {"id":"SET20260303014","settlementNo":"SET20260303014","deliveryNos":["DEL20260303020","DEL20260303021","DEL20260303022","DEL20260303023"],"stockInNos":["SI20260303012","ST20260303004","SI20260303013","SI20260303014"],"orderNos":["ORD20260303020"],"supplierId":"S1005","supplierName":"吴九","baseId":"B002","baseName":"马钢诚兴上海分公司","unitPrice":2359,"amount":245992,"confirmedBySupplier":true,"confirmedAt":"2026-03-04 11:12","createdAt":"2026-03-04 11:12","updatedAt":"2026-03-04 11:12","status":"已确认"},
  {"id":"SET20260308018","settlementNo":"SET20260308018","deliveryNos":["DEL20260308026","DEL20260308027","DEL20260308028"],"stockInNos":["SI20260308016","SI20260308017","ST20260308005"],"orderNos":["ORD20260308025"],"supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","unitPrice":2560,"amount":155466,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 11:12","createdAt":"2026-03-09 11:12","updatedAt":"2026-03-09 11:12","status":"已确认"},
  {"id":"SET20260225021","settlementNo":"SET20260225021","deliveryNos":["DEL20260225029"],"stockInNos":["SI20260225018"],"orderNos":["ORD20260225026"],"supplierId":"S1006","supplierName":"郑十","baseId":"B001","baseName":"马钢诚兴台州基地","unitPrice":2343,"amount":37545,"approved":false,"confirmedBySupplier":false,"confirmedAt":null,"createdAt":"2026-02-26 11:12","updatedAt":"2026-02-26 11:12","status":"审核中"},
  {"id":"SET20260222022","settlementNo":"SET20260222022","deliveryNos":["DEL20260222030"],"stockInNos":["SI20260222019"],"orderNos":["ORD20260222027"],"supplierId":"S1007","supplierName":"钱十一","baseId":"B005","baseName":"马钢诚兴无锡基地","unitPrice":2310,"amount":17799,"approved":true,"confirmedBySupplier":false,"confirmedAt":null,"createdAt":"2026-02-22 16:12","updatedAt":"2026-02-22 16:12","status":"待确认"},
  {"id":"SET20260219023","settlementNo":"SET20260219023","deliveryNos":["DEL20260219031"],"stockInNos":["ST20260219006"],"orderNos":["ORD20260219028"],"supplierId":"S1010","supplierName":"刘十四","baseId":"B004","baseName":"马钢诚兴南京分公司","unitPrice":2446,"amount":34355,"confirmedBySupplier":true,"confirmedAt":"2026-02-20 11:12","createdAt":"2026-02-20 11:12","updatedAt":"2026-02-20 11:12","status":"已确认"},
  {"id":"SET20260216024","settlementNo":"SET20260216024","deliveryNos":["DEL20260216032"],"stockInNos":["ST20260216007"],"orderNos":["ORD20260216029"],"supplierId":"S1011","supplierName":"陈十五","baseId":"B003","baseName":"马钢诚兴杭州湾基地","unitPrice":2254,"amount":9568,"confirmedBySupplier":true,"confirmedAt":"2026-02-17 11:12","createdAt":"2026-02-17 11:12","updatedAt":"2026-02-17 11:12","status":"已确认"},
  {"id":"SET20260213025","settlementNo":"SET20260213025","deliveryNos":["DEL20260213033"],"stockInNos":["SI20260213020"],"orderNos":["ORD20260213030"],"supplierId":"S1012","supplierName":"黄十六","baseId":"B003","baseName":"马钢诚兴杭州湾基地","unitPrice":2455,"amount":30999,"confirmedBySupplier":true,"confirmedAt":"2026-02-14 11:12","createdAt":"2026-02-14 11:12","updatedAt":"2026-02-14 11:12","status":"已确认"},
  {"id":"SET20260312026","settlementNo":"SET20260312026","deliveryNos":["DEL20260312034"],"stockInNos":["SI20260312021"],"orderNos":["ORD20260312031"],"supplierId":"S1004","supplierName":"周八","baseId":"B003","baseName":"马钢诚兴杭州湾基地","unitPrice":2380,"amount":35968,"confirmedBySupplier":true,"confirmedAt":"2026-03-13 11:12","createdAt":"2026-03-13 11:12","updatedAt":"2026-03-13 11:12","status":"已确认"},
  {"id":"SET20260311027","settlementNo":"SET20260311027","deliveryNos":["DEL20260311035"],"stockInNos":["SI20260311022"],"orderNos":["ORD20260311032"],"supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","unitPrice":1907,"amount":28925,"confirmedBySupplier":true,"confirmedAt":"2026-03-12 11:12","createdAt":"2026-03-12 11:12","updatedAt":"2026-03-12 11:12","status":"已确认"},
  {"id":"SET20260310028","settlementNo":"SET20260310028","deliveryNos":["DEL20260310036"],"stockInNos":["SI20260310023"],"orderNos":["ORD20260310033"],"supplierId":"S1012","supplierName":"黄十六","baseId":"B001","baseName":"马钢诚兴台州基地","unitPrice":2295,"amount":31700,"confirmedBySupplier":true,"confirmedAt":"2026-03-11 11:12","createdAt":"2026-03-11 11:12","updatedAt":"2026-03-11 11:12","status":"已确认"},
  {"id":"SET20260309029","settlementNo":"SET20260309029","deliveryNos":["DEL20260309037"],"stockInNos":["ST20260309008"],"orderNos":["ORD20260309034"],"supplierId":"S1012","supplierName":"黄十六","baseId":"B004","baseName":"马钢诚兴南京分公司","unitPrice":2464,"amount":37695,"confirmedBySupplier":true,"confirmedAt":"2026-03-10 11:12","createdAt":"2026-03-10 11:12","updatedAt":"2026-03-10 11:12","status":"已确认"},
  {"id":"SET20260308030","settlementNo":"SET20260308030","deliveryNos":["DEL20260308038"],"stockInNos":["ST20260308009"],"orderNos":["ORD20260308035"],"supplierId":"S1004","supplierName":"周八","baseId":"B003","baseName":"马钢诚兴杭州湾基地","unitPrice":2403,"amount":21498,"confirmedBySupplier":true,"confirmedAt":"2026-03-09 11:12","createdAt":"2026-03-09 11:12","updatedAt":"2026-03-09 11:12","status":"已确认"},
  {"id":"SET20260307031","settlementNo":"SET20260307031","deliveryNos":["DEL20260307039"],"stockInNos":["SI20260307024"],"orderNos":["ORD20260307036"],"supplierId":"S1001","supplierName":"王五","baseId":"B001","baseName":"马钢诚兴台州基地","unitPrice":2341,"amount":28764,"confirmedBySupplier":true,"confirmedAt":"2026-03-08 11:12","createdAt":"2026-03-08 11:12","updatedAt":"2026-03-08 11:12","status":"已确认"},
  {"id":"SET20260306032","settlementNo":"SET20260306032","deliveryNos":["DEL20260306040"],"stockInNos":["SI20260306025"],"orderNos":["ORD20260306037"],"supplierId":"S1004","supplierName":"周八","baseId":"B004","baseName":"马钢诚兴南京分公司","unitPrice":2242,"amount":25938,"confirmedBySupplier":true,"confirmedAt":"2026-03-07 11:12","createdAt":"2026-03-07 11:12","updatedAt":"2026-03-07 11:12","status":"已确认"}
];

export const mockInvoices = [
  {"id":"INV20260308001","invoiceNo":"INV20260308001","no":"INV20260308001","deliveryNos":["DEL20260308003","DEL20260308004","DEL20260308005","DEL20260308006","DEL20260308015","DEL20260308016","DEL20260308017","DEL20260308026","DEL20260308027","DEL20260308028"],"settlementNos":["SET20260308001","SET20260308010","SET20260308018"],"orderNos":["ORD20260308005","ORD20260308015","ORD20260308025"],"supplierId":"S1005","supplierName":"吴九","type":"反向开票","amount":597526.67,"at":"2026-03-10 11:12","file":"invoice_DEL003.pdf","status":"已付款","createdAt":"2026-03-10 11:12","updatedAt":"2026-03-10 11:12"},
  {"id":"INV20260303005","invoiceNo":"INV20260303005","no":"INV20260303005","deliveryNos":["DEL20260303011","DEL20260303012","DEL20260303020","DEL20260303021","DEL20260303022","DEL20260303023"],"settlementNos":["SET20260303006","SET20260303014"],"orderNos":["ORD20260303010","ORD20260303020"],"supplierId":"S1005","supplierName":"吴九","type":"反向开票","amount":362130.45,"at":"2026-03-05 11:12","file":"invoice_DEL011.pdf","status":"已付款","createdAt":"2026-03-05 11:12","updatedAt":"2026-03-05 11:12"},
  {"id":"INV20260219019","invoiceNo":"INV20260219019","no":"INV20260219019","deliveryNos":["DEL20260219031"],"settlementNos":["SET20260219023"],"orderNos":["ORD20260219028"],"supplierId":"S1010","supplierName":"刘十四","type":"反向开票","amount":34698.55,"at":"2026-02-21 11:12","file":"invoice_DEL031.pdf","pendingApproval":true,"status":"审批中","createdAt":"2026-02-21 11:12","updatedAt":"2026-02-21 11:12"},
  {"id":"INV20260216020","invoiceNo":"INV20260216020","no":"INV20260216020","deliveryNos":["DEL20260216032"],"settlementNos":["SET20260216024"],"orderNos":["ORD20260216029"],"supplierId":"S1011","supplierName":"陈十五","type":"反向开票","amount":9663.68,"at":"2026-02-18 11:12","file":"invoice_DEL032.pdf","status":"已付款","createdAt":"2026-02-18 11:12","updatedAt":"2026-02-18 11:12"},
  {"id":"INV20260213021","invoiceNo":"INV20260213021","no":"INV20260213021","deliveryNos":["DEL20260213033"],"settlementNos":["SET20260213025"],"orderNos":["ORD20260213030"],"supplierId":"S1012","supplierName":"黄十六","type":"反向开票","amount":31308.99,"at":"2026-02-15 11:12","file":"invoice_DEL033.pdf","status":"已付款","createdAt":"2026-02-15 11:12","updatedAt":"2026-02-15 11:12"},
  {"id":"INV20260312022","invoiceNo":"INV20260312022","no":"INV20260312022","deliveryNos":["DEL20260312034"],"settlementNos":["SET20260312026"],"orderNos":["ORD20260312031"],"supplierId":"S1004","supplierName":"周八","type":"反向开票","amount":36327.68,"at":"2026-03-14 11:12","file":"invoice_DEL034.pdf","status":"已付款","createdAt":"2026-03-14 11:12","updatedAt":"2026-03-14 11:12"},
  {"id":"INV20260311023","invoiceNo":"INV20260311023","no":"INV20260311023","deliveryNos":["DEL20260311035"],"settlementNos":["SET20260311027"],"orderNos":["ORD20260311032"],"supplierId":"S1005","supplierName":"吴九","type":"反向开票","amount":29214.25,"at":"2026-03-13 11:12","file":"invoice_DEL035.pdf","status":"已付款","createdAt":"2026-03-13 11:12","updatedAt":"2026-03-13 11:12"},
  {"id":"INV20260310024","invoiceNo":"INV20260310024","no":"INV20260310024","deliveryNos":["DEL20260310036"],"settlementNos":["SET20260310028"],"orderNos":["ORD20260310033"],"supplierId":"S1012","supplierName":"黄十六","type":"反向开票","amount":32017,"at":"2026-03-12 11:12","file":"invoice_DEL036.pdf","status":"已付款","createdAt":"2026-03-12 11:12","updatedAt":"2026-03-12 11:12"},
  {"id":"INV20260309025","invoiceNo":"INV20260309025","no":"INV20260309025","deliveryNos":["DEL20260309037"],"settlementNos":["SET20260309029"],"orderNos":["ORD20260309034"],"supplierId":"S1012","supplierName":"黄十六","type":"反向开票","amount":38071.95,"at":"2026-03-11 11:12","file":"invoice_DEL037.pdf","status":"已付款","createdAt":"2026-03-11 11:12","updatedAt":"2026-03-11 11:12"},
  {"id":"INV20260308026","invoiceNo":"INV20260308026","no":"INV20260308026","deliveryNos":["DEL20260308038"],"settlementNos":["SET20260308030"],"orderNos":["ORD20260308035"],"supplierId":"S1004","supplierName":"周八","type":"反向开票","amount":21712.98,"at":"2026-03-10 11:12","file":"invoice_DEL038.pdf","status":"已付款","createdAt":"2026-03-10 11:12","updatedAt":"2026-03-10 11:12"},
  {"id":"INV20260307027","invoiceNo":"INV20260307027","no":"INV20260307027","deliveryNos":["DEL20260307039"],"settlementNos":["SET20260307031"],"orderNos":["ORD20260307036"],"supplierId":"S1001","supplierName":"王五","type":"反向开票","amount":29051.64,"at":"2026-03-09 11:12","file":"invoice_DEL039.pdf","pendingApproval":true,"status":"审批中","createdAt":"2026-03-09 11:12","updatedAt":"2026-03-09 11:12"},
  {"id":"INV20260306028","invoiceNo":"INV20260306028","no":"INV20260306028","deliveryNos":["DEL20260306040"],"settlementNos":["SET20260306032"],"orderNos":["ORD20260306037"],"supplierId":"S1004","supplierName":"周八","type":"反向开票","amount":26197.38,"at":"2026-03-08 11:12","file":"invoice_DEL040.pdf","status":"已付款","createdAt":"2026-03-08 11:12","updatedAt":"2026-03-08 11:12"}
];

export const mockPayments = [
  {"id":"PAY20260308001","paymentNo":"PAY20260308001","no":"PAY20260308001","deliveryNos":["DEL20260308003","DEL20260308004","DEL20260308005","DEL20260308006","DEL20260303011","DEL20260303012","DEL20260308015","DEL20260308016","DEL20260308017","DEL20260303020","DEL20260303021","DEL20260303022","DEL20260303023","DEL20260308026","DEL20260308027","DEL20260308028","DEL20260311035"],"invoiceNos":["INV20260308001","INV20260303005","INV20260311023"],"orderNos":["ORD20260308005","ORD20260303010","ORD20260308015","ORD20260303020","ORD20260308025","ORD20260311032"],"supplierId":"S1005","supplierName":"吴九","amount":1050618.41,"at":"2026-03-11 11:12","method":"银行转账","transactionNo":"TXN20260308001","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260310","requiredAmount":1050618.41,"paidAmount":1050618.41,"voucher":{"no":"VCH20260308001","type":"银行回单","at":"2026-03-11 11:12","file":"PAY_VOUCHER_DEL003.pdf"},"status":"已付款","createdAt":"2026-03-11 11:12","updatedAt":"2026-03-11 11:12"},
  {"id":"PAY20260216020","paymentNo":"PAY20260216020","no":"PAY20260216020","deliveryNos":["DEL20260216032"],"invoiceNos":["INV20260216020"],"orderNos":["ORD20260216029"],"supplierId":"S1011","supplierName":"陈十五","amount":9663.68,"at":null,"method":"银行转账","transactionNo":null,"bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260218","requiredAmount":9663.68,"paidAmount":0,"pendingPay":true,"status":"待付款","createdAt":"2026-02-18 16:12","updatedAt":"2026-02-18 16:12"},
  {"id":"PAY20260213021","paymentNo":"PAY20260213021","no":"PAY20260213021","deliveryNos":["DEL20260213033","DEL20260310036","DEL20260309037"],"invoiceNos":["INV20260213021","INV20260310024","INV20260309025"],"orderNos":["ORD20260213030","ORD20260310033","ORD20260309034"],"supplierId":"S1012","supplierName":"黄十六","amount":168996.56,"at":"2026-02-16 11:12","method":"银行转账","transactionNo":"TXN20260213021","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260215","requiredAmount":168996.56,"paidAmount":168996.56,"voucher":{"no":"VCH20260213021","type":"银行回单","at":"2026-02-16 11:12","file":"PAY_VOUCHER_DEL033.pdf"},"status":"已付款","createdAt":"2026-02-16 11:12","updatedAt":"2026-02-16 11:12"},
  {"id":"PAY20260312022","paymentNo":"PAY20260312022","no":"PAY20260312022","deliveryNos":["DEL20260312034","DEL20260308038","DEL20260306040"],"invoiceNos":["INV20260312022","INV20260308026","INV20260306028"],"orderNos":["ORD20260312031","ORD20260308035","ORD20260306037"],"supplierId":"S1004","supplierName":"周八","amount":140396.74,"at":"2026-03-15 11:12","method":"银行转账","transactionNo":"TXN20260312022","bankName":"中国建设银行杭州分行","bankAccount":"6227 **** **** 5678","applyDate":"20260314","requiredAmount":140396.74,"paidAmount":140396.74,"voucher":{"no":"VCH20260312022","type":"银行回单","at":"2026-03-15 11:12","file":"PAY_VOUCHER_DEL034.pdf"},"status":"已付款","createdAt":"2026-03-15 11:12","updatedAt":"2026-03-15 11:12"}
];

export const approvalTasks = [
  // ========== 采购需求审批（待审批）==========
  { id: 'AP-001', type: 'demand_approval', title: '采购需求审批 - 工业重废毛料 (150吨)', applicant: '张伟', submitTime: '2026-03-05 09:00', date: '2026-03-05', status: 'pending', priority: 'high', currentStep: '平台运营部长', relatedId: 'D2026030501', flow: [{ step: '业务员提交', approver: '张伟', approverRole: '业务员', status: 'approved', time: '2026-03-05 09:00', remark: '客户急需，请尽快审批' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-002', type: 'demand_approval', title: '采购需求审批 - 特级破碎料 (200吨)', applicant: '李四', submitTime: '2026-03-04 14:00', date: '2026-03-05', status: 'pending', priority: 'medium', currentStep: '平台运营部长', relatedId: 'D2026030502', flow: [{ step: '业务员提交', approver: '李四', approverRole: '业务员', status: 'approved', time: '2026-03-04 14:00', remark: '' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-003', type: 'demand_approval', title: '采购需求审批 - 统料废钢 (300吨)', applicant: '王五', submitTime: '2026-03-05 10:30', date: '2026-03-05', status: 'pending', priority: 'medium', currentStep: '平台运营部长', relatedId: 'D2026030503', flow: [{ step: '业务员提交', approver: '王五', approverRole: '业务员', status: 'approved', time: '2026-03-05 10:30', remark: '长期供货需求' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'pending', time: null, remark: '' }] },

  // ========== 合同审批（待审批）==========
  { id: 'AP-004', type: 'contract_approval', title: '合同审批 - C20260305001 (王五/工业重废毛料)', applicant: '张伟', submitTime: '2026-03-05 08:30', date: '2026-03-05', status: 'pending', priority: 'high', currentStep: '平台运营部长', relatedId: 'ORD010', flow: [{ step: '业务员提交', approver: '张伟', approverRole: '业务员', status: 'approved', time: '2026-03-05 08:30', remark: '价格已谈妥，客户急需' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-005', type: 'contract_approval', title: '合同审批 - C20260304001 (赵六/特级破碎料)', applicant: '李四', submitTime: '2026-03-04 15:00', date: '2026-03-04', status: 'pending', priority: 'high', currentStep: '平台运营部长', relatedId: 'ORD009', flow: [{ step: '业务员提交', approver: '李四', approverRole: '业务员', status: 'approved', time: '2026-03-04 15:00', remark: '大客户，优先处理' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-006', type: 'contract_approval', title: '合同审批 - C20260303001 (孙七/统料废钢)', applicant: '王五', submitTime: '2026-03-03 11:00', date: '2026-03-03', status: 'pending', priority: 'medium', currentStep: '平台运营部长', relatedId: 'ORD008', flow: [{ step: '业务员提交', approver: '王五', approverRole: '业务员', status: 'approved', time: '2026-03-03 11:00', remark: '' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'pending', time: null, remark: '' }] },

  // ========== 结算审批（待审批）==========
  { id: 'AP-007', type: 'settlement_approval', title: '结算审批 - 王五 (19.80吨/48,510元)', applicant: '黄十四', submitTime: '2026-03-05 10:00', date: '2026-03-05', status: 'pending', priority: 'high', currentStep: '财务经理', relatedId: 'SET2026030501', flow: [{ step: '采购结算提交', approver: '黄十四', approverRole: '采购结算', status: 'approved', time: '2026-03-05 10:00', remark: '结算单已生成，请审批' }, { step: '财务经理', approver: '周八', approverRole: '财务经理', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-008', type: 'settlement_approval', title: '结算审批 - 赵六 (12.50吨/32,500元)', applicant: '黄十四', submitTime: '2026-03-05 11:30', date: '2026-03-05', status: 'pending', priority: 'medium', currentStep: '财务经理', relatedId: 'SET2026030502', flow: [{ step: '采购结算提交', approver: '黄十四', approverRole: '采购结算', status: 'approved', time: '2026-03-05 11:30', remark: '' }, { step: '财务经理', approver: '周八', approverRole: '财务经理', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-009', type: 'settlement_approval', title: '结算审批 - 周八 (8.00吨/14,400元)', applicant: '黄十四', submitTime: '2026-03-04 16:00', date: '2026-03-04', status: 'pending', priority: 'low', currentStep: '财务经理', relatedId: 'SET2026030401', flow: [{ step: '采购结算提交', approver: '黄十四', approverRole: '采购结算', status: 'approved', time: '2026-03-04 16:00', remark: '' }, { step: '财务经理', approver: '周八', approverRole: '财务经理', status: 'pending', time: null, remark: '' }] },

  // ========== 开票审批（待审批）==========
  { id: 'AP-010', type: 'invoice_approval', title: '开票审批 - 王五 (12.50吨/30,625元)', applicant: '周八', submitTime: '2026-03-05 09:30', date: '2026-03-05', status: 'pending', priority: 'high', currentStep: '财务部长', relatedId: 'INV2026030501', flow: [{ step: '财务经理', approver: '周八', approverRole: '财务经理', status: 'approved', time: '2026-03-05 09:30', remark: '发票信息已核对' }, { step: '财务部长', approver: '钱十一', approverRole: '财务部长', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-011', type: 'invoice_approval', title: '开票审批 - 吴九 (17.00吨/39,100元)', applicant: '周八', submitTime: '2026-03-04 17:00', date: '2026-03-04', status: 'pending', priority: 'medium', currentStep: '财务部长', relatedId: 'INV2026030401', flow: [{ step: '财务经理', approver: '周八', approverRole: '财务经理', status: 'approved', time: '2026-03-04 17:00', remark: '' }, { step: '财务部长', approver: '钱十一', approverRole: '财务部长', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-012', type: 'invoice_approval', title: '开票审批 - 孙七 (13.00吨/28,600元)', applicant: '周八', submitTime: '2026-03-05 14:00', date: '2026-03-05', status: 'pending', priority: 'low', currentStep: '财务部长', relatedId: 'INV2026030502', flow: [{ step: '财务经理', approver: '周八', approverRole: '财务经理', status: 'approved', time: '2026-03-05 14:00', remark: '客户催促开票' }, { step: '财务部长', approver: '钱十一', approverRole: '财务部长', status: 'pending', time: null, remark: '' }] },

  // ========== 付款审批（待审批）==========
  { id: 'AP-013', type: 'payment_approval', title: '付款审批 - 王五 (48,510元)', applicant: '钱十一', submitTime: '2026-03-05 11:00', date: '2026-03-05', status: 'pending', priority: 'high', currentStep: '财务总监', relatedId: 'PAY2026030501', flow: [{ step: '财务部长', approver: '钱十一', approverRole: '财务部长', status: 'approved', time: '2026-03-05 11:00', remark: '款项已核实，申请付款' }, { step: '财务总监', approver: '赵总', approverRole: '财务总监', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-014', type: 'payment_approval', title: '付款审批 - 赵六 (42,900元)', applicant: '钱十一', submitTime: '2026-03-05 12:00', date: '2026-03-05', status: 'pending', priority: 'medium', currentStep: '财务总监', relatedId: 'PAY2026030502', flow: [{ step: '财务部长', approver: '钱十一', approverRole: '财务部长', status: 'approved', time: '2026-03-05 12:00', remark: '' }, { step: '财务总监', approver: '赵总', approverRole: '财务总监', status: 'pending', time: null, remark: '' }] },
  { id: 'AP-015', type: 'payment_approval', title: '付款审批 - 吴九 (37,950元)', applicant: '钱十一', submitTime: '2026-03-04 18:00', date: '2026-03-04', status: 'pending', priority: 'low', currentStep: '财务总监', relatedId: 'PAY2026030401', flow: [{ step: '财务部长', approver: '钱十一', approverRole: '财务部长', status: 'approved', time: '2026-03-04 18:00', remark: '' }, { step: '财务总监', approver: '赵总', approverRole: '财务总监', status: 'pending', time: null, remark: '' }] },

  // ========== 已完成的审批 ==========
  { id: 'AP-016', type: 'demand_approval', title: '采购需求审批 - 钢筋头 (100吨)', applicant: '李四', submitTime: '2026-03-03 09:00', date: '2026-03-03', status: 'approved', priority: 'medium', currentStep: '已完成', relatedId: 'D2026030301', flow: [{ step: '业务员提交', approver: '李四', approverRole: '业务员', status: 'approved', time: '2026-03-03 09:00', remark: '' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'approved', time: '2026-03-03 10:00', remark: '同意' }] },
  { id: 'AP-017', type: 'contract_approval', title: '合同审批 - C20260302001 (吴九/钢筋头)', applicant: '王五', submitTime: '2026-03-02 10:00', date: '2026-03-02', status: 'approved', priority: 'medium', currentStep: '已完成', relatedId: 'ORD007', flow: [{ step: '业务员提交', approver: '王五', approverRole: '业务员', status: 'approved', time: '2026-03-02 10:00', remark: '' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'approved', time: '2026-03-02 11:00', remark: '同意' }] },
  { id: 'AP-018', type: 'settlement_approval', title: '结算审批 - 王五 (19.80吨/48,510元)', applicant: '黄十四', submitTime: '2026-03-02 14:00', date: '2026-03-02', status: 'approved', priority: 'medium', currentStep: '已完成', relatedId: 'SET2026030201', flow: [{ step: '采购结算提交', approver: '黄十四', approverRole: '采购结算', status: 'approved', time: '2026-03-02 14:00', remark: '' }, { step: '财务经理', approver: '周八', approverRole: '财务经理', status: 'approved', time: '2026-03-02 15:30', remark: '核对无误' }] },
  { id: 'AP-019', type: 'invoice_approval', title: '开票审批 - 赵六 (16.50吨/42,900元)', applicant: '周八', submitTime: '2026-03-03 10:00', date: '2026-03-03', status: 'approved', priority: 'medium', currentStep: '已完成', relatedId: 'INV2026030301', flow: [{ step: '财务经理', approver: '周八', approverRole: '财务经理', status: 'approved', time: '2026-03-03 10:00', remark: '' }, { step: '财务部长', approver: '钱十一', approverRole: '财务部长', status: 'approved', time: '2026-03-03 11:00', remark: '同意开票' }] },
  { id: 'AP-020', type: 'payment_approval', title: '付款审批 - 孙七 (19,140元)', applicant: '钱十一', submitTime: '2026-03-03 14:00', date: '2026-03-03', status: 'approved', priority: 'medium', currentStep: '已完成', relatedId: 'PAY2026030301', flow: [{ step: '财务部长', approver: '钱十一', approverRole: '财务部长', status: 'approved', time: '2026-03-03 14:00', remark: '' }, { step: '财务总监', approver: '赵总', approverRole: '财务总监', status: 'approved', time: '2026-03-03 15:00', remark: '同意付款' }] },

  // ========== 已驳回的审批 ==========
  { id: 'AP-021', type: 'demand_approval', title: '采购需求审批 - 轻薄料 (500吨)', applicant: '王五', submitTime: '2026-03-02 16:00', date: '2026-03-02', status: 'rejected', priority: 'medium', currentStep: '已驳回', relatedId: 'D2026030201', flow: [{ step: '业务员提交', approver: '王五', approverRole: '业务员', status: 'approved', time: '2026-03-02 16:00', remark: '' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'rejected', time: '2026-03-02 17:00', remark: '数量过大，需分批采购' }] },
  { id: 'AP-022', type: 'contract_approval', title: '合同审批 - C20260227001 (周八/钢筋头)', applicant: '李四', submitTime: '2026-02-27 14:00', date: '2026-02-27', status: 'rejected', priority: 'medium', currentStep: '已驳回', relatedId: 'ORD004', flow: [{ step: '业务员提交', approver: '李四', approverRole: '业务员', status: 'approved', time: '2026-02-27 14:00', remark: '' }, { step: '平台运营部长', approver: '王部长', approverRole: '平台运营部长', status: 'rejected', time: '2026-02-27 15:00', remark: '价格偏高，请重新核价' }] },
];

export const paymentApprovals = [
  { id: 'P9981', supplier: '王五', amount: '48,510.00', type: '货款支付', date: '2026-02-28', status: '已完成', step: 4 },
  { id: 'P9982', supplier: '吴九', amount: '63,750.00', type: '货款支付', date: '2026-02-25', status: '已完成', step: 4 },
  { id: 'P9983', supplier: '吴九', amount: '65,025.00', type: '货款支付', date: '2026-02-28', status: '已完成', step: 4 },
  { id: 'P9984', supplier: '王五', amount: '30,625.00', type: '货款支付', date: '2026-03-01', status: '待提交', step: 1 },
];

// ============ 审批流程配置 ============

export const mockApprovalFlows = [
  { id: 'flow_demand', name: '采购需求审批流', type: 'demand_approval', typeLabel: '采购需求审批', steps: ['业务员提交', '平台运营部长'], enabled: true },
  { id: 'flow_contract', name: '合同审批流', type: 'contract_approval', typeLabel: '合同审批', steps: ['业务员提交', '平台运营部长'], enabled: true },
  { id: 'flow_settlement', name: '结算审批流', type: 'settlement_approval', typeLabel: '结算审批', steps: ['采购结算提交', '财务经理'], enabled: true },
  { id: 'flow_invoice', name: '开票审批流', type: 'invoice_approval', typeLabel: '开票审批', steps: ['财务经理', '财务部长'], enabled: true },
  { id: 'flow_payment', name: '付款审批流', type: 'payment_approval', typeLabel: '付款审批', steps: ['财务部长', '财务总监'], enabled: true },
];

// ============ 审批人配置 ============

export const mockApprovers = [
  // 采购需求审批流
  { id: 'apr_1', stepKey: '业务员提交', stepLabel: '业务员提交', assignee: '张伟', assigneeRole: '业务员', remark: '由提交人自动占位' },
  { id: 'apr_2', stepKey: '平台运营部长', stepLabel: '平台运营部长', assignee: '王部长', assigneeRole: '平台运营部长', remark: '' },
  // 结算审批流
  { id: 'apr_3', stepKey: '采购结算提交', stepLabel: '采购结算提交', assignee: '黄十四', assigneeRole: '采购结算', remark: '由申请人自动占位' },
  { id: 'apr_4', stepKey: '财务经理', stepLabel: '财务经理', assignee: '周八', assigneeRole: '财务经理', remark: '' },
  // 开票审批流
  { id: 'apr_5', stepKey: '财务部长', stepLabel: '财务部长', assignee: '钱十一', assigneeRole: '财务部长', remark: '' },
  // 付款审批流
  { id: 'apr_6', stepKey: '财务总监', stepLabel: '财务总监', assignee: '赵总', assigneeRole: '财务总监', remark: '终审' },
];

// ============ 角色权限 ============

// 页面权限配置（菜单可见性）
export const ROLE_PERMISSIONS = {
  'admin': ['dashboard', 'approval', 'base', 'materials', 'employees', 'demand', 'order', 'delivery', 'arrival_notice', 'stockin_manage', 'settlement_manage', 'invoice_manage', 'document', 'stockin', 'settlement', 'invoice', 'payment', 'users', 'settings', 'role_permission', 'sub_account', 'operation_log'],
  'vp': ['dashboard', 'approval', 'order', 'delivery', 'arrival_notice', 'stockin_manage', 'settlement_manage', 'invoice_manage', 'document', 'payment', 'operation_log'],
  'ops_minister': ['dashboard', 'approval', 'base', 'demand', 'order', 'delivery', 'arrival_notice', 'stockin_manage', 'settlement_manage', 'invoice_manage', 'document', 'payment', 'operation_log'],
  'salesman': ['dashboard', 'base', 'materials', 'employees', 'demand'],
  'purchaser': ['dashboard', 'users', 'order', 'delivery', 'arrival_notice', 'stockin_manage', 'document'],
  'settlement': ['dashboard', 'document', 'settlement_manage', 'invoice_manage', 'settlement', 'payment', 'invoice'],
  'finance_mgr': ['dashboard', 'document', 'invoice_manage', 'invoice', 'payment'],
  'finance_director': ['dashboard', 'approval', 'document', 'invoice_manage', 'payment'],
  'production': ['dashboard', 'delivery', 'arrival_notice', 'stockin_manage', 'document', 'stockin'],
};

// 岗位列表
export const AVAILABLE_ROLES = [
  { id: 'admin', label: '超级管理员', description: '系统最高权限，可管理所有功能和数据' },
  { id: 'vp', label: '分管副总', description: '审批订单、查看送货单和付款单' },
  { id: 'ops_minister', label: '平台运营部长', description: '管理基地、审批订单、管理需求' },
  { id: 'salesman', label: '业务员', description: '管理基地物料、员工、发布需求' },
  { id: 'purchaser', label: '采购经理', description: '管理客商、订单、送货单' },
  { id: 'settlement', label: '采购结算', description: '管理结算、发票、付款' },
  { id: 'finance_mgr', label: '财务经理', description: '管理发票、付款' },
  { id: 'finance_director', label: '财务部长/总监', description: '审批付款、查看单据' },
  { id: 'production', label: '生产/质检管理', description: '管理送货单、入库单' },
];

// 功能权限点定义
export const PERMISSION_POINTS = {
  // 需求管理权限
  demand: {
    view: '查看需求',
    create: '发布需求',
    edit: '修改需求',
    delete: '删除需求',
  },
  // 客商管理权限
  users: {
    view: '查看客商',
    edit: '修改客商',
  },
  // 订单管理权限
  order: {
    view: '查看订单',
    create: '创建订单',
    edit: '修改订单',
    approve: '审批订单',
    reject: '驳回订单',
    close: '作废订单',
  },
  // 送货单权限
  delivery: {
    view: '查看送货单',
    confirm_reservation: '确认预约',
    confirm_arrival: '确认到场',
    store: '确认入库',
  },
  // 入库单权限
  stockin: {
    view: '查入库单',
    create: '创建入库单',
    edit: '修改入库单',
  },
  // 结算权限
  settlement: {
    view: '查看结算单',
    create: '创建结算单',
    confirm: '确认结算',
  },
  // 发票权限
  invoice: {
    view: '查看发票',
    create: '创建发票',
    verify: '核销发票',
  },
  // 付款权限
  payment: {
    view: '查看付款单',
    approve: '审批付款',
    pay: '执行付款',
  },
  // 基地管理权限
  base: {
    view: '查看基地',
    create: '新增基地',
    edit: '修改基地',
    stop: '停运基地',
    restart: '开启基地',
  },
  // 物料管理权限
  materials: {
    view: '查看物料',
    create: '新增物料',
    edit: '修改物料',
    delete: '删除物料',
  },
  // 员工管理权限
  employees: {
    view: '查看员工',
    create: '新增员工',
    edit: '修改员工',
    disable: '停用员工',
  },
};

// 岗位详细权限配置（页面权限 + 功能权限 + 数据权限）
export const ROLE_DETAILED_PERMISSIONS = {
  'admin': {
    pages: ['dashboard', 'approval', 'base', 'materials', 'employees', 'demand', 'order', 'delivery', 'document', 'stockin', 'settlement', 'invoice', 'payment', 'users', 'settings', 'role_permission', 'sub_account'],
    dataScope: 'all', // all: 全部数据, base: 所属基地, self: 仅自己
    permissions: {
      demand: ['view', 'create', 'edit', 'delete'],
      users: ['view', 'edit'],
      order: ['view', 'create', 'edit', 'approve', 'reject', 'close'],
      delivery: ['view', 'confirm_reservation', 'confirm_arrival', 'store'],
      stockin: ['view', 'create', 'edit'],
      settlement: ['view', 'create', 'confirm'],
      invoice: ['view', 'create', 'verify'],
      payment: ['view', 'approve', 'pay'],
      base: ['view', 'create', 'edit', 'stop', 'restart'],
      materials: ['view', 'create', 'edit', 'delete'],
      employees: ['view', 'create', 'edit', 'disable'],
    },
  },
  'vp': {
    pages: ['dashboard', 'approval', 'order', 'delivery', 'document', 'payment'],
    dataScope: 'all',
    permissions: {
      order: ['view', 'approve', 'reject'],
      delivery: ['view'],
      payment: ['view', 'approve'],
    },
  },
  'ops_minister': {
    pages: ['dashboard', 'approval', 'base', 'demand', 'order', 'delivery', 'document', 'payment'],
    dataScope: 'all',
    permissions: {
      base: ['view', 'edit', 'stop', 'restart'],
      demand: ['view', 'create', 'edit', 'delete'],
      order: ['view', 'approve', 'reject'],
      delivery: ['view'],
      payment: ['view', 'approve'],
    },
  },
  'salesman': {
    pages: ['dashboard', 'base', 'materials', 'employees', 'demand'],
    dataScope: 'base',
    permissions: {
      base: ['view'],
      materials: ['view', 'create', 'edit', 'delete'],
      employees: ['view', 'create', 'edit'],
      demand: ['view', 'create', 'edit', 'delete'],
    },
  },
  'purchaser': {
    pages: ['dashboard', 'users', 'order', 'delivery', 'document'],
    dataScope: 'base',
    permissions: {
      users: ['view', 'edit'],
      order: ['view', 'create', 'edit', 'close'],
      delivery: ['view', 'confirm_reservation'],
    },
  },
  'settlement': {
    pages: ['dashboard', 'document', 'settlement', 'payment', 'invoice'],
    dataScope: 'base',
    permissions: {
      settlement: ['view', 'create', 'confirm'],
      invoice: ['view', 'create', 'verify'],
      payment: ['view'],
    },
  },
  'finance_mgr': {
    pages: ['dashboard', 'document', 'invoice', 'payment'],
    dataScope: 'base',
    permissions: {
      invoice: ['view', 'create', 'verify'],
      payment: ['view'],
    },
  },
  'finance_director': {
    pages: ['dashboard', 'approval', 'document', 'payment'],
    dataScope: 'all',
    permissions: {
      payment: ['view', 'approve'],
    },
  },
  'production': {
    pages: ['dashboard', 'delivery', 'document', 'stockin'],
    dataScope: 'base',
    permissions: {
      delivery: ['view', 'confirm_arrival', 'store'],
      stockin: ['view', 'create', 'edit'],
    },
  },
};

// 子账号数据
export const mockSubAccounts = [
  { id: 'SA001', employeeCode: 'EMP001', workNo: 'BW20001', name: '张三', phone: '13800000001', department: '运营部', roleId: 'salesman', roleName: '业务员', base: '马钢诚兴台州基地', status: 'active', createdAt: '2025-01-15', lastLoginAt: '2026-03-01 09:30' },
  { id: 'SA002', employeeCode: 'EMP002', workNo: 'BW20002', name: '李四', phone: '13800000002', department: '运营部', roleId: 'salesman', roleName: '业务员', base: '马钢诚兴台州基地', status: 'active', createdAt: '2025-02-20', lastLoginAt: '2026-02-28 16:45' },
  { id: 'SA003', employeeCode: 'EMP003', workNo: 'BW10001', name: '王部长', phone: '13800000003', department: '平台运营中心', roleId: 'ops_minister', roleName: '平台运营部长', base: '平台运营中心', status: 'active', createdAt: '2024-06-10', lastLoginAt: '2026-03-01 08:00' },
  { id: 'SA004', employeeCode: 'EMP004', workNo: 'BW00001', name: '赵总', phone: '13800000004', department: '集团总部', roleId: 'vp', roleName: '分管副总', base: '集团总部', status: 'active', createdAt: '2023-01-01', lastLoginAt: '2026-02-28 18:00' },
  { id: 'SA005', employeeCode: 'EMP005', workNo: 'BW30001', name: '钱七', phone: '13800000005', department: '采购部', roleId: 'purchaser', roleName: '采购经理', base: '马钢诚兴台州基地', status: 'active', createdAt: '2025-03-10', lastLoginAt: '2026-03-01 10:15' },
  { id: 'SA006', employeeCode: 'EMP006', workNo: 'BW40001', name: '孙八', phone: '13800000006', department: '财务部', roleId: 'finance_mgr', roleName: '财务经理', base: '平台运营中心', status: 'active', createdAt: '2024-08-15', lastLoginAt: '2026-02-27 17:30' },
  { id: 'SA007', employeeCode: 'EMP007', workNo: 'BW40002', name: '周九', phone: '13800000007', department: '财务部', roleId: 'settlement', roleName: '采购结算', base: '平台运营中心', status: 'active', createdAt: '2025-01-20', lastLoginAt: '2026-03-01 11:00' },
  { id: 'SA008', employeeCode: 'EMP008', workNo: 'BW50001', name: '吴十', phone: '13800000008', department: '生产部', roleId: 'production', roleName: '生产/质检管理', base: '马钢诚兴台州基地', status: 'disabled', createdAt: '2024-11-05', lastLoginAt: '2025-12-15 09:00' },
];

// ============ 操作日志数据（兼容旧代码）============

export const mockLogs = [
  { id: 1, user: '张伟 (业务员)', time: '2026-03-01 09:30:15', action: '新增', content: '创建了该记录', version: 'V1.0' },
  { id: 2, user: '王部长 (运营部长)', time: '2026-03-01 10:15:22', action: '审核', content: '审核通过', version: 'V1.1' },
  { id: 3, user: '张伟 (业务员)', time: '2026-03-01 14:20:05', action: '修改', content: '修改了价格信息：2400 -> 2450', version: 'V1.2' },
  { id: 4, user: '王五 (质检员)', time: '2026-03-01 16:00:00', action: '质检', content: '质检通过，等级一级', version: 'V1.3' },
];

// ============ 入库单数据（兼容旧代码）============

export const mockStockIns = [
  {"id":"SI20260308001","stockInNo":"SI20260308001","deliveryNo":"DEL20260308003","deliveryId":"DEL003","orderId":"ORD005","orderNo":"ORD20260308005","supplierId":"S1005","supplierName":"吴九","baseId":"B001","baseName":"马钢诚兴台州基地","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-08 15:12","operator":"李四","grossWeight":23,"tareWeight":16,"netWeight":7,"deduction":0.53,"actualWeight":6.47,"price":2517,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":16296,"amountWithTax":16458.96,"totalAmount":16458.96,"quality":"二级","photos":["plate_DEL003.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 14:22","operator":"王门卫","photo":"entry_DEL003.jpg"},"entryWeighInfo":{"at":"2026-03-08 14:42","operator":"李四","photo":"weigh_in_DEL003.jpg"},"qualityInfo":{"at":"2026-03-08 14:57","operator":"张质检","photo":"quality_DEL003.jpg"},"exitWeighInfo":{"at":"2026-03-08 15:00","operator":"李四","photo":"weigh_out_DEL003.jpg"},"exitCheckInfo":{"at":"2026-03-08 15:22","operator":"王门卫","photo":"exit_DEL003.jpg"},"settlementNo":"SET20260308001","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 15:12","updatedAt":"2026-03-08 15:12"},
  {"id":"SI20260308002","stockInNo":"SI20260308002","deliveryNo":"DEL20260308004","deliveryId":"DEL004","orderId":"ORD005","orderNo":"ORD20260308005","supplierId":"S1005","supplierName":"吴九","baseId":"B001","baseName":"马钢诚兴台州基地","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-08 17:12","operator":"李四","grossWeight":22,"tareWeight":12,"netWeight":10,"deduction":0.12,"actualWeight":9.88,"price":2517,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":24856,"amountWithTax":25104.56,"totalAmount":25104.56,"quality":"一级","photos":["plate_DEL004.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 16:22","operator":"王门卫","photo":"entry_DEL004.jpg"},"entryWeighInfo":{"at":"2026-03-08 16:42","operator":"李四","photo":"weigh_in_DEL004.jpg"},"qualityInfo":{"at":"2026-03-08 16:57","operator":"张质检","photo":"quality_DEL004.jpg"},"exitWeighInfo":{"at":"2026-03-08 17:00","operator":"李四","photo":"weigh_out_DEL004.jpg"},"exitCheckInfo":{"at":"2026-03-08 17:22","operator":"王门卫","photo":"exit_DEL004.jpg"},"settlementNo":"SET20260308001","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 17:12","updatedAt":"2026-03-08 17:12"},
  {"id":"ST20260308001","stockInNo":"ST20260308001","deliveryNo":"DEL20260308005","deliveryId":"DEL005","orderId":"ORD005","orderNo":"ORD20260308005","supplierId":"S1005","supplierName":"吴九","baseId":"B001","baseName":"马钢诚兴台州基地","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-08 19:12","operator":"李四","grossWeight":28,"tareWeight":16,"netWeight":12,"deduction":0.11,"actualWeight":11.89,"price":2517,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":29937,"amountWithTax":30236.37,"totalAmount":30236.37,"quality":"二级","photos":["plate_DEL005.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 18:22","operator":"王门卫","photo":"entry_DEL005.jpg"},"entryWeighInfo":{"at":"2026-03-08 18:42","operator":"李四","photo":"weigh_in_DEL005.jpg"},"qualityInfo":{"at":"2026-03-08 18:57","operator":"张质检","photo":"quality_DEL005.jpg"},"exitWeighInfo":{"at":"2026-03-08 19:00","operator":"李四","photo":"weigh_out_DEL005.jpg"},"exitCheckInfo":{"at":"2026-03-08 19:22","operator":"王门卫","photo":"exit_DEL005.jpg"},"settlementNo":"SET20260308001","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 19:12","updatedAt":"2026-03-08 19:12"},
  {"id":"SI20260308003","stockInNo":"SI20260308003","deliveryNo":"DEL20260308006","deliveryId":"DEL006","orderId":"ORD005","orderNo":"ORD20260308005","supplierId":"S1005","supplierName":"吴九","baseId":"B001","baseName":"马钢诚兴台州基地","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-08 21:12","operator":"李四","grossWeight":33,"tareWeight":14,"netWeight":19,"deduction":0.47,"actualWeight":18.53,"price":2517,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":46649,"amountWithTax":47115.49,"totalAmount":47115.49,"quality":"合格","photos":["plate_DEL006.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 20:22","operator":"王门卫","photo":"entry_DEL006.jpg"},"entryWeighInfo":{"at":"2026-03-08 20:42","operator":"李四","photo":"weigh_in_DEL006.jpg"},"qualityInfo":{"at":"2026-03-08 20:57","operator":"张质检","photo":"quality_DEL006.jpg"},"exitWeighInfo":{"at":"2026-03-08 21:00","operator":"李四","photo":"weigh_out_DEL006.jpg"},"exitCheckInfo":{"at":"2026-03-08 21:22","operator":"王门卫","photo":"exit_DEL006.jpg"},"settlementNo":"SET20260308001","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 21:12","updatedAt":"2026-03-08 21:12"},
  {"id":"SI20260307004","stockInNo":"SI20260307004","deliveryNo":"DEL20260307007","deliveryId":"DEL007","orderId":"ORD006","orderNo":"ORD20260307006","supplierId":"S1001","supplierName":"王五","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M005","materialName":"钢筋头","stockInTime":"2026-03-07 15:12","operator":"李四","grossWeight":28,"tareWeight":14,"netWeight":14,"deduction":0.9,"actualWeight":13.1,"price":2377,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":31135,"amountWithTax":31446.35,"totalAmount":31446.35,"quality":"二级","photos":["plate_DEL007.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-07 14:22","operator":"王门卫","photo":"entry_DEL007.jpg"},"entryWeighInfo":{"at":"2026-03-07 14:42","operator":"李四","photo":"weigh_in_DEL007.jpg"},"qualityInfo":{"at":"2026-03-07 14:57","operator":"张质检","photo":"quality_DEL007.jpg"},"exitWeighInfo":{"at":"2026-03-07 15:00","operator":"李四","photo":"weigh_out_DEL007.jpg"},"exitCheckInfo":{"at":"2026-03-07 15:22","operator":"王门卫","photo":"exit_DEL007.jpg"},"settlementNo":"SET20260307005","hasSettlement":true,"status":"已结算","createdAt":"2026-03-07 15:12","updatedAt":"2026-03-07 15:12"},
  {"id":"SI20260303005","stockInNo":"SI20260303005","deliveryNo":"DEL20260303011","deliveryId":"DEL011","orderId":"ORD010","orderNo":"ORD20260303010","supplierId":"S1005","supplierName":"吴九","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-03 15:12","operator":"李四","grossWeight":29,"tareWeight":13,"netWeight":16,"deduction":0.09,"actualWeight":15.91,"price":2407,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":38293,"amountWithTax":38675.93,"totalAmount":38675.93,"quality":"合格","photos":["plate_DEL011.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-03 14:22","operator":"王门卫","photo":"entry_DEL011.jpg"},"entryWeighInfo":{"at":"2026-03-03 14:42","operator":"李四","photo":"weigh_in_DEL011.jpg"},"qualityInfo":{"at":"2026-03-03 14:57","operator":"张质检","photo":"quality_DEL011.jpg"},"exitWeighInfo":{"at":"2026-03-03 15:00","operator":"李四","photo":"weigh_out_DEL011.jpg"},"exitCheckInfo":{"at":"2026-03-03 15:22","operator":"王门卫","photo":"exit_DEL011.jpg"},"settlementNo":"SET20260303006","hasSettlement":true,"status":"已结算","createdAt":"2026-03-03 15:12","updatedAt":"2026-03-03 15:12"},
  {"id":"SI20260303006","stockInNo":"SI20260303006","deliveryNo":"DEL20260303012","deliveryId":"DEL012","orderId":"ORD010","orderNo":"ORD20260303010","supplierId":"S1005","supplierName":"吴九","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-03 17:12","operator":"李四","grossWeight":21,"tareWeight":14,"netWeight":7,"deduction":0.06,"actualWeight":6.94,"price":2407,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":16711,"amountWithTax":16878.11,"totalAmount":16878.11,"quality":"一级","photos":["plate_DEL012.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-03 16:22","operator":"王门卫","photo":"entry_DEL012.jpg"},"entryWeighInfo":{"at":"2026-03-03 16:42","operator":"李四","photo":"weigh_in_DEL012.jpg"},"qualityInfo":{"at":"2026-03-03 16:57","operator":"张质检","photo":"quality_DEL012.jpg"},"exitWeighInfo":{"at":"2026-03-03 17:00","operator":"李四","photo":"weigh_out_DEL012.jpg"},"exitCheckInfo":{"at":"2026-03-03 17:22","operator":"王门卫","photo":"exit_DEL012.jpg"},"settlementNo":"SET20260303006","hasSettlement":true,"status":"已结算","createdAt":"2026-03-03 17:12","updatedAt":"2026-03-03 17:12"},
  {"id":"SI20260312007","stockInNo":"SI20260312007","deliveryNo":"DEL20260312013","deliveryId":"DEL013","orderId":"ORD011","orderNo":"ORD20260312011","supplierId":"S1001","supplierName":"王五","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-12 15:12","operator":"李四","grossWeight":31,"tareWeight":14,"netWeight":17,"deduction":0.22,"actualWeight":16.78,"price":2400,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":40282,"amountWithTax":40684.82,"totalAmount":40684.82,"quality":"一级","photos":["plate_DEL013.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-12 14:22","operator":"王门卫","photo":"entry_DEL013.jpg"},"entryWeighInfo":{"at":"2026-03-12 14:42","operator":"李四","photo":"weigh_in_DEL013.jpg"},"qualityInfo":{"at":"2026-03-12 14:57","operator":"张质检","photo":"quality_DEL013.jpg"},"exitWeighInfo":{"at":"2026-03-12 15:00","operator":"李四","photo":"weigh_out_DEL013.jpg"},"exitCheckInfo":{"at":"2026-03-12 15:22","operator":"王门卫","photo":"exit_DEL013.jpg"},"settlementNo":"SET20260312008","hasSettlement":true,"status":"已结算","createdAt":"2026-03-12 15:12","updatedAt":"2026-03-12 15:12"},
  {"id":"ST20260312002","stockInNo":"ST20260312002","deliveryNo":"DEL20260312014","deliveryId":"DEL014","orderId":"ORD011","orderNo":"ORD20260312011","supplierId":"S1001","supplierName":"王五","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-12 17:12","operator":"李四","grossWeight":20,"tareWeight":15,"netWeight":5,"deduction":0.48,"actualWeight":4.52,"price":2400,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":10853,"amountWithTax":10961.53,"totalAmount":10961.53,"quality":"一级","photos":["plate_DEL014.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-12 16:22","operator":"王门卫","photo":"entry_DEL014.jpg"},"entryWeighInfo":{"at":"2026-03-12 16:42","operator":"李四","photo":"weigh_in_DEL014.jpg"},"qualityInfo":{"at":"2026-03-12 16:57","operator":"张质检","photo":"quality_DEL014.jpg"},"exitWeighInfo":{"at":"2026-03-12 17:00","operator":"李四","photo":"weigh_out_DEL014.jpg"},"exitCheckInfo":{"at":"2026-03-12 17:22","operator":"王门卫","photo":"exit_DEL014.jpg"},"settlementNo":"SET20260312008","hasSettlement":true,"status":"已结算","createdAt":"2026-03-12 17:12","updatedAt":"2026-03-12 17:12"},
  {"id":"SI20260308008","stockInNo":"SI20260308008","deliveryNo":"DEL20260308015","deliveryId":"DEL015","orderId":"ORD015","orderNo":"ORD20260308015","supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","materialId":"M002","materialName":"特级破碎料","stockInTime":"2026-03-08 15:12","operator":"李四","grossWeight":29,"tareWeight":13,"netWeight":16,"deduction":0.21,"actualWeight":15.79,"price":2529,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":39940,"amountWithTax":40339.4,"totalAmount":40339.4,"quality":"一级","photos":["plate_DEL015.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 14:22","operator":"王门卫","photo":"entry_DEL015.jpg"},"entryWeighInfo":{"at":"2026-03-08 14:42","operator":"李四","photo":"weigh_in_DEL015.jpg"},"qualityInfo":{"at":"2026-03-08 14:57","operator":"张质检","photo":"quality_DEL015.jpg"},"exitWeighInfo":{"at":"2026-03-08 15:00","operator":"李四","photo":"weigh_out_DEL015.jpg"},"exitCheckInfo":{"at":"2026-03-08 15:22","operator":"王门卫","photo":"exit_DEL015.jpg"},"settlementNo":"SET20260308010","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 15:12","updatedAt":"2026-03-08 15:12"},
  {"id":"SI20260308009","stockInNo":"SI20260308009","deliveryNo":"DEL20260308016","deliveryId":"DEL016","orderId":"ORD015","orderNo":"ORD20260308015","supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","materialId":"M002","materialName":"特级破碎料","stockInTime":"2026-03-08 17:12","operator":"李四","grossWeight":21,"tareWeight":16,"netWeight":5,"deduction":0.29,"actualWeight":4.71,"price":2529,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":11910,"amountWithTax":12029.1,"totalAmount":12029.1,"quality":"二级","photos":["plate_DEL016.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 16:22","operator":"王门卫","photo":"entry_DEL016.jpg"},"entryWeighInfo":{"at":"2026-03-08 16:42","operator":"李四","photo":"weigh_in_DEL016.jpg"},"qualityInfo":{"at":"2026-03-08 16:57","operator":"张质检","photo":"quality_DEL016.jpg"},"exitWeighInfo":{"at":"2026-03-08 17:00","operator":"李四","photo":"weigh_out_DEL016.jpg"},"exitCheckInfo":{"at":"2026-03-08 17:22","operator":"王门卫","photo":"exit_DEL016.jpg"},"settlementNo":"SET20260308010","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 17:12","updatedAt":"2026-03-08 17:12"},
  {"id":"ST20260308003","stockInNo":"ST20260308003","deliveryNo":"DEL20260308017","deliveryId":"DEL017","orderId":"ORD015","orderNo":"ORD20260308015","supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","materialId":"M002","materialName":"特级破碎料","stockInTime":"2026-03-08 19:12","operator":"李四","grossWeight":33,"tareWeight":13,"netWeight":20,"deduction":0.82,"actualWeight":19.18,"price":2529,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":48506,"amountWithTax":48991.06,"totalAmount":48991.06,"quality":"一级","photos":["plate_DEL017.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 18:22","operator":"王门卫","photo":"entry_DEL017.jpg"},"entryWeighInfo":{"at":"2026-03-08 18:42","operator":"李四","photo":"weigh_in_DEL017.jpg"},"qualityInfo":{"at":"2026-03-08 18:57","operator":"张质检","photo":"quality_DEL017.jpg"},"exitWeighInfo":{"at":"2026-03-08 19:00","operator":"李四","photo":"weigh_out_DEL017.jpg"},"exitCheckInfo":{"at":"2026-03-08 19:22","operator":"王门卫","photo":"exit_DEL017.jpg"},"settlementNo":"SET20260308010","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 19:12","updatedAt":"2026-03-08 19:12"},
  {"id":"SI20260307010","stockInNo":"SI20260307010","deliveryNo":"DEL20260307018","deliveryId":"DEL018","orderId":"ORD016","orderNo":"ORD20260307016","supplierId":"S1001","supplierName":"王五","baseId":"B003","baseName":"马钢诚兴杭州湾基地","materialId":"M003","materialName":"统料废钢","stockInTime":"2026-03-07 15:12","operator":"李四","grossWeight":29,"tareWeight":12,"netWeight":17,"deduction":0.07,"actualWeight":16.93,"price":2185,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":36991,"amountWithTax":37360.91,"totalAmount":37360.91,"quality":"合格","photos":["plate_DEL018.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-07 14:22","operator":"王门卫","photo":"entry_DEL018.jpg"},"entryWeighInfo":{"at":"2026-03-07 14:42","operator":"李四","photo":"weigh_in_DEL018.jpg"},"qualityInfo":{"at":"2026-03-07 14:57","operator":"张质检","photo":"quality_DEL018.jpg"},"exitWeighInfo":{"at":"2026-03-07 15:00","operator":"李四","photo":"weigh_out_DEL018.jpg"},"exitCheckInfo":{"at":"2026-03-07 15:22","operator":"王门卫","photo":"exit_DEL018.jpg"},"settlementNo":null,"hasSettlement":false,"status":"已入库","createdAt":"2026-03-07 15:12","updatedAt":"2026-03-07 15:12"},
  {"id":"SI20260307011","stockInNo":"SI20260307011","deliveryNo":"DEL20260307019","deliveryId":"DEL019","orderId":"ORD016","orderNo":"ORD20260307016","supplierId":"S1001","supplierName":"王五","baseId":"B003","baseName":"马钢诚兴杭州湾基地","materialId":"M003","materialName":"统料废钢","stockInTime":"2026-03-07 17:12","operator":"李四","grossWeight":29,"tareWeight":16,"netWeight":13,"deduction":0.44,"actualWeight":12.56,"price":2185,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":27438,"amountWithTax":27712.38,"totalAmount":27712.38,"quality":"二级","photos":["plate_DEL019.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-07 16:22","operator":"王门卫","photo":"entry_DEL019.jpg"},"entryWeighInfo":{"at":"2026-03-07 16:42","operator":"李四","photo":"weigh_in_DEL019.jpg"},"qualityInfo":{"at":"2026-03-07 16:57","operator":"张质检","photo":"quality_DEL019.jpg"},"exitWeighInfo":{"at":"2026-03-07 17:00","operator":"李四","photo":"weigh_out_DEL019.jpg"},"exitCheckInfo":{"at":"2026-03-07 17:22","operator":"王门卫","photo":"exit_DEL019.jpg"},"settlementNo":"SET20260307013","hasSettlement":true,"status":"已结算","createdAt":"2026-03-07 17:12","updatedAt":"2026-03-07 17:12"},
  {"id":"SI20260303012","stockInNo":"SI20260303012","deliveryNo":"DEL20260303020","deliveryId":"DEL020","orderId":"ORD020","orderNo":"ORD20260303020","supplierId":"S1005","supplierName":"吴九","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M005","materialName":"钢筋头","stockInTime":"2026-03-03 15:12","operator":"李四","grossWeight":21,"tareWeight":15,"netWeight":6,"deduction":0.39,"actualWeight":5.61,"price":2359,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":13226,"amountWithTax":13358.26,"totalAmount":13358.26,"quality":"二级","photos":["plate_DEL020.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-03 14:22","operator":"王门卫","photo":"entry_DEL020.jpg"},"entryWeighInfo":{"at":"2026-03-03 14:42","operator":"李四","photo":"weigh_in_DEL020.jpg"},"qualityInfo":{"at":"2026-03-03 14:57","operator":"张质检","photo":"quality_DEL020.jpg"},"exitWeighInfo":{"at":"2026-03-03 15:00","operator":"李四","photo":"weigh_out_DEL020.jpg"},"exitCheckInfo":{"at":"2026-03-03 15:22","operator":"王门卫","photo":"exit_DEL020.jpg"},"settlementNo":"SET20260303014","hasSettlement":true,"status":"已结算","createdAt":"2026-03-03 15:12","updatedAt":"2026-03-03 15:12"},
  {"id":"ST20260303004","stockInNo":"ST20260303004","deliveryNo":"DEL20260303021","deliveryId":"DEL021","orderId":"ORD020","orderNo":"ORD20260303020","supplierId":"S1005","supplierName":"吴九","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M005","materialName":"钢筋头","stockInTime":"2026-03-03 17:12","operator":"李四","grossWeight":33,"tareWeight":12,"netWeight":21,"deduction":0.54,"actualWeight":20.46,"price":2359,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":48274,"amountWithTax":48756.74,"totalAmount":48756.74,"quality":"合格","photos":["plate_DEL021.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-03 16:22","operator":"王门卫","photo":"entry_DEL021.jpg"},"entryWeighInfo":{"at":"2026-03-03 16:42","operator":"李四","photo":"weigh_in_DEL021.jpg"},"qualityInfo":{"at":"2026-03-03 16:57","operator":"张质检","photo":"quality_DEL021.jpg"},"exitWeighInfo":{"at":"2026-03-03 17:00","operator":"李四","photo":"weigh_out_DEL021.jpg"},"exitCheckInfo":{"at":"2026-03-03 17:22","operator":"王门卫","photo":"exit_DEL021.jpg"},"settlementNo":"SET20260303014","hasSettlement":true,"status":"已结算","createdAt":"2026-03-03 17:12","updatedAt":"2026-03-03 17:12"},
  {"id":"SI20260303013","stockInNo":"SI20260303013","deliveryNo":"DEL20260303022","deliveryId":"DEL022","orderId":"ORD020","orderNo":"ORD20260303020","supplierId":"S1005","supplierName":"吴九","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M005","materialName":"钢筋头","stockInTime":"2026-03-03 19:12","operator":"李四","grossWeight":29,"tareWeight":15,"netWeight":14,"deduction":0.27,"actualWeight":13.73,"price":2359,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":32400,"amountWithTax":32724,"totalAmount":32724,"quality":"二级","photos":["plate_DEL022.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-03 18:22","operator":"王门卫","photo":"entry_DEL022.jpg"},"entryWeighInfo":{"at":"2026-03-03 18:42","operator":"李四","photo":"weigh_in_DEL022.jpg"},"qualityInfo":{"at":"2026-03-03 18:57","operator":"张质检","photo":"quality_DEL022.jpg"},"exitWeighInfo":{"at":"2026-03-03 19:00","operator":"李四","photo":"weigh_out_DEL022.jpg"},"exitCheckInfo":{"at":"2026-03-03 19:22","operator":"王门卫","photo":"exit_DEL022.jpg"},"settlementNo":"SET20260303014","hasSettlement":true,"status":"已结算","createdAt":"2026-03-03 19:12","updatedAt":"2026-03-03 19:12"},
  {"id":"SI20260303014","stockInNo":"SI20260303014","deliveryNo":"DEL20260303023","deliveryId":"DEL023","orderId":"ORD020","orderNo":"ORD20260303020","supplierId":"S1005","supplierName":"吴九","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M005","materialName":"钢筋头","stockInTime":"2026-03-03 21:12","operator":"李四","grossWeight":32,"tareWeight":12,"netWeight":20,"deduction":0.22,"actualWeight":19.78,"price":2359,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":46666,"amountWithTax":47132.66,"totalAmount":47132.66,"quality":"一级","photos":["plate_DEL023.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-03 20:22","operator":"王门卫","photo":"entry_DEL023.jpg"},"entryWeighInfo":{"at":"2026-03-03 20:42","operator":"李四","photo":"weigh_in_DEL023.jpg"},"qualityInfo":{"at":"2026-03-03 20:57","operator":"张质检","photo":"quality_DEL023.jpg"},"exitWeighInfo":{"at":"2026-03-03 21:00","operator":"李四","photo":"weigh_out_DEL023.jpg"},"exitCheckInfo":{"at":"2026-03-03 21:22","operator":"王门卫","photo":"exit_DEL023.jpg"},"settlementNo":"SET20260303014","hasSettlement":true,"status":"已结算","createdAt":"2026-03-03 21:12","updatedAt":"2026-03-03 21:12"},
  {"id":"SI20260312015","stockInNo":"SI20260312015","deliveryNo":"DEL20260312025","deliveryId":"DEL025","orderId":"ORD021","orderNo":"ORD20260312021","supplierId":"S1001","supplierName":"王五","baseId":"B002","baseName":"马钢诚兴上海分公司","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-12 17:12","operator":"李四","grossWeight":34,"tareWeight":15,"netWeight":19,"deduction":0.1,"actualWeight":18.9,"price":2361,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":44626,"amountWithTax":45072.26,"totalAmount":45072.26,"quality":"二级","photos":["plate_DEL025.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-12 16:22","operator":"王门卫","photo":"entry_DEL025.jpg"},"entryWeighInfo":{"at":"2026-03-12 16:42","operator":"李四","photo":"weigh_in_DEL025.jpg"},"qualityInfo":{"at":"2026-03-12 16:57","operator":"张质检","photo":"quality_DEL025.jpg"},"exitWeighInfo":{"at":"2026-03-12 17:00","operator":"李四","photo":"weigh_out_DEL025.jpg"},"exitCheckInfo":{"at":"2026-03-12 17:22","operator":"王门卫","photo":"exit_DEL025.jpg"},"settlementNo":null,"hasSettlement":false,"status":"已入库","createdAt":"2026-03-12 17:12","updatedAt":"2026-03-12 17:12"},
  {"id":"SI20260308016","stockInNo":"SI20260308016","deliveryNo":"DEL20260308026","deliveryId":"DEL026","orderId":"ORD025","orderNo":"ORD20260308025","supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","materialId":"M002","materialName":"特级破碎料","stockInTime":"2026-03-08 15:12","operator":"李四","grossWeight":22,"tareWeight":12,"netWeight":10,"deduction":0.74,"actualWeight":9.26,"price":2560,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":23700,"amountWithTax":23937,"totalAmount":23937,"quality":"二级","photos":["plate_DEL026.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 14:22","operator":"王门卫","photo":"entry_DEL026.jpg"},"entryWeighInfo":{"at":"2026-03-08 14:42","operator":"李四","photo":"weigh_in_DEL026.jpg"},"qualityInfo":{"at":"2026-03-08 14:57","operator":"张质检","photo":"quality_DEL026.jpg"},"exitWeighInfo":{"at":"2026-03-08 15:00","operator":"李四","photo":"weigh_out_DEL026.jpg"},"exitCheckInfo":{"at":"2026-03-08 15:22","operator":"王门卫","photo":"exit_DEL026.jpg"},"settlementNo":"SET20260308018","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 15:12","updatedAt":"2026-03-08 15:12"},
  {"id":"SI20260308017","stockInNo":"SI20260308017","deliveryNo":"DEL20260308027","deliveryId":"DEL027","orderId":"ORD025","orderNo":"ORD20260308025","supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","materialId":"M002","materialName":"特级破碎料","stockInTime":"2026-03-08 17:12","operator":"李四","grossWeight":30,"tareWeight":16,"netWeight":14,"deduction":0.52,"actualWeight":13.48,"price":2560,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":34500,"amountWithTax":34845,"totalAmount":34845,"quality":"一级","photos":["plate_DEL027.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 16:22","operator":"王门卫","photo":"entry_DEL027.jpg"},"entryWeighInfo":{"at":"2026-03-08 16:42","operator":"李四","photo":"weigh_in_DEL027.jpg"},"qualityInfo":{"at":"2026-03-08 16:57","operator":"张质检","photo":"quality_DEL027.jpg"},"exitWeighInfo":{"at":"2026-03-08 17:00","operator":"李四","photo":"weigh_out_DEL027.jpg"},"exitCheckInfo":{"at":"2026-03-08 17:22","operator":"王门卫","photo":"exit_DEL027.jpg"},"settlementNo":"SET20260308018","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 17:12","updatedAt":"2026-03-08 17:12"},
  {"id":"ST20260308005","stockInNo":"ST20260308005","deliveryNo":"DEL20260308028","deliveryId":"DEL028","orderId":"ORD025","orderNo":"ORD20260308025","supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","materialId":"M002","materialName":"特级破碎料","stockInTime":"2026-03-08 19:12","operator":"李四","grossWeight":28,"tareWeight":14,"netWeight":14,"deduction":0.3,"actualWeight":13.7,"price":2560,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":35080,"amountWithTax":35430.8,"totalAmount":35430.8,"quality":"合格","photos":["plate_DEL028.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 18:22","operator":"王门卫","photo":"entry_DEL028.jpg"},"entryWeighInfo":{"at":"2026-03-08 18:42","operator":"李四","photo":"weigh_in_DEL028.jpg"},"qualityInfo":{"at":"2026-03-08 18:57","operator":"张质检","photo":"quality_DEL028.jpg"},"exitWeighInfo":{"at":"2026-03-08 19:00","operator":"李四","photo":"weigh_out_DEL028.jpg"},"exitCheckInfo":{"at":"2026-03-08 19:22","operator":"王门卫","photo":"exit_DEL028.jpg"},"settlementNo":"SET20260308018","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 19:12","updatedAt":"2026-03-08 19:12"},
  {"id":"SI20260225018","stockInNo":"SI20260225018","deliveryNo":"DEL20260225029","deliveryId":"DEL029","orderId":"ORD026","orderNo":"ORD20260225026","supplierId":"S1006","supplierName":"郑十","baseId":"B001","baseName":"马钢诚兴台州基地","materialId":"M003","materialName":"统料废钢","stockInTime":"2026-02-25 15:12","operator":"李四","grossWeight":31,"tareWeight":14,"netWeight":17,"deduction":0.98,"actualWeight":16.02,"price":2343,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":37545,"amountWithTax":37920.45,"totalAmount":37920.45,"quality":"一级","photos":["plate_DEL029.jpg"],"confirmed":true,"entryInfo":{"at":"2026-02-25 14:22","operator":"王门卫","photo":"entry_DEL029.jpg"},"entryWeighInfo":{"at":"2026-02-25 14:42","operator":"李四","photo":"weigh_in_DEL029.jpg"},"qualityInfo":{"at":"2026-02-25 14:57","operator":"张质检","photo":"quality_DEL029.jpg"},"exitWeighInfo":{"at":"2026-02-25 15:00","operator":"李四","photo":"weigh_out_DEL029.jpg"},"exitCheckInfo":{"at":"2026-02-25 15:22","operator":"王门卫","photo":"exit_DEL029.jpg"},"settlementNo":"SET20260225021","hasSettlement":true,"status":"已结算","createdAt":"2026-02-25 15:12","updatedAt":"2026-02-25 15:12"},
  {"id":"SI20260222019","stockInNo":"SI20260222019","deliveryNo":"DEL20260222030","deliveryId":"DEL030","orderId":"ORD027","orderNo":"ORD20260222027","supplierId":"S1007","supplierName":"钱十一","baseId":"B005","baseName":"马钢诚兴无锡基地","materialId":"M003","materialName":"统料废钢","stockInTime":"2026-02-22 15:12","operator":"李四","grossWeight":24,"tareWeight":16,"netWeight":8,"deduction":0.29,"actualWeight":7.71,"price":2310,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":17799,"amountWithTax":17976.99,"totalAmount":17976.99,"quality":"二级","photos":["plate_DEL030.jpg"],"confirmed":true,"entryInfo":{"at":"2026-02-22 14:22","operator":"王门卫","photo":"entry_DEL030.jpg"},"entryWeighInfo":{"at":"2026-02-22 14:42","operator":"李四","photo":"weigh_in_DEL030.jpg"},"qualityInfo":{"at":"2026-02-22 14:57","operator":"张质检","photo":"quality_DEL030.jpg"},"exitWeighInfo":{"at":"2026-02-22 15:00","operator":"李四","photo":"weigh_out_DEL030.jpg"},"exitCheckInfo":{"at":"2026-02-22 15:22","operator":"王门卫","photo":"exit_DEL030.jpg"},"settlementNo":"SET20260222022","hasSettlement":true,"status":"已结算","createdAt":"2026-02-22 15:12","updatedAt":"2026-02-22 15:12"},
  {"id":"ST20260219006","stockInNo":"ST20260219006","deliveryNo":"DEL20260219031","deliveryId":"DEL031","orderId":"ORD028","orderNo":"ORD20260219028","supplierId":"S1010","supplierName":"刘十四","baseId":"B004","baseName":"马钢诚兴南京分公司","materialId":"M005","materialName":"钢筋头","stockInTime":"2026-02-19 15:12","operator":"李四","grossWeight":28,"tareWeight":13,"netWeight":15,"deduction":0.95,"actualWeight":14.05,"price":2446,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":34355,"amountWithTax":34698.55,"totalAmount":34698.55,"quality":"二级","photos":["plate_DEL031.jpg"],"confirmed":true,"entryInfo":{"at":"2026-02-19 14:22","operator":"王门卫","photo":"entry_DEL031.jpg"},"entryWeighInfo":{"at":"2026-02-19 14:42","operator":"李四","photo":"weigh_in_DEL031.jpg"},"qualityInfo":{"at":"2026-02-19 14:57","operator":"张质检","photo":"quality_DEL031.jpg"},"exitWeighInfo":{"at":"2026-02-19 15:00","operator":"李四","photo":"weigh_out_DEL031.jpg"},"exitCheckInfo":{"at":"2026-02-19 15:22","operator":"王门卫","photo":"exit_DEL031.jpg"},"settlementNo":"SET20260219023","hasSettlement":true,"status":"已结算","createdAt":"2026-02-19 15:12","updatedAt":"2026-02-19 15:12"},
  {"id":"ST20260216007","stockInNo":"ST20260216007","deliveryNo":"DEL20260216032","deliveryId":"DEL032","orderId":"ORD029","orderNo":"ORD20260216029","supplierId":"S1011","supplierName":"陈十五","baseId":"B003","baseName":"马钢诚兴杭州湾基地","materialId":"M003","materialName":"统料废钢","stockInTime":"2026-02-16 15:12","operator":"李四","grossWeight":21,"tareWeight":16,"netWeight":5,"deduction":0.76,"actualWeight":4.24,"price":2254,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":9568,"amountWithTax":9663.68,"totalAmount":9663.68,"quality":"合格","photos":["plate_DEL032.jpg"],"confirmed":true,"entryInfo":{"at":"2026-02-16 14:22","operator":"王门卫","photo":"entry_DEL032.jpg"},"entryWeighInfo":{"at":"2026-02-16 14:42","operator":"李四","photo":"weigh_in_DEL032.jpg"},"qualityInfo":{"at":"2026-02-16 14:57","operator":"张质检","photo":"quality_DEL032.jpg"},"exitWeighInfo":{"at":"2026-02-16 15:00","operator":"李四","photo":"weigh_out_DEL032.jpg"},"exitCheckInfo":{"at":"2026-02-16 15:22","operator":"王门卫","photo":"exit_DEL032.jpg"},"settlementNo":"SET20260216024","hasSettlement":true,"status":"已结算","createdAt":"2026-02-16 15:12","updatedAt":"2026-02-16 15:12"},
  {"id":"SI20260213020","stockInNo":"SI20260213020","deliveryNo":"DEL20260213033","deliveryId":"DEL033","orderId":"ORD030","orderNo":"ORD20260213030","supplierId":"S1012","supplierName":"黄十六","baseId":"B003","baseName":"马钢诚兴杭州湾基地","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-02-13 15:12","operator":"李四","grossWeight":28,"tareWeight":15,"netWeight":13,"deduction":0.37,"actualWeight":12.63,"price":2455,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":30999,"amountWithTax":31308.99,"totalAmount":31308.99,"quality":"一级","photos":["plate_DEL033.jpg"],"confirmed":true,"entryInfo":{"at":"2026-02-13 14:22","operator":"王门卫","photo":"entry_DEL033.jpg"},"entryWeighInfo":{"at":"2026-02-13 14:42","operator":"李四","photo":"weigh_in_DEL033.jpg"},"qualityInfo":{"at":"2026-02-13 14:57","operator":"张质检","photo":"quality_DEL033.jpg"},"exitWeighInfo":{"at":"2026-02-13 15:00","operator":"李四","photo":"weigh_out_DEL033.jpg"},"exitCheckInfo":{"at":"2026-02-13 15:22","operator":"王门卫","photo":"exit_DEL033.jpg"},"settlementNo":"SET20260213025","hasSettlement":true,"status":"已结算","createdAt":"2026-02-13 15:12","updatedAt":"2026-02-13 15:12"},
  {"id":"SI20260312021","stockInNo":"SI20260312021","deliveryNo":"DEL20260312034","deliveryId":"DEL034","orderId":"ORD031","orderNo":"ORD20260312031","supplierId":"S1004","supplierName":"周八","baseId":"B003","baseName":"马钢诚兴杭州湾基地","materialId":"M005","materialName":"钢筋头","stockInTime":"2026-03-12 15:12","operator":"李四","grossWeight":32,"tareWeight":16,"netWeight":16,"deduction":0.89,"actualWeight":15.11,"price":2380,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":35968,"amountWithTax":36327.68,"totalAmount":36327.68,"quality":"一级","photos":["plate_DEL034.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-12 14:22","operator":"王门卫","photo":"entry_DEL034.jpg"},"entryWeighInfo":{"at":"2026-03-12 14:42","operator":"李四","photo":"weigh_in_DEL034.jpg"},"qualityInfo":{"at":"2026-03-12 14:57","operator":"张质检","photo":"quality_DEL034.jpg"},"exitWeighInfo":{"at":"2026-03-12 15:00","operator":"李四","photo":"weigh_out_DEL034.jpg"},"exitCheckInfo":{"at":"2026-03-12 15:22","operator":"王门卫","photo":"exit_DEL034.jpg"},"settlementNo":"SET20260312026","hasSettlement":true,"status":"已结算","createdAt":"2026-03-12 15:12","updatedAt":"2026-03-12 15:12"},
  {"id":"SI20260311022","stockInNo":"SI20260311022","deliveryNo":"DEL20260311035","deliveryId":"DEL035","orderId":"ORD032","orderNo":"ORD20260311032","supplierId":"S1005","supplierName":"吴九","baseId":"B005","baseName":"马钢诚兴无锡基地","materialId":"M004","materialName":"轻薄料","stockInTime":"2026-03-11 15:12","operator":"李四","grossWeight":30,"tareWeight":14,"netWeight":16,"deduction":0.83,"actualWeight":15.17,"price":1907,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":28925,"amountWithTax":29214.25,"totalAmount":29214.25,"quality":"一级","photos":["plate_DEL035.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-11 14:22","operator":"王门卫","photo":"entry_DEL035.jpg"},"entryWeighInfo":{"at":"2026-03-11 14:42","operator":"李四","photo":"weigh_in_DEL035.jpg"},"qualityInfo":{"at":"2026-03-11 14:57","operator":"张质检","photo":"quality_DEL035.jpg"},"exitWeighInfo":{"at":"2026-03-11 15:00","operator":"李四","photo":"weigh_out_DEL035.jpg"},"exitCheckInfo":{"at":"2026-03-11 15:22","operator":"王门卫","photo":"exit_DEL035.jpg"},"settlementNo":"SET20260311027","hasSettlement":true,"status":"已结算","createdAt":"2026-03-11 15:12","updatedAt":"2026-03-11 15:12"},
  {"id":"SI20260310023","stockInNo":"SI20260310023","deliveryNo":"DEL20260310036","deliveryId":"DEL036","orderId":"ORD033","orderNo":"ORD20260310033","supplierId":"S1012","supplierName":"黄十六","baseId":"B001","baseName":"马钢诚兴台州基地","materialId":"M003","materialName":"统料废钢","stockInTime":"2026-03-10 15:12","operator":"李四","grossWeight":29,"tareWeight":15,"netWeight":14,"deduction":0.19,"actualWeight":13.81,"price":2295,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":31700,"amountWithTax":32017,"totalAmount":32017,"quality":"合格","photos":["plate_DEL036.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-10 14:22","operator":"王门卫","photo":"entry_DEL036.jpg"},"entryWeighInfo":{"at":"2026-03-10 14:42","operator":"李四","photo":"weigh_in_DEL036.jpg"},"qualityInfo":{"at":"2026-03-10 14:57","operator":"张质检","photo":"quality_DEL036.jpg"},"exitWeighInfo":{"at":"2026-03-10 15:00","operator":"李四","photo":"weigh_out_DEL036.jpg"},"exitCheckInfo":{"at":"2026-03-10 15:22","operator":"王门卫","photo":"exit_DEL036.jpg"},"settlementNo":"SET20260310028","hasSettlement":true,"status":"已结算","createdAt":"2026-03-10 15:12","updatedAt":"2026-03-10 15:12"},
  {"id":"ST20260309008","stockInNo":"ST20260309008","deliveryNo":"DEL20260309037","deliveryId":"DEL037","orderId":"ORD034","orderNo":"ORD20260309034","supplierId":"S1012","supplierName":"黄十六","baseId":"B004","baseName":"马钢诚兴南京分公司","materialId":"M001","materialName":"工业重废毛料","stockInTime":"2026-03-09 15:12","operator":"李四","grossWeight":30,"tareWeight":14,"netWeight":16,"deduction":0.7,"actualWeight":15.3,"price":2464,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":37695,"amountWithTax":38071.95,"totalAmount":38071.95,"quality":"一级","photos":["plate_DEL037.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-09 14:22","operator":"王门卫","photo":"entry_DEL037.jpg"},"entryWeighInfo":{"at":"2026-03-09 14:42","operator":"李四","photo":"weigh_in_DEL037.jpg"},"qualityInfo":{"at":"2026-03-09 14:57","operator":"张质检","photo":"quality_DEL037.jpg"},"exitWeighInfo":{"at":"2026-03-09 15:00","operator":"李四","photo":"weigh_out_DEL037.jpg"},"exitCheckInfo":{"at":"2026-03-09 15:22","operator":"王门卫","photo":"exit_DEL037.jpg"},"settlementNo":"SET20260309029","hasSettlement":true,"status":"已结算","createdAt":"2026-03-09 15:12","updatedAt":"2026-03-09 15:12"},
  {"id":"ST20260308009","stockInNo":"ST20260308009","deliveryNo":"DEL20260308038","deliveryId":"DEL038","orderId":"ORD035","orderNo":"ORD20260308035","supplierId":"S1004","supplierName":"周八","baseId":"B003","baseName":"马钢诚兴杭州湾基地","materialId":"M005","materialName":"钢筋头","stockInTime":"2026-03-08 15:12","operator":"李四","grossWeight":24,"tareWeight":15,"netWeight":9,"deduction":0.05,"actualWeight":8.95,"price":2403,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":21498,"amountWithTax":21712.98,"totalAmount":21712.98,"quality":"合格","photos":["plate_DEL038.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-08 14:22","operator":"王门卫","photo":"entry_DEL038.jpg"},"entryWeighInfo":{"at":"2026-03-08 14:42","operator":"李四","photo":"weigh_in_DEL038.jpg"},"qualityInfo":{"at":"2026-03-08 14:57","operator":"张质检","photo":"quality_DEL038.jpg"},"exitWeighInfo":{"at":"2026-03-08 15:00","operator":"李四","photo":"weigh_out_DEL038.jpg"},"exitCheckInfo":{"at":"2026-03-08 15:22","operator":"王门卫","photo":"exit_DEL038.jpg"},"settlementNo":"SET20260308030","hasSettlement":true,"status":"已结算","createdAt":"2026-03-08 15:12","updatedAt":"2026-03-08 15:12"},
  {"id":"SI20260307024","stockInNo":"SI20260307024","deliveryNo":"DEL20260307039","deliveryId":"DEL039","orderId":"ORD036","orderNo":"ORD20260307036","supplierId":"S1001","supplierName":"王五","baseId":"B001","baseName":"马钢诚兴台州基地","materialId":"M003","materialName":"统料废钢","stockInTime":"2026-03-07 15:12","operator":"李四","grossWeight":25,"tareWeight":12,"netWeight":13,"deduction":0.71,"actualWeight":12.29,"price":2341,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":28764,"amountWithTax":29051.64,"totalAmount":29051.64,"quality":"合格","photos":["plate_DEL039.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-07 14:22","operator":"王门卫","photo":"entry_DEL039.jpg"},"entryWeighInfo":{"at":"2026-03-07 14:42","operator":"李四","photo":"weigh_in_DEL039.jpg"},"qualityInfo":{"at":"2026-03-07 14:57","operator":"张质检","photo":"quality_DEL039.jpg"},"exitWeighInfo":{"at":"2026-03-07 15:00","operator":"李四","photo":"weigh_out_DEL039.jpg"},"exitCheckInfo":{"at":"2026-03-07 15:22","operator":"王门卫","photo":"exit_DEL039.jpg"},"settlementNo":"SET20260307031","hasSettlement":true,"status":"已结算","createdAt":"2026-03-07 15:12","updatedAt":"2026-03-07 15:12"},
  {"id":"SI20260306025","stockInNo":"SI20260306025","deliveryNo":"DEL20260306040","deliveryId":"DEL040","orderId":"ORD037","orderNo":"ORD20260306037","supplierId":"S1004","supplierName":"周八","baseId":"B004","baseName":"马钢诚兴南京分公司","materialId":"M003","materialName":"统料废钢","stockInTime":"2026-03-06 15:12","operator":"李四","grossWeight":26,"tareWeight":14,"netWeight":12,"deduction":0.43,"actualWeight":11.57,"price":2242,"taxRate":1,"invoiceType":"反向开票","amountWithoutTax":25938,"amountWithTax":26197.38,"totalAmount":26197.38,"quality":"二级","photos":["plate_DEL040.jpg"],"confirmed":true,"entryInfo":{"at":"2026-03-06 14:22","operator":"王门卫","photo":"entry_DEL040.jpg"},"entryWeighInfo":{"at":"2026-03-06 14:42","operator":"李四","photo":"weigh_in_DEL040.jpg"},"qualityInfo":{"at":"2026-03-06 14:57","operator":"张质检","photo":"quality_DEL040.jpg"},"exitWeighInfo":{"at":"2026-03-06 15:00","operator":"李四","photo":"weigh_out_DEL040.jpg"},"exitCheckInfo":{"at":"2026-03-06 15:22","operator":"王门卫","photo":"exit_DEL040.jpg"},"settlementNo":"SET20260306032","hasSettlement":true,"status":"已结算","createdAt":"2026-03-06 15:12","updatedAt":"2026-03-06 15:12"}
];

// ============ 预约单数据（兼容旧代码）============

export const mockReservations = [
  { id: 'R2026030101', supplier: '王五', plate: '浙J99999', material: '工业重废', time: '2026-03-02 10:00', status: '待入场', driver: '王师傅', contact: '137****9999', contractId: 'C20260228001' },
  { id: 'R2026030102', supplier: '赵六', plate: '沪A12345', material: '特级破碎料', time: '2026-03-02 14:00', status: '待入场', driver: '张师傅', contact: '135****5555', contractId: 'C20260301001' },
];

// ============ 通知数据 ============

export const initialNotifications = [
  { id: 'N001', type: 'approval', title: '审批待处理', content: '您有2个订单待审批', time: '2026-03-01 09:30', read: false, link: 'approval' },
  { id: 'N002', type: 'delivery', title: '送货单状态更新', content: '送货单 DEL20260301002 已到场，等待订单审批通过', time: '2026-03-01 10:35', read: false, link: 'delivery' },
  { id: 'N003', type: 'settlement', title: '结算待确认', content: '送货单 DEL20260228002 结算单待供应商确认', time: '2026-02-28 17:30', read: true, link: 'settlement' },
];

// ============ 辅助函数 ============

/**
 * 根据订单ID获取关联的送货单
 */
export const getDeliveriesByOrderId = (orderId) => {
  return mockDeliveries.filter(d => d.orderId === orderId);
};

/**
 * 根据送货单ID获取详情
 */
export const getDeliveryById = (deliveryId) => {
  return mockDeliveries.find(d => d.id === deliveryId);
};

/**
 * 根据订单ID获取详情
 */
export const getOrderById = (orderId) => {
  return mockOrders.find(o => o.id === orderId);
};

// ============ 用户操作日志数据 ============

/**
 * 用户操作日志 Mock 数据
 * 记录用户在交易过程中的关键操作，作为交易存证
 */

export const mockOperationLogs = [
  // ===== 王五 (S1001) 的操作日志 =====
  {
    id: 'LOG001',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'user_register',
    operationGroup: 'registration',
    timestamp: '2025-06-15T09:30:00+08:00',
    description: '用户注册账号',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      registerMethod: '手机号注册',
      smsCode: '****',
    },
    deviceInfo: {
      ip: '183.128.45.67',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '',
  },
  {
    id: 'LOG002',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'id_card_upload',
    operationGroup: 'registration',
    timestamp: '2025-06-15T09:35:00+08:00',
    description: '上传身份证正反面照片',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'id_card_front',
    evidenceUrl: '/evidence/S1001/id_card_front.jpg',
    evidenceThumbnail: '/evidence/S1001/id_card_front_thumb.jpg',
    snapshot: {
      idCardNo: '331002198010101234',
      realName: '王五',
      idCardFront: '/evidence/S1001/id_card_front.jpg',
      idCardBack: '/evidence/S1001/id_card_back.jpg',
      ocrResult: {
        name: '王五',
        gender: '男',
        nation: '汉',
        birth: '1980-10-10',
        address: '浙江省台州市路桥区xxx街道xxx号',
      },
    },
    deviceInfo: {
      ip: '183.128.45.67',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: 'OCR识别成功',
  },
  {
    id: 'LOG003',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'bank_card_upload',
    operationGroup: 'registration',
    timestamp: '2025-06-15T09:42:00+08:00',
    description: '上传银行卡照片并绑定',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'bank_card',
    evidenceUrl: '/evidence/S1001/bank_card.jpg',
    evidenceThumbnail: '/evidence/S1001/bank_card_thumb.jpg',
    snapshot: {
      bankName: '中国农业银行',
      bankAccount: '622848003812345678',
      bankBranch: '台州分行',
      cardType: '借记卡',
    },
    deviceInfo: {
      ip: '183.128.45.67',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '银行卡绑定成功',
  },
  {
    id: 'LOG004',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'auth_approved',
    operationGroup: 'registration',
    timestamp: '2025-06-15T10:15:00+08:00',
    description: '实名认证审核通过',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      auditor: '系统自动审核',
      auditResult: '通过',
      auditNote: '身份信息与银行卡信息一致',
    },
    deviceInfo: {
      ip: '10.0.0.1',
      device: 'Server',
      os: 'Linux',
      browser: 'System',
      location: '浙江省杭州市',
    },
    remark: '三要素验证通过',
  },
  {
    id: 'LOG005',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'order_create',
    operationGroup: 'order',
    timestamp: '2026-03-01T14:30:00+08:00',
    description: '创建订单 ORD20260301001',
    documentType: 'order',
    documentId: 'ORD001',
    documentNo: 'ORD20260301001',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260301001',
      materialName: '工业重废毛料',
      baseName: '马钢诚兴台州基地',
      estimatedWeight: 50,
      estimatedAmount: 120000,
      price: 2400,
    },
    deviceInfo: {
      ip: '183.128.45.67',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '',
  },
  {
    id: 'LOG006',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'order_agree_contract',
    operationGroup: 'order',
    timestamp: '2026-03-01T14:35:00+08:00',
    description: '勾选同意《采购协议》和《隐私协议》',
    documentType: 'order',
    documentId: 'ORD001',
    documentNo: 'ORD20260301001',
    evidenceType: 'contract',
    evidenceUrl: '/evidence/S1001/contract_ORD001.pdf',
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260301001',
      contracts: [
        { name: '废钢采购协议', version: 'v2.0', agreedAt: '2026-03-01T14:35:00+08:00' },
        { name: '用户隐私协议', version: 'v1.5', agreedAt: '2026-03-01T14:35:00+08:00' },
      ],
    },
    deviceInfo: {
      ip: '183.128.45.67',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '协议签署完成',
  },
  {
    id: 'LOG007',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'order_face_verify',
    operationGroup: 'order',
    timestamp: '2026-03-01T14:38:00+08:00',
    description: '订单提交前人脸识别验证',
    documentType: 'order',
    documentId: 'ORD001',
    documentNo: 'ORD20260301001',
    evidenceType: 'face_video',
    evidenceUrl: '/evidence/S1001/face_verify_ORD001.mp4',
    evidenceThumbnail: '/evidence/S1001/face_verify_ORD001.jpg',
    snapshot: {
      orderNo: 'ORD20260301001',
      verifyMethod: '活体检测+人脸比对',
      verifyResult: '通过',
      similarity: 98.7,
      idCardPhoto: '/evidence/S1001/id_card_front.jpg',
    },
    deviceInfo: {
      ip: '183.128.45.67',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '人脸验证通过，相似度98.7%',
  },
  {
    id: 'LOG008',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'order_submit',
    operationGroup: 'order',
    timestamp: '2026-03-01T14:40:00+08:00',
    description: '提交订单 ORD20260301001',
    documentType: 'order',
    documentId: 'ORD001',
    documentNo: 'ORD20260301001',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260301001',
      status: 'pending_sign',
      materialName: '工业重废毛料',
      estimatedWeight: 50,
      estimatedAmount: 120000,
    },
    deviceInfo: {
      ip: '183.128.45.67',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '订单提交成功，等待签署',
  },
  {
    id: 'LOG009',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'reservation_create',
    operationGroup: 'reservation',
    timestamp: '2026-03-02T08:30:00+08:00',
    description: '创建预约发货 DEL20260302001',
    documentType: 'delivery',
    documentId: 'DEL001',
    documentNo: 'DEL20260302001',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      deliveryNo: 'DEL20260302001',
      orderNo: 'ORD20260301001',
      reservationTime: '2026-03-02 10:00',
      vehicleNo: '浙J12345',
      driverName: '张师傅',
      driverPhone: '139****5678',
    },
    deviceInfo: {
      ip: '183.128.45.67',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '',
  },
  {
    id: 'LOG010',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'reservation_submit',
    operationGroup: 'reservation',
    timestamp: '2026-03-02T08:35:00+08:00',
    description: '提交预约发货 DEL20260302001',
    documentType: 'delivery',
    documentId: 'DEL001',
    documentNo: 'DEL20260302001',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      deliveryNo: 'DEL20260302001',
      status: 'waiting_delivery',
      reservationNo: 'RSV20260302001',
    },
    deviceInfo: {
      ip: '183.128.45.67',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '预约提交成功',
  },
  {
    id: 'LOG011',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'settlement_confirm',
    operationGroup: 'settlement',
    timestamp: '2026-03-03T16:30:00+08:00',
    description: '确认结算单 SET20260303001',
    documentType: 'settlement',
    documentId: 'SET001',
    documentNo: 'SET20260303001',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      settlementNo: 'SET20260303001',
      deliveryNo: 'DEL20260302001',
      unitPrice: 2418,
      actualWeight: 32.1,
      amount: 77594,
      confirmedAt: '2026-03-03T16:30:00+08:00',
    },
    deviceInfo: {
      ip: '183.128.45.68',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '',
  },
  {
    id: 'LOG012',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'settlement_agree_contract',
    operationGroup: 'settlement',
    timestamp: '2026-03-03T16:32:00+08:00',
    description: '勾选同意《结算协议》',
    documentType: 'settlement',
    documentId: 'SET001',
    documentNo: 'SET20260303001',
    evidenceType: 'contract',
    evidenceUrl: '/evidence/S1001/settlement_contract_SET001.pdf',
    evidenceThumbnail: null,
    snapshot: {
      settlementNo: 'SET20260303001',
      contracts: [
        { name: '结算确认协议', version: 'v1.0', agreedAt: '2026-03-03T16:32:00+08:00' },
      ],
    },
    deviceInfo: {
      ip: '183.128.45.68',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '',
  },
  {
    id: 'LOG013',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'settlement_face_verify',
    operationGroup: 'settlement',
    timestamp: '2026-03-03T16:35:00+08:00',
    description: '结算确认人脸识别验证',
    documentType: 'settlement',
    documentId: 'SET001',
    documentNo: 'SET20260303001',
    evidenceType: 'face_video',
    evidenceUrl: '/evidence/S1001/face_verify_SET001.mp4',
    evidenceThumbnail: '/evidence/S1001/face_verify_SET001.jpg',
    snapshot: {
      settlementNo: 'SET20260303001',
      verifyMethod: '活体检测+人脸比对',
      verifyResult: '通过',
      similarity: 99.2,
    },
    deviceInfo: {
      ip: '183.128.45.68',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '人脸验证通过，相似度99.2%',
  },
  {
    id: 'LOG014',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'document_view',
    operationGroup: 'document',
    timestamp: '2026-03-03T17:00:00+08:00',
    description: '查看了入库单 SI20260302001',
    documentType: 'stockin',
    documentId: 'SI001',
    documentNo: 'SI20260302001',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      stockInNo: 'SI20260302001',
      deliveryNo: 'DEL20260302001',
      grossWeight: 48,
      tareWeight: 15,
      netWeight: 33,
      actualWeight: 32.1,
      quality: '合格',
    },
    deviceInfo: {
      ip: '183.128.45.68',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '',
  },
  {
    id: 'LOG015',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'document_view',
    operationGroup: 'document',
    timestamp: '2026-03-05T10:00:00+08:00',
    description: '查看了发票单 INV20260305001',
    documentType: 'invoice',
    documentId: 'INV001',
    documentNo: 'INV20260305001',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      invoiceNo: 'INV20260305001',
      type: '反向开票',
      amount: 78294,
    },
    deviceInfo: {
      ip: '183.128.45.69',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.2',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '',
  },

  // ===== 吴九 (S1005) 的操作日志 =====
  {
    id: 'LOG016',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'user_register',
    operationGroup: 'registration',
    timestamp: '2025-07-20T14:20:00+08:00',
    description: '用户注册账号',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      registerMethod: '手机号注册',
      smsCode: '****',
    },
    deviceInfo: {
      ip: '120.35.78.90',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '',
  },
  {
    id: 'LOG017',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'id_card_upload',
    operationGroup: 'registration',
    timestamp: '2025-07-20T14:25:00+08:00',
    description: '上传身份证正反面照片',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'id_card_front',
    evidenceUrl: '/evidence/S1005/id_card_front.jpg',
    evidenceThumbnail: '/evidence/S1005/id_card_front_thumb.jpg',
    snapshot: {
      idCardNo: '320205198712125678',
      realName: '吴九',
      idCardFront: '/evidence/S1005/id_card_front.jpg',
      idCardBack: '/evidence/S1005/id_card_back.jpg',
      ocrResult: {
        name: '吴九',
        gender: '男',
        nation: '汉',
        birth: '1987-12-12',
        address: '江苏省无锡市惠山区xxx街道xxx号',
      },
    },
    deviceInfo: {
      ip: '120.35.78.90',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: 'OCR识别成功',
  },
  {
    id: 'LOG018',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'bank_card_upload',
    operationGroup: 'registration',
    timestamp: '2025-07-20T14:32:00+08:00',
    description: '上传银行卡照片并绑定',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'bank_card',
    evidenceUrl: '/evidence/S1005/bank_card.jpg',
    evidenceThumbnail: '/evidence/S1005/bank_card_thumb.jpg',
    snapshot: {
      bankName: '浦发银行',
      bankAccount: '9843012345678901',
      bankBranch: '杭州分行',
      cardType: '借记卡',
    },
    deviceInfo: {
      ip: '120.35.78.90',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '银行卡绑定成功',
  },
  {
    id: 'LOG019',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'auth_approved',
    operationGroup: 'registration',
    timestamp: '2025-07-20T15:00:00+08:00',
    description: '实名认证审核通过',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      auditor: '系统自动审核',
      auditResult: '通过',
      auditNote: '身份信息与银行卡信息一致',
    },
    deviceInfo: {
      ip: '10.0.0.1',
      device: 'Server',
      os: 'Linux',
      browser: 'System',
      location: '浙江省杭州市',
    },
    remark: '三要素验证通过',
  },
  {
    id: 'LOG020',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'order_create',
    operationGroup: 'order',
    timestamp: '2026-03-03T09:15:00+08:00',
    description: '创建订单 ORD20260303020',
    documentType: 'order',
    documentId: 'ORD020',
    documentNo: 'ORD20260303020',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260303020',
      materialName: '钢筋头',
      baseName: '马钢诚兴上海分公司',
      estimatedWeight: 80,
      estimatedAmount: 185000,
      price: 2313,
    },
    deviceInfo: {
      ip: '120.35.78.91',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '',
  },
  {
    id: 'LOG021',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'order_agree_contract',
    operationGroup: 'order',
    timestamp: '2026-03-03T09:20:00+08:00',
    description: '勾选同意《采购协议》和《隐私协议》',
    documentType: 'order',
    documentId: 'ORD020',
    documentNo: 'ORD20260303020',
    evidenceType: 'contract',
    evidenceUrl: '/evidence/S1005/contract_ORD020.pdf',
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260303020',
      contracts: [
        { name: '废钢采购协议', version: 'v2.0', agreedAt: '2026-03-03T09:20:00+08:00' },
        { name: '用户隐私协议', version: 'v1.5', agreedAt: '2026-03-03T09:20:00+08:00' },
      ],
    },
    deviceInfo: {
      ip: '120.35.78.91',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '协议签署完成',
  },
  {
    id: 'LOG022',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'order_face_verify',
    operationGroup: 'order',
    timestamp: '2026-03-03T09:23:00+08:00',
    description: '订单提交前人脸识别验证',
    documentType: 'order',
    documentId: 'ORD020',
    documentNo: 'ORD20260303020',
    evidenceType: 'face_video',
    evidenceUrl: '/evidence/S1005/face_verify_ORD020.mp4',
    evidenceThumbnail: '/evidence/S1005/face_verify_ORD020.jpg',
    snapshot: {
      orderNo: 'ORD20260303020',
      verifyMethod: '活体检测+人脸比对',
      verifyResult: '通过',
      similarity: 97.8,
    },
    deviceInfo: {
      ip: '120.35.78.91',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '人脸验证通过，相似度97.8%',
  },
  {
    id: 'LOG023',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'order_submit',
    operationGroup: 'order',
    timestamp: '2026-03-03T09:25:00+08:00',
    description: '提交订单 ORD20260303020',
    documentType: 'order',
    documentId: 'ORD020',
    documentNo: 'ORD20260303020',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260303020',
      status: 'pending_sign',
      materialName: '钢筋头',
      estimatedWeight: 80,
      estimatedAmount: 185000,
    },
    deviceInfo: {
      ip: '120.35.78.91',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '订单提交成功',
  },
  {
    id: 'LOG024',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'reservation_create',
    operationGroup: 'reservation',
    timestamp: '2026-03-03T11:00:00+08:00',
    description: '创建预约发货 DEL20260303020',
    documentType: 'delivery',
    documentId: 'DEL020',
    documentNo: 'DEL20260303020',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      deliveryNo: 'DEL20260303020',
      orderNo: 'ORD20260303020',
      reservationTime: '2026-03-03 13:00',
      vehicleNo: '苏A68149',
      driverName: '赵师傅',
      driverPhone: '138****4408',
    },
    deviceInfo: {
      ip: '120.35.78.92',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '',
  },
  {
    id: 'LOG025',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'reservation_submit',
    operationGroup: 'reservation',
    timestamp: '2026-03-03T11:05:00+08:00',
    description: '提交预约发货 DEL20260303020',
    documentType: 'delivery',
    documentId: 'DEL020',
    documentNo: 'DEL20260303020',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      deliveryNo: 'DEL20260303020',
      status: 'waiting_delivery',
      reservationNo: 'RSV20260303020',
    },
    deviceInfo: {
      ip: '120.35.78.92',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '预约提交成功',
  },
  {
    id: 'LOG026',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'settlement_confirm',
    operationGroup: 'settlement',
    timestamp: '2026-03-04T11:10:00+08:00',
    description: '确认结算单 SET20260303014',
    documentType: 'settlement',
    documentId: 'SET014',
    documentNo: 'SET20260303014',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      settlementNo: 'SET20260303014',
      mergedCount: 4,
      totalAmount: 140566,
      unitPrice: 2359,
    },
    deviceInfo: {
      ip: '120.35.78.93',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '合并结算确认',
  },
  {
    id: 'LOG027',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'settlement_agree_contract',
    operationGroup: 'settlement',
    timestamp: '2026-03-04T11:12:00+08:00',
    description: '勾选同意《结算协议》',
    documentType: 'settlement',
    documentId: 'SET014',
    documentNo: 'SET20260303014',
    evidenceType: 'contract',
    evidenceUrl: '/evidence/S1005/settlement_contract_SET014.pdf',
    evidenceThumbnail: null,
    snapshot: {
      settlementNo: 'SET20260303014',
      contracts: [
        { name: '结算确认协议', version: 'v1.0', agreedAt: '2026-03-04T11:12:00+08:00' },
      ],
    },
    deviceInfo: {
      ip: '120.35.78.93',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '',
  },
  {
    id: 'LOG028',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'settlement_face_verify',
    operationGroup: 'settlement',
    timestamp: '2026-03-04T11:15:00+08:00',
    description: '结算确认人脸识别验证',
    documentType: 'settlement',
    documentId: 'SET014',
    documentNo: 'SET20260303014',
    evidenceType: 'face_video',
    evidenceUrl: '/evidence/S1005/face_verify_SET014.mp4',
    evidenceThumbnail: '/evidence/S1005/face_verify_SET014.jpg',
    snapshot: {
      settlementNo: 'SET20260303014',
      verifyMethod: '活体检测+人脸比对',
      verifyResult: '通过',
      similarity: 98.5,
    },
    deviceInfo: {
      ip: '120.35.78.93',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '人脸验证通过，相似度98.5%',
  },
  {
    id: 'LOG029',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'document_view',
    operationGroup: 'document',
    timestamp: '2026-03-06T14:00:00+08:00',
    description: '查看了付款单 PAY20260308001',
    documentType: 'payment',
    documentId: 'PAY001',
    documentNo: 'PAY20260308001',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      paymentNo: 'PAY20260308001',
      amount: 31836.92,
      method: '银行转账',
      bankName: '中国建设银行杭州分行',
      transactionNo: 'TXN20260303010',
    },
    deviceInfo: {
      ip: '120.35.78.94',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '',
  },

  // ===== 赵六 (S1002) 的操作日志 =====
  {
    id: 'LOG030',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'user_register',
    operationGroup: 'registration',
    timestamp: '2025-05-10T10:30:00+08:00',
    description: '用户注册账号',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      registerMethod: '手机号注册',
      smsCode: '****',
    },
    deviceInfo: {
      ip: '58.34.102.45',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '',
  },
  {
    id: 'LOG031',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'id_card_upload',
    operationGroup: 'registration',
    timestamp: '2025-05-10T10:38:00+08:00',
    description: '上传身份证正反面照片',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'id_card_front',
    evidenceUrl: '/evidence/S1002/id_card_front.jpg',
    evidenceThumbnail: '/evidence/S1002/id_card_front_thumb.jpg',
    snapshot: {
      idCardNo: '331002199205055678',
      realName: '赵六',
      ocrResult: {
        name: '赵六',
        gender: '男',
        nation: '汉',
        birth: '1992-05-05',
        address: '浙江省杭州市西湖区xxx街道xxx号',
      },
    },
    deviceInfo: {
      ip: '58.34.102.45',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: 'OCR识别成功',
  },
  {
    id: 'LOG032',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'bank_card_upload',
    operationGroup: 'registration',
    timestamp: '2025-05-10T10:45:00+08:00',
    description: '上传银行卡照片并绑定',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'bank_card',
    evidenceUrl: '/evidence/S1002/bank_card.jpg',
    evidenceThumbnail: '/evidence/S1002/bank_card_thumb.jpg',
    snapshot: {
      bankName: '中国工商银行',
      bankAccount: '622202123456789012',
      bankBranch: '上海分行',
      cardType: '借记卡',
    },
    deviceInfo: {
      ip: '58.34.102.45',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '银行卡绑定成功',
  },
  {
    id: 'LOG033',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'auth_approved',
    operationGroup: 'registration',
    timestamp: '2025-05-10T11:20:00+08:00',
    description: '实名认证审核通过',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      auditor: '系统自动审核',
      auditResult: '通过',
      auditNote: '身份信息与银行卡信息一致',
    },
    deviceInfo: {
      ip: '10.0.0.1',
      device: 'Server',
      os: 'Linux',
      browser: 'System',
      location: '浙江省杭州市',
    },
    remark: '三要素验证通过',
  },
  {
    id: 'LOG034',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'order_create',
    operationGroup: 'order',
    timestamp: '2026-02-20T15:00:00+08:00',
    description: '创建订单 ORD20260220002',
    documentType: 'order',
    documentId: 'ORD002',
    documentNo: 'ORD20260220002',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260220002',
      materialName: '特级破碎料',
      baseName: '马钢诚兴上海分公司',
      estimatedWeight: 100,
      estimatedAmount: 260000,
      price: 2600,
    },
    deviceInfo: {
      ip: '58.34.102.46',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '',
  },
  {
    id: 'LOG035',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'order_agree_contract',
    operationGroup: 'order',
    timestamp: '2026-02-20T15:05:00+08:00',
    description: '勾选同意《采购协议》和《隐私协议》',
    documentType: 'order',
    documentId: 'ORD002',
    documentNo: 'ORD20260220002',
    evidenceType: 'contract',
    evidenceUrl: '/evidence/S1002/contract_ORD002.pdf',
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260220002',
      contracts: [
        { name: '废钢采购协议', version: 'v2.0', agreedAt: '2026-02-20T15:05:00+08:00' },
        { name: '用户隐私协议', version: 'v1.5', agreedAt: '2026-02-20T15:05:00+08:00' },
      ],
    },
    deviceInfo: {
      ip: '58.34.102.46',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '协议签署完成',
  },
  {
    id: 'LOG036',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'order_face_verify',
    operationGroup: 'order',
    timestamp: '2026-02-20T15:08:00+08:00',
    description: '订单提交前人脸识别验证',
    documentType: 'order',
    documentId: 'ORD002',
    documentNo: 'ORD20260220002',
    evidenceType: 'face_video',
    evidenceUrl: '/evidence/S1002/face_verify_ORD002.mp4',
    evidenceThumbnail: '/evidence/S1002/face_verify_ORD002.jpg',
    snapshot: {
      orderNo: 'ORD20260220002',
      verifyMethod: '活体检测+人脸比对',
      verifyResult: '通过',
      similarity: 96.9,
    },
    deviceInfo: {
      ip: '58.34.102.46',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '人脸验证通过，相似度96.9%',
  },
  {
    id: 'LOG037',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'order_submit',
    operationGroup: 'order',
    timestamp: '2026-02-20T15:10:00+08:00',
    description: '提交订单 ORD20260220002',
    documentType: 'order',
    documentId: 'ORD002',
    documentNo: 'ORD20260220002',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260220002',
      status: 'pending_sign',
    },
    deviceInfo: {
      ip: '58.34.102.46',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '订单提交成功',
  },
  {
    id: 'LOG038',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'document_view',
    operationGroup: 'document',
    timestamp: '2026-02-25T16:30:00+08:00',
    description: '查看了订单 ORD20260220002',
    documentType: 'order',
    documentId: 'ORD002',
    documentNo: 'ORD20260220002',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260220002',
      status: 'in_progress',
      deliveryCount: 3,
    },
    deviceInfo: {
      ip: '58.34.102.47',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '',
  },
  {
    id: 'LOG039',
    userId: 'S1002',
    userName: '赵六',
    userPhone: '13900139000',
    operationType: 'document_view',
    operationGroup: 'document',
    timestamp: '2026-02-26T10:15:00+08:00',
    description: '查看了送货单 DEL20260225002',
    documentType: 'delivery',
    documentId: 'DEL002',
    documentNo: 'DEL20260225002',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      deliveryNo: 'DEL20260225002',
      status: 'stored',
      actualWeight: 28.5,
    },
    deviceInfo: {
      ip: '58.34.102.48',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '',
  },

  // ===== 更多操作日志示例 =====
  {
    id: 'LOG040',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'order_create',
    operationGroup: 'order',
    timestamp: '2026-03-12T10:00:00+08:00',
    description: '创建订单 ORD20260312021',
    documentType: 'order',
    documentId: 'ORD021',
    documentNo: 'ORD20260312021',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260312021',
      materialName: '工业重废毛料',
      baseName: '马钢诚兴上海分公司',
      estimatedWeight: 60,
      estimatedAmount: 141660,
      price: 2361,
    },
    deviceInfo: {
      ip: '183.128.45.70',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '',
  },
  {
    id: 'LOG041',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'order_agree_contract',
    operationGroup: 'order',
    timestamp: '2026-03-12T10:05:00+08:00',
    description: '勾选同意《采购协议》和《隐私协议》',
    documentType: 'order',
    documentId: 'ORD021',
    documentNo: 'ORD20260312021',
    evidenceType: 'contract',
    evidenceUrl: '/evidence/S1001/contract_ORD021.pdf',
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260312021',
      contracts: [
        { name: '废钢采购协议', version: 'v2.0', agreedAt: '2026-03-12T10:05:00+08:00' },
        { name: '用户隐私协议', version: 'v1.5', agreedAt: '2026-03-12T10:05:00+08:00' },
      ],
    },
    deviceInfo: {
      ip: '183.128.45.70',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '协议签署完成',
  },
  {
    id: 'LOG042',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'order_face_verify',
    operationGroup: 'order',
    timestamp: '2026-03-12T10:08:00+08:00',
    description: '订单提交前人脸识别验证',
    documentType: 'order',
    documentId: 'ORD021',
    documentNo: 'ORD20260312021',
    evidenceType: 'face_video',
    evidenceUrl: '/evidence/S1001/face_verify_ORD021.mp4',
    evidenceThumbnail: '/evidence/S1001/face_verify_ORD021.jpg',
    snapshot: {
      orderNo: 'ORD20260312021',
      verifyMethod: '活体检测+人脸比对',
      verifyResult: '通过',
      similarity: 99.5,
    },
    deviceInfo: {
      ip: '183.128.45.70',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '人脸验证通过，相似度99.5%',
  },
  {
    id: 'LOG043',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'order_submit',
    operationGroup: 'order',
    timestamp: '2026-03-12T10:10:00+08:00',
    description: '提交订单 ORD20260312021',
    documentType: 'order',
    documentId: 'ORD021',
    documentNo: 'ORD20260312021',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      orderNo: 'ORD20260312021',
      status: 'pending_sign',
    },
    deviceInfo: {
      ip: '183.128.45.70',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '订单提交成功',
  },
  {
    id: 'LOG044',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'reservation_create',
    operationGroup: 'reservation',
    timestamp: '2026-03-12T11:00:00+08:00',
    description: '创建预约发货 DEL20260312024',
    documentType: 'delivery',
    documentId: 'DEL024',
    documentNo: 'DEL20260312024',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      deliveryNo: 'DEL20260312024',
      orderNo: 'ORD20260312021',
      reservationTime: '2026-03-12 13:00',
      vehicleNo: '苏B64337',
      driverName: '李师傅',
      driverPhone: '182****4323',
    },
    deviceInfo: {
      ip: '183.128.45.71',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '',
  },
  {
    id: 'LOG045',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'reservation_submit',
    operationGroup: 'reservation',
    timestamp: '2026-03-12T11:05:00+08:00',
    description: '提交预约发货 DEL20260312024',
    documentType: 'delivery',
    documentId: 'DEL024',
    documentNo: 'DEL20260312024',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      deliveryNo: 'DEL20260312024',
      status: 'waiting_delivery',
      reservationNo: 'RSV20260312024',
    },
    deviceInfo: {
      ip: '183.128.45.71',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '预约提交成功',
  },
  {
    id: 'LOG046',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'document_view',
    operationGroup: 'document',
    timestamp: '2026-03-08T15:30:00+08:00',
    description: '查看了入库单 SI20260308016',
    documentType: 'stockin',
    documentId: 'SI016',
    documentNo: 'SI20260308016',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      stockInNo: 'SI20260308016',
      deliveryNo: 'DEL20260308026',
      grossWeight: 22,
      tareWeight: 12,
      netWeight: 10,
      actualWeight: 9.26,
      quality: '二级',
    },
    deviceInfo: {
      ip: '120.35.78.95',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '',
  },
  {
    id: 'LOG047',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'document_view',
    operationGroup: 'document',
    timestamp: '2026-03-10T09:00:00+08:00',
    description: '查看了结算单 SET20260308018',
    documentType: 'settlement',
    documentId: 'SET018',
    documentNo: 'SET20260308018',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      settlementNo: 'SET20260308018',
      mergedCount: 3,
      totalAmount: 93280,
    },
    deviceInfo: {
      ip: '120.35.78.96',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '',
  },
  {
    id: 'LOG048',
    userId: 'S1005',
    userName: '吴九',
    userPhone: '13500135003',
    operationType: 'document_view',
    operationGroup: 'document',
    timestamp: '2026-03-10T11:00:00+08:00',
    description: '查看了发票单 INV20260308001',
    documentType: 'invoice',
    documentId: 'INV008',
    documentNo: 'INV20260308001',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    snapshot: {
      invoiceNo: 'INV20260308001',
      type: '反向开票',
      amount: 31448.77,
      mergedCount: 10,
    },
    deviceInfo: {
      ip: '120.35.78.97',
      device: 'HUAWEI Mate 60 Pro',
      os: 'HarmonyOS 4.0',
      browser: 'WeChat MiniProgram',
      location: '江苏省无锡市惠山区',
    },
    remark: '',
  },

  // ===== 帮别人卖模式 - 组织者李四 (S1002) 帮实供人张三 (S1013) 下单 =====
  {
    id: 'LOG049',
    userId: 'S1002',
    userName: '李四',
    userPhone: '13900139000',
    operationType: 'organizer_create_order',
    operationGroup: 'organizer',
    timestamp: '2026-03-08T09:30:00+08:00',
    description: '组织者创建帮别人卖订单 ORD20260308026',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      mode: 'other',
      materialName: '工业重废毛料',
      baseName: '马钢诚兴台州基地',
      estimatedWeight: 35,
      estimatedAmount: 85000,
      price: 2430,
    },
    deviceInfo: {
      ip: '58.34.102.50',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '帮别人卖模式',
  },
  {
    id: 'LOG050',
    userId: 'S1002',
    userName: '李四',
    userPhone: '13900139000',
    operationType: 'organizer_fill_supplier',
    operationGroup: 'organizer',
    timestamp: '2026-03-08T09:32:00+08:00',
    description: '填写实供人张三信息',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      supplierName: '张三',
      supplierPhone: '136****6013',
      selectedFromHistory: true,
    },
    deviceInfo: {
      ip: '58.34.102.50',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '从历史记录选择实供人',
  },
  {
    id: 'LOG051',
    userId: 'S1002',
    userName: '李四',
    userPhone: '13900139000',
    operationType: 'organizer_generate_qr',
    operationGroup: 'organizer',
    timestamp: '2026-03-08T09:35:00+08:00',
    description: '生成实供人确认二维码',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'qr_code',
    evidenceUrl: '/evidence/S1002/qrcode_ORD026.png',
    evidenceThumbnail: '/evidence/S1002/qrcode_ORD026_thumb.png',
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      qrCodeUrl: 'https://fgztc.com/confirm/ORD20260308026',
      qrExpireTime: '2099-12-31T23:59:59+08:00',
    },
    deviceInfo: {
      ip: '58.34.102.50',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '二维码长期有效',
  },
  {
    id: 'LOG052',
    userId: 'S1002',
    userName: '李四',
    userPhone: '13900139000',
    operationType: 'organizer_share_link',
    operationGroup: 'organizer',
    timestamp: '2026-03-08T09:36:00+08:00',
    description: '分享确认链接给实供人',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'screenshot',
    evidenceUrl: '/evidence/S1002/share_ORD026.png',
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      shareMethod: '微信',
      shareTime: '2026-03-08T09:36:00+08:00',
    },
    deviceInfo: {
      ip: '58.34.102.50',
      device: 'Xiaomi 14',
      os: 'Android 14',
      browser: 'WeChat MiniProgram',
      location: '上海市宝山区',
    },
    remark: '通过微信分享给实供人',
  },

  // ===== 实供人张三 (S1013) 扫码确认 =====
  {
    id: 'LOG053',
    userId: 'S1013',
    userName: '张三',
    userPhone: '13600136013',
    operationType: 'supplier_scan_qr',
    operationGroup: 'supplier',
    timestamp: '2026-03-08T10:15:00+08:00',
    description: '实供人扫描确认二维码',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'screenshot',
    evidenceUrl: '/evidence/S1013/scan_ORD026.png',
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      scanTime: '2026-03-08T10:15:00+08:00',
      scanFrom: '微信扫一扫',
      organizerName: '李四',
      materialName: '工业重废毛料',
      baseName: '马钢诚兴台州基地',
      estimatedWeight: 35,
    },
    deviceInfo: {
      ip: '112.80.248.75',
      device: 'OPPO Find X6',
      os: 'Android 13',
      browser: 'WeChat MiniProgram',
      location: '浙江省杭州市西湖区',
    },
    remark: '通过微信扫一扫进入',
  },
  {
    id: 'LOG054',
    userId: 'S1013',
    userName: '张三',
    userPhone: '13600136013',
    operationType: 'supplier_verify_phone',
    operationGroup: 'supplier',
    timestamp: '2026-03-08T10:18:00+08:00',
    description: '实供人验证手机号后四位',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      verifyMethod: '手机号后四位',
      verifyResult: '通过',
      phoneLastFour: '6013',
    },
    deviceInfo: {
      ip: '112.80.248.75',
      device: 'OPPO Find X6',
      os: 'Android 13',
      browser: 'WeChat MiniProgram',
      location: '浙江省杭州市西湖区',
    },
    remark: '身份验证通过',
  },
  {
    id: 'LOG055',
    userId: 'S1013',
    userName: '张三',
    userPhone: '13600136013',
    operationType: 'supplier_select_bank',
    operationGroup: 'supplier',
    timestamp: '2026-03-08T10:22:00+08:00',
    description: '实供人选择收款银行卡',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      selectedBank: '中国工商银行',
      selectedAccount: '6222****9012',
      bankBranch: '杭州分行',
    },
    deviceInfo: {
      ip: '112.80.248.75',
      device: 'OPPO Find X6',
      os: 'Android 13',
      browser: 'WeChat MiniProgram',
      location: '浙江省杭州市西湖区',
    },
    remark: '',
  },
  {
    id: 'LOG056',
    userId: 'S1013',
    userName: '张三',
    userPhone: '13600136013',
    operationType: 'supplier_agree_contract',
    operationGroup: 'supplier',
    timestamp: '2026-03-08T10:25:00+08:00',
    description: '实供人同意《废钢采购合同》和《平台服务协议》',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'contract',
    evidenceUrl: '/evidence/S1013/contract_ORD026.pdf',
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      contracts: [
        { name: '废钢采购合同', version: 'v2.0', agreedAt: '2026-03-08T10:25:00+08:00' },
        { name: '平台服务协议', version: 'v1.5', agreedAt: '2026-03-08T10:25:00+08:00' },
        { name: '反向开票政策告知书', version: 'v1.0', agreedAt: '2026-03-08T10:25:00+08:00' },
      ],
    },
    deviceInfo: {
      ip: '112.80.248.75',
      device: 'OPPO Find X6',
      os: 'Android 13',
      browser: 'WeChat MiniProgram',
      location: '浙江省杭州市西湖区',
    },
    remark: '协议签署完成',
  },
  {
    id: 'LOG057',
    userId: 'S1013',
    userName: '张三',
    userPhone: '13600136013',
    operationType: 'supplier_face_verify',
    operationGroup: 'supplier',
    timestamp: '2026-03-08T10:28:00+08:00',
    description: '实供人人脸识别验证',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'face_video',
    evidenceUrl: '/evidence/S1013/face_verify_ORD026.mp4',
    evidenceThumbnail: '/evidence/S1013/face_verify_ORD026.jpg',
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      verifyMethod: '活体检测+人脸比对',
      verifyResult: '通过',
      similarity: 97.3,
    },
    deviceInfo: {
      ip: '112.80.248.75',
      device: 'OPPO Find X6',
      os: 'Android 13',
      browser: 'WeChat MiniProgram',
      location: '浙江省杭州市西湖区',
    },
    remark: '人脸验证通过，相似度97.3%',
  },
  {
    id: 'LOG058',
    userId: 'S1013',
    userName: '张三',
    userPhone: '13600136013',
    operationType: 'supplier_confirm_order',
    operationGroup: 'supplier',
    timestamp: '2026-03-08T10:30:00+08:00',
    description: '实供人确认订单，订单状态变更为"进行中"',
    documentType: 'order',
    documentId: 'ORD026',
    documentNo: 'ORD20260308026',
    evidenceType: 'screenshot',
    evidenceUrl: '/evidence/S1013/confirm_ORD026.png',
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1002',
    organizerName: '李四',
    supplierId: 'S1013',
    supplierName: '张三',
    supplierPhone: '13600136013',
    snapshot: {
      orderNo: 'ORD20260308026',
      status: 'in_progress',
      confirmedAt: '2026-03-08T10:30:00+08:00',
      organizerName: '李四',
      materialName: '工业重废毛料',
      baseName: '马钢诚兴台州基地',
      estimatedWeight: 35,
      estimatedAmount: 85050,
    },
    deviceInfo: {
      ip: '112.80.248.75',
      device: 'OPPO Find X6',
      os: 'Android 13',
      browser: 'WeChat MiniProgram',
      location: '浙江省杭州市西湖区',
    },
    remark: '订单确认成功，开始送货流程',
  },

  // ===== 另一个帮别人卖案例 - 组织者王五 (S1001) 帮实供人李四 (S1014) 下单 =====
  {
    id: 'LOG059',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'organizer_create_order',
    operationGroup: 'organizer',
    timestamp: '2026-03-10T14:00:00+08:00',
    description: '组织者创建帮别人卖订单 ORD20260310027',
    documentType: 'order',
    documentId: 'ORD027',
    documentNo: 'ORD20260310027',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      orderNo: 'ORD20260310027',
      mode: 'other',
      materialName: '特级破碎料',
      baseName: '马钢诚兴上海分公司',
      estimatedWeight: 45,
      estimatedAmount: 117000,
      price: 2600,
    },
    deviceInfo: {
      ip: '183.128.45.72',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '帮别人卖模式',
  },
  {
    id: 'LOG060',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'organizer_fill_supplier',
    operationGroup: 'organizer',
    timestamp: '2026-03-10T14:03:00+08:00',
    description: '填写实供人李四信息（手动输入）',
    documentType: 'order',
    documentId: 'ORD027',
    documentNo: 'ORD20260310027',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      orderNo: 'ORD20260310027',
      supplierName: '李四',
      supplierPhone: '135****5014',
      selectedFromHistory: false,
    },
    deviceInfo: {
      ip: '183.128.45.72',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '手动输入实供人信息',
  },
  {
    id: 'LOG061',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'organizer_generate_qr',
    operationGroup: 'organizer',
    timestamp: '2026-03-10T14:05:00+08:00',
    description: '生成实供人确认二维码',
    documentType: 'order',
    documentId: 'ORD027',
    documentNo: 'ORD20260310027',
    evidenceType: 'qr_code',
    evidenceUrl: '/evidence/S1001/qrcode_ORD027.png',
    evidenceThumbnail: '/evidence/S1001/qrcode_ORD027_thumb.png',
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      orderNo: 'ORD20260310027',
      qrCodeUrl: 'https://fgztc.com/confirm/ORD20260310027',
      qrExpireTime: '2099-12-31T23:59:59+08:00',
    },
    deviceInfo: {
      ip: '183.128.45.72',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '二维码长期有效',
  },
  {
    id: 'LOG062',
    userId: 'S1001',
    userName: '王五',
    userPhone: '13800138000',
    operationType: 'organizer_share_link',
    operationGroup: 'organizer',
    timestamp: '2026-03-10T14:06:00+08:00',
    description: '分享确认链接给实供人',
    documentType: 'order',
    documentId: 'ORD027',
    documentNo: 'ORD20260310027',
    evidenceType: 'screenshot',
    evidenceUrl: '/evidence/S1001/share_ORD027.png',
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      orderNo: 'ORD20260310027',
      shareMethod: '复制链接',
      shareTime: '2026-03-10T14:06:00+08:00',
    },
    deviceInfo: {
      ip: '183.128.45.72',
      device: 'iPhone 15 Pro',
      os: 'iOS 17.3',
      browser: 'WeChat MiniProgram',
      location: '浙江省台州市路桥区',
    },
    remark: '通过复制链接分享',
  },
  {
    id: 'LOG063',
    userId: 'S1014',
    userName: '李四',
    userPhone: '13500135014',
    operationType: 'supplier_scan_qr',
    operationGroup: 'supplier',
    timestamp: '2026-03-10T15:30:00+08:00',
    description: '实供人扫描确认二维码',
    documentType: 'order',
    documentId: 'ORD027',
    documentNo: 'ORD20260310027',
    evidenceType: 'screenshot',
    evidenceUrl: '/evidence/S1014/scan_ORD027.png',
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      orderNo: 'ORD20260310027',
      scanTime: '2026-03-10T15:30:00+08:00',
      scanFrom: '浏览器',
      organizerName: '王五',
      materialName: '特级破碎料',
      baseName: '马钢诚兴上海分公司',
      estimatedWeight: 45,
    },
    deviceInfo: {
      ip: '61.130.45.88',
      device: 'vivo X90',
      os: 'Android 13',
      browser: 'Chrome',
      location: '浙江省宁波市鄞州区',
    },
    remark: '通过浏览器扫码进入',
  },
  {
    id: 'LOG064',
    userId: 'S1014',
    userName: '李四',
    userPhone: '13500135014',
    operationType: 'supplier_verify_phone',
    operationGroup: 'supplier',
    timestamp: '2026-03-10T15:33:00+08:00',
    description: '实供人验证手机号后四位',
    documentType: 'order',
    documentId: 'ORD027',
    documentNo: 'ORD20260310027',
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      orderNo: 'ORD20260310027',
      verifyMethod: '手机号后四位',
      verifyResult: '通过',
      phoneLastFour: '5014',
    },
    deviceInfo: {
      ip: '61.130.45.88',
      device: 'vivo X90',
      os: 'Android 13',
      browser: 'Chrome',
      location: '浙江省宁波市鄞州区',
    },
    remark: '身份验证通过',
  },
  {
    id: 'LOG065',
    userId: 'S1014',
    userName: '李四',
    userPhone: '13500135014',
    operationType: 'id_card_upload',
    operationGroup: 'registration',
    timestamp: '2026-03-10T15:40:00+08:00',
    description: '实供人首次上传身份证（未实名认证）',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'id_card_front',
    evidenceUrl: '/evidence/S1014/id_card_front.jpg',
    evidenceThumbnail: '/evidence/S1014/id_card_front_thumb.jpg',
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      idCardNo: '330102199008082345',
      realName: '李四',
      ocrResult: {
        name: '李四',
        gender: '男',
        nation: '汉',
        birth: '1990-08-08',
        address: '浙江省宁波市鄞州区xxx街道xxx号',
      },
    },
    deviceInfo: {
      ip: '61.130.45.88',
      device: 'vivo X90',
      os: 'Android 13',
      browser: 'Chrome',
      location: '浙江省宁波市鄞州区',
    },
    remark: 'OCR识别成功，首次实名认证',
  },
  {
    id: 'LOG066',
    userId: 'S1014',
    userName: '李四',
    userPhone: '13500135014',
    operationType: 'supplier_face_verify',
    operationGroup: 'supplier',
    timestamp: '2026-03-10T15:45:00+08:00',
    description: '实供人人脸识别验证（实名认证）',
    documentType: 'order',
    documentId: 'ORD027',
    documentNo: 'ORD20260310027',
    evidenceType: 'face_video',
    evidenceUrl: '/evidence/S1014/face_verify_ORD027.mp4',
    evidenceThumbnail: '/evidence/S1014/face_verify_ORD027.jpg',
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      orderNo: 'ORD20260310027',
      verifyMethod: '活体检测+人脸比对',
      verifyResult: '通过',
      similarity: 98.1,
      authType: '实名认证',
    },
    deviceInfo: {
      ip: '61.130.45.88',
      device: 'vivo X90',
      os: 'Android 13',
      browser: 'Chrome',
      location: '浙江省宁波市鄞州区',
    },
    remark: '人脸验证通过，相似度98.1%，实名认证完成',
  },
  {
    id: 'LOG067',
    userId: 'S1014',
    userName: '李四',
    userPhone: '13500135014',
    operationType: 'bank_card_upload',
    operationGroup: 'registration',
    timestamp: '2026-03-10T15:50:00+08:00',
    description: '实供人首次绑定银行卡',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'bank_card',
    evidenceUrl: '/evidence/S1014/bank_card.jpg',
    evidenceThumbnail: '/evidence/S1014/bank_card_thumb.jpg',
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      bankName: '中国农业银行',
      bankAccount: '622848003812345678',
      bankBranch: '宁波分行',
      cardType: '借记卡',
    },
    deviceInfo: {
      ip: '61.130.45.88',
      device: 'vivo X90',
      os: 'Android 13',
      browser: 'Chrome',
      location: '浙江省宁波市鄞州区',
    },
    remark: '银行卡绑定成功',
  },
  {
    id: 'LOG068',
    userId: 'S1014',
    userName: '李四',
    userPhone: '13500135014',
    operationType: 'supplier_agree_contract',
    operationGroup: 'supplier',
    timestamp: '2026-03-10T15:55:00+08:00',
    description: '实供人同意《废钢采购合同》和《平台服务协议》',
    documentType: 'order',
    documentId: 'ORD027',
    documentNo: 'ORD20260310027',
    evidenceType: 'contract',
    evidenceUrl: '/evidence/S1014/contract_ORD027.pdf',
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      orderNo: 'ORD20260310027',
      contracts: [
        { name: '废钢采购合同', version: 'v2.0', agreedAt: '2026-03-10T15:55:00+08:00' },
        { name: '平台服务协议', version: 'v1.5', agreedAt: '2026-03-10T15:55:00+08:00' },
        { name: '反向开票政策告知书', version: 'v1.0', agreedAt: '2026-03-10T15:55:00+08:00' },
      ],
    },
    deviceInfo: {
      ip: '61.130.45.88',
      device: 'vivo X90',
      os: 'Android 13',
      browser: 'Chrome',
      location: '浙江省宁波市鄞州区',
    },
    remark: '协议签署完成',
  },
  {
    id: 'LOG069',
    userId: 'S1014',
    userName: '李四',
    userPhone: '13500135014',
    operationType: 'supplier_confirm_order',
    operationGroup: 'supplier',
    timestamp: '2026-03-10T16:00:00+08:00',
    description: '实供人确认订单，订单状态变更为"进行中"',
    documentType: 'order',
    documentId: 'ORD027',
    documentNo: 'ORD20260310027',
    evidenceType: 'screenshot',
    evidenceUrl: '/evidence/S1014/confirm_ORD027.png',
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      orderNo: 'ORD20260310027',
      status: 'in_progress',
      confirmedAt: '2026-03-10T16:00:00+08:00',
      organizerName: '王五',
      materialName: '特级破碎料',
      baseName: '马钢诚兴上海分公司',
      estimatedWeight: 45,
      estimatedAmount: 117000,
    },
    deviceInfo: {
      ip: '61.130.45.88',
      device: 'vivo X90',
      os: 'Android 13',
      browser: 'Chrome',
      location: '浙江省宁波市鄞州区',
    },
    remark: '订单确认成功，首次交易用户',
  },
  {
    id: 'LOG070',
    userId: 'S1014',
    userName: '李四',
    userPhone: '13500135014',
    operationType: 'auth_approved',
    operationGroup: 'registration',
    timestamp: '2026-03-10T16:02:00+08:00',
    description: '实名认证审核通过',
    documentType: null,
    documentId: null,
    documentNo: null,
    evidenceType: 'none',
    evidenceUrl: null,
    evidenceThumbnail: null,
    isOrganizerMode: true,
    organizerId: 'S1001',
    organizerName: '王五',
    supplierId: 'S1014',
    supplierName: '李四',
    supplierPhone: '13500135014',
    snapshot: {
      auditor: '系统自动审核',
      auditResult: '通过',
      auditNote: '身份信息与银行卡信息一致',
    },
    deviceInfo: {
      ip: '10.0.0.1',
      device: 'Server',
      os: 'Linux',
      browser: 'System',
      location: '浙江省杭州市',
    },
    remark: '三要素验证通过，实名认证完成',
  },
];
